{
  "LEARN_MORE": "Learn More",
  "ADVANCED_OPTIONS": "Advanced Options",
  "STAFF_ONLY_OPTIONS": "Staff Only Options",
  "ITEMS_PER_PAGE": "Items per page",
  "PAGE_OF": "{{start}} - {{end}} of {{total}}",
  "SAVE": "Save",
  "YES": "Yes",
  "DATE": "Date",
  "TIME": "Time",
  "NO": "No",
  "OK": "OK",
  "UPDATE": "Update",
  "DELETE": "Delete",
  "NEW": "New",
  "DONE": "Done",
  "SKIP": "Skip",
  "SUBMIT": "Submit",
  "COMPLETE": "Complete",
  "ORDER": "Order",
  "OPTION": "Option",
  "REDRAW": "Redraw",
  "ADD_OPTION": "Add Option",
  "DRAW": "Draw",
  "OR": "or",
  "EDIT": "Edit",
  "NEXT": "Next",
  "PREVIOUS": "Previous",
  "CONFIRM": "Confirm",
  "CLOSE": "Close",
  "NONE": "None",
  "CANCEL": "Cancel",
  "RESET": "Reset",
  "APPLY": "Apply",
  "BACK": "Back",
  "UNLINK": "Unlink",
  "DOWNLOAD": "Download",
  "SEARCH": "Search",
  "CLEAR_SEARCH_HISTORY": "Clear Search History",
  "CLEAR": "Clear",
  "NAME": "Name",
  "ACTIONS": "Actions",
  "CREATE": "Create",
  "LABEL": "Label",
  "VISIBILITY": "Visibility",
  "VISIBLE": "Visible",
  "HIDDEN": "Hidden",
  "OPEN": "Open",
  "RESEND": "Resend",
  "VERIFY": "Verify",
  "LAUNCH": "Launch",
  "MESSAGE": "Message",
  "VIEW": "View",
  "ADD": "Add",
  "SHOW": "Show",
  "HIDE": "Hide",
  "SELECT": "Select",
  "SEND": "Send",
  "ICON": "Icon",
  "N/A": "N/A",
  "REFUND": "Refund",
  "REFUNDED": "Refunded",
  "SELECT_IMAGE": "Select Image",
  "SELECT_IMAGES": "Select Images",
  "MAX_HEIGHT": "Max Height",
  "MAX_WIDTH": "Max Width",
  "MAX_SIZE": "Max Size",
  "MAX_IMAGES": "Max Images",
  "MORE_OPTIONS": "More Options",
  "REORDER": "Reorder",
  "PX": "px",
  "MB": "MB",
  "TBC": "TBC",
  "UNLIMITED": "Unlimited",
  "PHONE_INPUT_LABEL": "Phone Number",
  "REFRESH": "Refresh",
  "CONTENT_UPDATED": "The content on this page has been updated. Refresh?",
  "CONTENT_DELETED": "The content on this page has been deleted. Go Back?",
  "CONTENT_REFRESH": "The content on this page has changed and will be refreshed",
  "RECAPTCHA_ERROR_MESSAGE": "Please complete the reCAPTCHA",
  "UNPAID_INVOICE": "{{unpaid_count}} Unpaid Invoice",
  "UNPAID_INVOICES": "{{unpaid_count}} Unpaid Invoices",
  "INVOICES_PAID": "All Invoices Paid",
  "NOTE": "Note:",
  "AUCTION_HIDDEN_INFO": "This campaign was hidden on {{hide_date}} and will be deleted on {{delete_date}}. To restore it, change the status in ",
  "AUCTION_HIDDEN_INFO_LINK": "Auction Controls",
  "LEAVE_FEEDBACK": "Leave feedback",
  "SHOW_HIDE_COLUMNS": "Show/Hide Columns",
  "SAAS": "SaaS",
  "NON_SAAS": "Non-SaaS",
  "STRIPE": "Stripe",
  "TAX": "Tax",
  "GENERIC_ERROR": "An error occurred",
  "QR_CODE": {
    "DOWNLOAD": "Download QR code"
  },
  "PADDLE_NUMBERS": {
    "STATUS": {
      "PROFILE_UNVERIFIED": "Unverified",
      "SUCCESS": "Successful",
      "UNASSIGNED": "Unassigned"
    },
    "GIVING_LEVELS": {
      "BACK": "All giving levels",
      "ADD": "Add Giving Level",
      "EDIT_DIALOG": {
        "TITLE": "Edit Giving Level",
        "NAME": "Name",
        "DESCRIPTION": "Description",
        "VALUE": "Value"
      },
      "CREATE_DIALOG": {
        "TITLE": "Add Giving Level"
      },
      "DELETE_DIALOG": {
        "TITLE": "Delete Giving Level",
        "BODY": "Are you sure you would like to delete this giving level? This can't be undone."
      }
    },
    "PADDLE_RAISE": {
      "TABLE": "Table",
      "SEARCH_PLEDGES": "Search Pledges",
      "PARTICIPANT_NAME": "Participant Name",
      "CONTACT": "Contact",
      "GIVING_LEVEL": "Giving Level",
      "STATUS": "Status",
      "PADDLE_NUMBER": "Paddle Number",
      "PAYMENT_METHOD_CONNECTED": "Payment Method"
    }
  },
  "SETUP_GUIDE": {
    "TITLE": "Setup Guide",
    "SUBTITLE": "Use this guide to get your campaign up and running",
    "PROGRESS_TEXT": "{{completedTasks}} of {{totalTasks}} tasks completed",
    "PROGRESS_BAR": "",
    "AI_SECTION_TITLE": "Setup with AI",
    "AI_PROMPT_PLACEHOLDER_ITEM_FORM": "Add a brief description of the item and I will get started on the form",
    "AI_PROMPT_PLACEHOLDER_GENERIC": "Describe what you need and I will get started",
    "AI_PROMPT_PLACEHOLDER_BRANDING_FORM": "Describe what you want",
    "GENERATE_WITH_AI": "Generate with AI",
    "AI_CHAT": {
      "SEARCH_PLACEHOLDER": "Search chat history",
      "LOAD_SESSION": "Load a session",
      "NEW_SESSION": "New chat",
      "HISTORY": "Chat history",
      "NEW_CHAT": "New chat",
      "NO_SESSION_TITLE": "New chat",
      "GENERATE": "Generate",
      "ASK_BUTTON": "Get Answer",
      "ASK_BUTTON_SHORT": "Send",
      "AVAILABLE_TOOLS": "Available tools in Act mode",
      "SELECTED_TOOL": "Selected tool",
      "EMPTY_STATE": "Start a conversation with the AI assistant.",
      "DISCLAIMER": "AI can make mistakes. This assistant is experimental — contact ",
      "DISCLAIMER_SUPPORT_LINK": "GalaBid Support",
      "DISCLAIMER_SUFFIX": " to talk to a real person.",
      "ASK_PROMPT_PLACEHOLDER": "Ask anything about GalaBid",
      "MODE_ASK": "Ask",
      "MODE_ACT": "Act",
      "MODE_ASK_HINT": "Get answers about using GalaBid.",
      "MODE_ACT_HINT": "Generate assets for your campaign.",
      "MODE_ACT_DISABLED_HINT": "Unavailable in this page.",
      "MODE_HELP": "Ask reads only, Act can apply changes.",
      "DISABLED_HINT_BUSY": "AI is generating a response. Please wait a moment.",
      "DISABLED_HINT_IMAGE_GENERATED": "Input is locked after image generation. Start a new chat to continue.",
      "DISABLED_HINT_ACTIVE_CONVERSATION": "Mode cannot be changed during a conversation. Start a new chat to switch modes.",
      "USE_TOOL_PREFIX": "Use tool - {{tool}}:",
      "APPLY": "Apply",
      "APPLIED": "Applied",
      "EDIT": "Edit",
      "SAVE_AND_REGENERATE": "Save & Regenerate",
      "CANCEL": "Cancel",
      "READ_MORE": "Read more",
      "MESSAGE_TYPE": {
        "USER": "You",
        "ASSISTANT": "Assistant",
        "TOOL_CALL": "Tool Call",
        "TOOL_RESULT": "Tool Result",
        "ERROR": "Error"
      },
      "TOOL": {
        "DEFAULT": {
          "GENERATING": "Generating tool result",
          "RESULT": "Tool result"
        },
        "GENERATE_BRANDING_COLORS": {
          "LABEL": "Branding Colors",
          "GENERATING": "Generating branding colors",
          "RESULT": "Branding colors generated"
        },
        "GENERATE_CUSTOM_CSS": {
          "LABEL": "Custom CSS",
          "GENERATING": "Generating custom CSS",
          "RESULT": "Custom CSS generated"
        },
        "SEARCH_ARTICLES": {
          "LABEL": "Search Articles",
          "GENERATING": "Searching support articles",
          "RESULT": "Found relevant support articles"
        },
        "GET_ARTICLE_CONTENT": {
          "LABEL": "Article Content",
          "GENERATING": "Retrieving article content",
          "RESULT": "Article content retrieved"
        },
        "GENERATE_LOGO": {
          "LABEL": "Logo",
          "GENERATING": "Generating logo (Est. 30s - 60s)",
          "RESULT": "Logo generated"
        },
        "GENERATE_BANNER": {
          "LABEL": "Banner",
          "GENERATING": "Generating banner (Est. 30s - 60s)",
          "RESULT": "Banner generated"
        }
      }
    },
    "NEED_MORE_HELP": "Need more help?",
    "CHECK_OUT_HELP_SECTION": "Check Help Center",
    "HIDE_SETUP_GUIDE": "Hide Setup Guide",
    "DISMISS_SETUP_GUIDE": "Dismiss Setup Guide",
    "TABS": {
      "SETUP": "Setup",
      "AI_ASSISTANT": "AI Assistant",
      "BETA": "Beta"
    },
    "STEPS": {
      "TELL_US_ABOUT_YOUR_CAMPAIGN": {
        "TITLE": "Tell us about your campaign",
        "DESCRIPTION": "Add your event details to personalise your campaign",
        "PRIMARY_BUTTON": "Go to Campaign Details"
      },
      "SETUP_BRANDING": {
        "TITLE": "Set up branding",
        "DESCRIPTION": "Add a logo, a banner and update colours for your campaign",
        "PRIMARY_BUTTON": "Go to Branding Settings"
      },
      "ADD_ITEM": {
        "TITLE": "Add your first item",
        "DESCRIPTION": "Add an item for participants to bid, purchase or donate",
        "PRIMARY_BUTTON": "Add Item",
        "SECONDARY_BUTTON": "Browse Extra Profit Items"
      },
      "COLLECT_EXTRA_DETAILS": {
        "TITLE": "Collect extra details",
        "DESCRIPTION": "Add custom questions to collect extra details from your guests",
        "PRIMARY_BUTTON": "Go to Registration Settings"
      },
      "CONNECT_STRIPE": {
        "TITLE": "Payment Setup",
        "DESCRIPTION": "Connect your Stripe account to be able process payments for your participants",
        "PRIMARY_BUTTON": "Go to Payment Settings"
      }
    },
    "SUBSTEPS": {
      "CHECK_CAMPAIGN_NAME": {
        "TITLE": "Check your campaign name"
      },
      "ADD_EVENT_DATE_TIME": {
        "TITLE": "Add your event date and time"
      },
      "SET_EVENT_LOCATION": {
        "TITLE": "Set your event location"
      },
      "ADD_BANNER": {
        "TITLE": "Add a banner image"
      },
      "ADD_LOGO": {
        "TITLE": "Add a logo"
      },
      "SET_CAMPAIGN_COLORS": {
        "TITLE": "Set campaign colours"
      },
      "ADD_ITEM_NAME_DESCRIPTION": {
        "TITLE": "Add item name"
      },
      "CHOOSE_ITEM_TYPE": {
        "TITLE": "Choose the item type"
      },
      "ADD_PRICING": {
        "TITLE": "Add pricing"
      },
      "ADD_ITEM_IMAGE": {
        "TITLE": "Add an item image"
      },
      "REVIEW_TNC": {
        "TITLE": "Review terms and conditions"
      },
      "CONNECT_STRIPE": {
        "TITLE": "Connect Stripe"
      },
      "PASS_ON_FEES": {
        "TITLE": "Passing on fees"
      }
    },
    "CONFIRM_CLOSE": {
      "TITLE": "Are you sure you want to close the setup guide?",
      "BODY": "This will close the setup guide and if you want to continue with the guide again, you can open it from the side menu."
    },
    "COMPLETE_DIALOG": {
      "TITLE": "Setup Complete",
      "BODY": "Congratulations! You've completed setting up your campaign. When you're ready, share it with guests using the link or QR code below.",
      "LINK_COPIED": "Campaign URL Copied to Clipboard"
    }
  },
  "FEEDBACK": {
    "TITLE": "Leave feedback",
    "HOW_CAN_WE_IMPROVE": "How can we improve GalaBid?",
    "DESC": "Thank you for taking the time to share your feedback. Your insights help us improve the dashboard and create a better experience for everyone.",
    "CONFIRM": "Your feedback has been submitted"
  },
  "UNSAVED_CHANGES_DIALOG": {
    "TITLE": "You have unsaved changes on this page",
    "BODY": "Are you sure you would like to leave before saving your changes?",
    "BUTTON_LEAVE": "Leave",
    "BUTTON_STAY": "Stay"
  },
  "FILE_UPLOAD_DIALOG": {
    "RESELECT_FILE": "Reselect File",
    "DOWNLOAD_TEXT": "Download spreadsheet template",
    "DOWNLOAD_TEMPLATE_SUCCESS": "Template downloaded successfully",
    "ITEMS": {
      "UPLOADER_TEXT": "Drag and drop items spreadsheet here",
      "BUTTON_TEXT": "Choose items spreadsheet file",
      "SUCCESS": "Items uploaded successfully",
      "ERROR_HEADER": "Error uploading items, please see suggestions below",
      "RECORD_AT_ROW": "Item at row {{row}}"
    },
    "USERS": {
      "UPLOADER_TEXT": "Drag and drop participants spreadsheet here",
      "BUTTON_TEXT": "Choose participants spreadsheet file",
      "SUCCESS": "{{count}} Participants invited successfully",
      "ERROR_HEADER": "Error uploading participants, please see suggestions below",
      "RECORD_AT_ROW": "Participant at row {{row}}"
    }
  },
  "GENERIC": {
    "ERROR": "An Error Occurred",
    "APPLY": "Apply",
    "CANCEL": "Cancel",
    "EMPTY": "No Items Found"
  },
  "SEARCH_EMPTY_STATE": {
    "TITLE": "Oops, no results!",
    "SUBTITLE": "We couldn't find anything matching your search"
  },
  "VERIFY_EMAIL": {
    "NO_TOKEN": "No token provided",
    "GO_TO_DASHBOARD": "Go to Dashboard",
    "VERIFY_SUCCESS_HEADER": "Email Verified",
    "VERIFY_SUCCESS": "Thank you for confirming your email. You're all set to continue!",
    "VERIFY_SUCCESS_TOAST": "Verify Successful",
    "VERIFY_ERROR_HEADER": "We couldn't verify your email address",
    "VERIFY_ERROR": "The verification link may be invalid or expired. Please request a new verification email, or contact support if the issue persists."
  },
  "REGISTER": {
    "HEADER": "Sign up for free",
    "STEPPER": {
      "ACCOUNT": "Account",
      "FUNDRAISER": "Fundraiser",
      "LAST_STEP": "Last Step"
    },
    "CONGRATULATIONS": "Congratulations!",
    "ACCOUNT_CREATED": "Your account has been created successfully. An email has been sent to verify your account.",
    "REGISTRATION_SUBMITTED": "Registration Submitted",
    "OFFLINE_ONBOARDING": "A member of our team will be in touch shortly to discuss your campaign and help you get started.",
    "CREATE": "Create Campaign",
    "SSO": {
      "FACEBOOK": "Sign up with Facebook",
      "GOOGLE": "Sign up with Google",
      "MICROSOFT": "Sign up with Microsoft",
      "APPLE": "Sign up with Apple"
    },
    "FOOTER": "By signing up, you agree with our",
    "NO_FIREARMS": "Kindly note that the sale of firearms is not permitted on GalaBid.",
    "HAVE_ACCOUNT": "Already have an account?",
    "LOGIN": "Login",
    "TANDC": "Terms and Conditions",
    "HEADLINE_1": "It takes less than a minute",
    "HEADLINE_2": "to start fundraising with GalaBid.",
    "POINTS": {
      "1": "Packed with 100+ features",
      "2": "An extensive range of sale or return auction items - profits guaranteed",
      "3": "Online support team and how to guides",
      "4": "Trusted by grassroots and global causes since 2011"
    },
    "FORM": {
      "FIRST_NAME": "First Name",
      "LAST_NAME": "Last Name",
      "EMAIL": "Email",
      "PASSWORD": "Password",
      "REFERRAL": "Where did you hear about us?",
      "EXCLUDE_MY_CAMPAIGN": "Exclude my campaigns",
      "SHOWCASE_INFO": "We sometimes select campaigns to showcase on our website.",
      "REFERRAL_OPTIONS": {
        "PAID_AD": "Google Paid Ad",
        "MARKETING_SUMMIT": "Nonprofit Marketing Summit",
        "ORGANIC_LISTING": "Google Organic Listing",
        "OTHER_SEARCH": "Other Search Engine",
        "LINKEDIN": "LinkedIn",
        "X": "X",
        "FACEBOOK": "Facebook",
        "INSTAGRAM": "Instagram",
        "OTHER_SOCIAL_MEDIA": "Other Social Media",
        "REFERRAL": "Referral",
        "REVIEW": "Capterra / Trustpilot",
        "PREVIOUS": "I'm a previous participant",
        "OTHER": "Other",
        "MARKETING_EMAIL": "Marketing Email",
        "AFP": "AFP",
        "CHAT_GPT": "ChatGPT",
        "GROK": "Grok",
        "CLAUD": "Claude",
        "GEMINI": "Gemini",
        "OTHER_AI": "Other AI Platform"
      }
    }
  },
  "SUMMARY": {
    "IOC": {
      "TITLE": "Extra Profit Items",
      "PROFIT": "Profit",
      "COST": "Cost"
    },
    "TOTAL_RAISED": {
      "TITLE": "Total Raised",
      "STRIPE_FEE_MESSAGE": "Excludes Stripe fees",
      "TARGET": "Target: {{target}}",
      "IOC_PROFIT": "Extra Profit Items - Profit",
      "IOC_COST": "Extra Profit Items - Costs",
      "EVENT_TICKETS": "Event Tickets",
      "TOTAL": "Total",
      "TIP_REVENUE_SHARE": "Tip Revenue Share",
      "BASE_TOTAL_RAISED": "Base Total Raised",
      "PADDLE_RAISE": "Paddle Raise"
    },
    "PARTICIPANT_ACTIVITY": {
      "TITLE": "Participant Activity",
      "REGISTERED": "Registered",
      "ACTIVE_REGISTERED": "Active Registered"
    },
    "BIDDING_ACTIVITY": {
      "TITLE": "Bidding Activity",
      "BIDS_PLACED": "Bids Placed",
      "MOST_BIDS": "Most Bids on an Item"
    },
    "PAYMENT": {
      "PAID": "Paid",
      "UNPAID": "Unpaid",
      "NOTE": "Includes any campaign added fees & taxes and items on consignment costs. Excludes Stripe fees.",
      "NOTE_TIPPING": "Includes any campaign added fees & taxes, GalaBid Tips and items on consignment costs. Excludes Stripe fees."
    },
    "PAYMENT_SUMMARY": {
      "TITLE": "Payment Summary"
    },
    "PARTICIPANT_SUMMARY": {
      "TITLE": "Participant Payment Summary"
    },
    "AUCTION": {
      "TITLE": "Auction Items",
      "TOTAL": "Bid Total",
      "QUANTITY": "Bid Quantity",
      "HAS_BIDS": "Has Bids",
      "NO_BIDS": "No Bids",
      "NOT_SELLING": "Items Not Selling",
      "MOST_BIDS": "Most Amount Of Bids",
      "BIDDING_PURCHASE_COUNT": "Buy Now Quantity"
    },
    "INACTIVE_BIDDING_ITEMS": {
      "TITLE": "Items Not Selling",
      "EMPTY": "No Items Not Selling"
    },
    "POPULAR_BIDDING_ITEMS": {
      "TITLE": "Most Amount of Bids",
      "CURRENT_PRICE": "Current Price",
      "BID_COUNT": "No. Of Bids",
      "EMPTY": "No items with bids"
    },
    "PURCHASE": {
      "TITLE": "Buy It Now Items",
      "TOTAL": "Total",
      "TOTAL_ITEMS": "Total Items (Units Available)",
      "HAVE_SOLD": "Have Sold",
      "TO_SELL": "To Sell"
    },
    "DONATION": {
      "TITLE": "Donation Performance",
      "TOTAL": "Total Raised",
      "TARGET": "Target",
      "QUANTITY": "Quantity"
    },
    "RAFFLE": {
      "TITLE": "Raffle Performance",
      "TOTAL": "Total",
      "TICKETS_SOLD": "Tickets Sold",
      "TICKETS_AVAILABLE": "Tickets To Sell"
    },
    "EVENT_TICKETING": {
      "TITLE": "Event Tickets",
      "TOTAL": "Total",
      "TICKETS_SOLD": "Tickets Sold",
      "TICKETS_AVAILABLE": "Total Tickets"
    },
    "RAFFLE_WINNERS": {
      "TITLE": "Raffle Winners",
      "EMPTY": "No raffle winners yet",
      "ITEM_NAME": "Item Name",
      "WINNER": "Winner",
      "PRIZE": "Prize",
      "TICKET_NUMBER": "Ticket Number"
    },
    "TIP_REVENUE_SHARE_SUMMARY": {
      "TITLE": "Tip Revenue Share"
    },
    "PADDLE_RAISE": {
      "TITLE": "Paddle Raise Summary",
      "TOTAL_PLEDGES": "Total Number of Pledges",
      "TOTAL_SUCCESSFUL_PLEDGES": "Total Number of Successful Pledges",
      "TOTAL_RAISED": "Total Raised"
    }
  },
  "PRINT_VOUCHERS": {
    "DOWNLOAD": "Download Vouchers",
    "PRINT": "Print Vouchers",
    "SELECT_ITEMS": "Select Items for Vouchers",
    "SELECT_ITEMS_HINT": "Choose specific items to generate vouchers for. Leave empty to generate vouchers for all items.",
    "SELECTED_ITEMS": "Selected Items",
    "CLEAR_ALL": "Clear All",
    "DIALOG_TITLE": "Print Vouchers",
    "DIALOG_BODY": "Are you sure you want to print these vouchers? Remember to enable Background Graphics in More Settings inside the print dialog if you do not see all the colors.",
    "DIALOG_CONFIRM": "Print",
    "DIALOG_CANCEL": "Cancel"
  },
  "ITEMS": {
    "RESOURCES": {
      "MENU_LABEL": "Downloadable Assets",
      "TITLE": "Downloadable Assets",
      "TEMPLATE_DESC": "Download a template to help you format your item list correctly.",
      "EXPORT_DESC": "Export all items in your list to a file for external use.",
      "PRINT_VOUCHERS_DESC": "Print all item vouchers.",
      "ITEM_BOOKLET_DESC": "Generate and print the item display booklet.",
      "RESET_ITEM_CODES_DESC": "Reset item codes to new automatically generated values.",
      "TEMPLATE": "Item Upload Spreadsheet",
      "EXPORT": "Export Items Spreadsheet",
      "PRINT_VOUCHERS": "Printable Vouchers",
      "PRINT_PODIO_VOUCHERS": "Print Podio Vouchers",
      "ITEM_BOOKLET": "Printable Item Booklet"
    },
    "BOOKLET": {
      "PAGE_LAYOUT": "Page Layout",
      "HIDDEN_ITEMS": "Hidden Items",
      "FULL_WIDTH_BANNER": "Full Width Banner",
      "DOWNLOAD": "Download",
      "PRINT": "Print",
      "DOWNLOAD_BOOKLET_SUCCESS": "Booklet Downloaded"
    },
    "BULK_DELETE": {
      "WARNING_NOTIFICATION": "Items with activity cannot be deleted",
      "IOC_WARNING_NOTIFICATION": "Extra Profit Items cannot be deleted. Please deselect any Extra Profit Items and try again.",
      "GO_TO_BIDS_AND_BUYS": "Go to bids and buys",
      "WARNING": "This item has activity",
      "CONFIRM_TITLE": "Delete Items",
      "CONFIRM_BODY": "Are you sure you would like to delete {{count}} items? This action is irreversible.",
      "CONFIRM_BODY_SINGLE": "Are you sure you would like to delete this item? This action is irreversible."
    },
    "BULK_UPDATE": {
      "IOC_WARNING_NOTIFICATION": "Extra Profit Items cannot be bulk updated. Please deselect any Extra Profit Items and try again.",
      "EMPTY_FORM_ERROR": "Please add some item fields and try again",
      "DESLECT_ITEM_TITLE": "Deselect {{name}}",
      "DESLECT_ITEM_BODY": "Are you sure you would like to deselect this item?",
      "DESLECT_ITEM_CONFIRM": "Deselect",
      "DESLECT_ITEM_CANCEL": "Cancel",
      "DONATION": "Donation",
      "RAFFLE": "Raffle",
      "PURCHASE": "Buy It Now",
      "BIDDING": "Auction",
      "NO_ITEMS_SELECTED": "No items selected",
      "NO_ITEMS_SELECTED_MESSAGE": "Select your items from the items list ",
      "SEARCH": "Search Item Fields",
      "TITLE": "Bulk Update",
      "SELECT_ALL": "Select All",
      "STAFF": "Staff Only",
      "ADVANCED": "Advanced",
      "GENERAL": "General",
      "EMPTY": "Add a field to get started",
      "ADD_FIELD": "Add a form field",
      "ITEM_FORM": "Item Form",
      "BROWSE_FIELDS": "Browse All Fields",
      "FREQUENTLY_USED_FIELDS": "Commonly Used Fields",
      "ITEMS_SELECTED": "{{count}} Item Selected",
      "ITEMS_SELECTED_PLURAL": "{{count}} Items Selected",
      "DELETE_TITLE": "Delete Items",
      "DELETE_BODY": "Are you sure you'd like to delete these items? This action is irreversible",
      "SUBTITLE_EDITING": "Editing",
      "SUBTITLE_ITEMS": "{{count}} Item",
      "SUBTITLE_ITEMS_PLURAL": "{{count}} Items",
      "SUBMIT": "Update {{count}} Item",
      "SUBMIT_PLURAL": "Update {{count}} Items",
      "CONFIRM_TITLE": "Confirm Update",
      "CONFIRM_BODY": "Are you sure you'd like to update the selected items?",
      "SUCCESS": "Items Updated",
      "FULFILMENT_CONFLICT_WARNING": "Items cannot have both voucher and collection settings enabled"
    },
    "TYPE": {
      "FEE": "Fee",
      "RAFFLE": "Raffle",
      "BIDDING": "Auction",
      "SEALED": "Sealed Bid",
      "SILENT": "Silent Auction",
      "LIVE": "Live Auction",
      "PURCHASE": "Buy-It-Now",
      "BIDDING_PURCHASE": "Auction (Buy-It-Now)",
      "DONATION": "Donation/Crowdfunding",
      "DONATION_SINGULAR": "Donation",
      "IOC": "Extra Profit Items",
      "EVENT_TICKET_PURCHASE": "Event Ticket",
      "PAYMENT_DONATION": "Payment Donation"
    },
    "TRANSFER": {
      "NO_ITEMS": "This campaign doesn't have any items yet",
      "IMPORT": "Import {{count}} Item",
      "IMPORT_MULTI": "Import {{count}} Items",
      "TRANSFER_OUT": "Transfer Out {{count}} Item",
      "TRANSFER_OUT_SUCCESS": "Items Successfully Transfered Out",
      "TRANSFER_OUT_MULTI": "Transfer Out {{count}} Items",
      "SUCCESS": "Items Imported",
      "NO_ITEMS_MESSAGE": "Select some items and try again",
      "TRANSFERRING_FROM": "Campaign:",
      "CAMPAIGN_LIST": "Campaign List"
    },
    "CATEGORY": {
      "EMPTY_STATE": "No Categories Yet",
      "EMPTY_STATE_SUBTITLE": "Define categories to organize your items efficiently",
      "ORDER": "Order",
      "NAME": "Name",
      "COUNT": "Number of Items",
      "SEARCH": "Search Categories",
      "ADD": "Add Category",
      "EMPTY": "Click + add to create a category",
      "UPDATE_SUCCESS": "Categories updated",
      "UPDATE_SUCCESS_SINGLE": "Category updated",
      "CREATE_TITLE": "Add Category",
      "EDIT_TITLE": "Edit Category",
      "EDIT_SUBMIT": "Save",
      "CREATE_SUBMIT": "Create",
      "DELETE_SUCCESS": "Category Deleted",
      "CONFIRM_DELETE_TITLE": "Delete Category",
      "CONFIRM_DELETE_BODY": "Are you sure you would like to delete this category? This action is irreversible",
      "CONFIRM_DELETE_CONFIRM": "Delete",
      "CONFIRM_DELETE_CANCEL": "Cancel",
      "NAME_LABEL": "Category Name",
      "CREATE_SUCCESS": "Category Created",
      "ITEMS_SELECTED": "{{count}} Items Selected"
    },
    "IOC_SHOP": {
      "THIS_COUNTRY": "This country",
      "NOT_AVAILABLE": "Extra Profit Items are not available in {{country}}",
      "MEMORABILIA_DIALOG": {
        "TITLE": "Ticketed Events",
        "BODY": "If you'd like to add Ticketed Events to your campaign, please contact your account manager.",
        "BODY_2": "Catalogue can be found here:",
        "TICKET_LINK": "galabid.com/salesticketedevents"
      },
      "SEARCH": "Search Items",
      "SHOW_FILTERS": "Show Filters",
      "HIDE_FILTERS": "Hide Filters",
      "MIN": "Min",
      "MAX": "Max",
      "FILTER": "Filter",
      "FILTERS": "Filters",
      "EXAMPLE_LABEL": "Pricing simulator",
      "MORE_INFO": "Info",
      "SELECT": "Select this item",
      "COST": "Cost",
      "ALIAS": "Item Code",
      "STARTING_PRICE": "Starting Price",
      "EXPLAIN_PRICING": "Pricing",
      "BEST_SELLER": "Best Seller",
      "MINIMUM_INCREMENT": "Minimum Increment",
      "PROFIT": "Profit",
      "NO_RISK": "There is no cost if the item recieves no bids",
      "BIDS_LABEL": "Bids Placed",
      "BID_AMOUNT": "Bid Amount",
      "PRICING_ADDITIONAL_INFO_1": "This assumes the bids are placed at the minimum increment, bidders can always place more, in which case your profit will increase",
      "PRICING_ADDITIONAL_INFO_2": "This doesn't take into account any additional Stripe or service fees",
      "MORE_INFO_BUTTON": "More Info",
      "HOW_IT_WORKS": {
        "TITLE": "No Risk Extra Profit Items",
        "BODY_1": "<strong>It's Free to add these items to your campaign.</strong>There is no limit on how much you can raise on each item. The minimum profit on a sale is 10%, the average is 29%.",
        "BODY_2": "Add these items at any point. Even if your campaign is running and has bids already",
        "BODY_3": "No-risk basis: this means if an item doesn't sell, there's no charge to you or penalties.",
        "BODY_4": "Our redemptions team will handle the prize fulfilment, so you won't need to worry about securing vouchers, sending artwork or booking activities.",
        "SHARE_DESCRIPTION": "Share a read-only view of the catalogue with the link:",
        "LINK_COPIED": "Catalogue Link Copied to Clipboard"
      },
      "PLACEMENT_PREFERENCE_DIALOG": {
        "TITLE": "Items Placement",
        "RADIO_GROUP_LABEL": "Select where you want to place the imported items",
        "TOP": "Insert at top of item list",
        "BOTTOM": "Insert at bottom of item list"
      }
    },
    "LIST": {
      "ALL_ITEMS_ON_PAGE": "All {{count}} items on this page are selected",
      "SELECT_ALL_ON_PAGE": "Select all {{count}} items on this page",
      "SELECT_ALL": "Select all {{count}} items",
      "EMPTY_STATE": {
        "CUSTOM_ITEM": {
          "TITLE": "Start adding your own items",
          "SUBTITLE": "Start adding items so your participants can bid, buy and donate."
        },
        "IOC_LINK": "Explore the Full Catalog",
        "IOC": {
          "TITLE_1": "GalaBid's",
          "TITLE_2": "Extra Profit",
          "TITLE_3": "Items",
          "SUBTITLE_1": "Raise even more with no-risk Items. Guaranteed profit for every GalaBid item that sells.",
          "SUBTITLE_2": "There is no charge if an item does not sell - no credit card is required to add items to your campaign.",
          "BUTTON": "Explore the Full Catalog",
          "SUB_BUTTON": "More Info",
          "LEARN_MORE": "Learn More"
        }
      },
      "IMPORT": "Import Spreadsheet",
      "TRANSFER_IN_ITEMS": "Transfer In Items",
      "TRANSFER_OUT_ITEMS": "Transfer Out Items",
      "HAS_ACTIVITY": "Has Activity",
      "NEW_BID": "New Bid",
      "NEW_BID_TITLE": "New Bid",
      "NEW_BID_DESC": "Place a bid on behalf of a participant for the item: <strong>#{{alias}} - {{name}}</strong>",
      "PLACE_BID": "Place Bid",
      "PLACE_BID_SUCCESS": "Bid placed successfully",
      "PLACE_BID_ERROR_AUTO_OUTBID": "This bid was automatically outbid by another guest's maximum bid. Try a higher amount.",
      "PLACE_BID_NOT_ALLOWED": "You cannot place a bid on item <strong>#{{alias}} - {{name}}</strong> because there is already a winner and the campaign is <strong>{{status}}</strong>.",
      "SEND_NOTIF": "Send invoice notification",
      "SEND_NOTIF_DESC": "Send an invoice notification to the participant as a payment reminder",
      "BID_AMOUNT": "Bid Amount",
      "QR_CODE": "QR Code",
      "QR_CODE_DESC": "Share the QR code to help new participants access this item directly.",
      "SEE_BIDS_AND_BUYS": "See Bids and Buys",
      "REORDER_ITEMS_SUCCESS": "Item Order Updated",
      "DOWNLOAD_TEMPLATE_SUCCESS": "Template Downloaded",
      "RESET_ALIASES_SUCCESS": "Item Codes Reset",
      "FILTERS": "Filters",
      "RESET_ITEM_CODES": "Reset Item Codes",
      "CONFIRM_RESET_ITEM_CODES_BODY": "Are you sure you would like to reset the item codes? This action is irreversible",
      "CONFIRM_DELETE_TITLE": "Delete Item",
      "CONFIRM_DELETE_BODY": "Are you sure you would like to delete this item? This action is irreversible",
      "CONFIRM_DELETE_CONFIRM": "Delete",
      "CONFIRM_DELETE_CANCEL": "Cancel",
      "RETRACT_IOC_ITEM": "Retract Extra Profit Item",
      "CONFIRM_RETRACT_IOC_TITLE": "Retract Extra Profit Item",
      "CONFIRM_RETRACT_IOC_BODY": "Are you sure you would like to retract this Extra Profit Item? This will delete the item from other campaigns where it has no activity, notify the admins of those campaigns, and hide it from this campaign.",
      "CONFIRM_RETRACT_IOC_CONFIRM": "Retract",
      "CONFIRM_RETRACT_IOC_CANCEL": "Cancel",
      "RETRACT_IOC_SUCCESS": "Extra Profit Item retracted successfully",
      "ADD": "Create Item",
      "LOCK": "Lock",
      "VOUCHER_ENABLED": "Vouchers",
      "MAX_BID_ENABLED": "Max Bid",
      "MARKET_VALUE": "Market Value",
      "UNITS_PER_PERSON": "Units Per Person",
      "TAX": "Tax",
      "IOC": "Extra Profit Item",
      "IOC_COST": "Extra Profit Item Cost",
      "PAY_NOW": "Pay Now",
      "IMAGE": "Image",
      "ORDER": "Order",
      "ALIAS": "Code",
      "NAME": "Name",
      "MIN_BID_INCREMENT": "Minimum Bidding Increment",
      "MIN_DONATION": "Minimum Donation",
      "TYPE": "Type",
      "REORDER": "Save Ordering",
      "STARTING_PRICE": "Starting Price",
      "PRICE": "Price",
      "RESERVE_PRICE": "Reserve Price",
      "BUY_NOW_PRICE": "Buy Now Price",
      "REORDER_ACTION": "Save",
      "SEARCH": "Search Items",
      "QUANTITY": "Quantity",
      "VISIBLE": "Visible",
      "HIDDEN": "Hidden",
      "FILTER_ITEM_TYPE": "Show item types",
      "ITEM": {
        "EDIT": "Edit",
        "DELETE": "Delete",
        "HIGHEST_BID": "Highest Bid",
        "HIGHEST_BIDDER": "Highest Bidder",
        "STARTING_PRICE": "Starting Price",
        "TICKETS_AVAILABLE": "Tickets Available",
        "TICKETS_SOLD": "Tickets Sold",
        "UNITS_AVAILABLE": "Units Available",
        "UNITS_SOLD": "Units Sold",
        "TOTAL_COLLECTED": "Total Collected"
      }
    },
    "EXPORT": {
      "SUCCESS": "Items exported successfully"
    },
    "EDIT": {
      "RAFFLE_SAAS_MESSAGE": "Make sure to include the following information: ",
      "RAFFLE_SAAS_MESSAGE_1": "Name, Address & Registration/Charity Number of the Organisation running the draw.",
      "RAFFLE_SAAS_MESSAGE_2": "When the draw will take place.",
      "RAFFLE_SAAS_MESSAGE_3": "Where winners' names will be published.",
      "RAFFLE_SAAS_MESSAGE_4": "Any specific conditions such as minimum ticket sales and the refund policy if minimum is not met.",
      "IOC_COST_LABEL": "IOC Cost",
      "WINNING_BID": "Winning Bid",
      "UNITS": "Unit(s)",
      "BUY_NOW": "Buy Now",
      "RAFFLE_LAW_MESSAGE": "You may not be permitted to run an Online Raffle. Check local laws before proceeding.",
      "IMAGE": "Item Images",
      "RAFFLE_PRICE_WARNING": "Higher Raffle Ticket Prices are Highly Recommended. Stripe fees can amount to a high percentage of lower ticket prices. We recommend a minimum price of {{amount}}.",
      "ADD_DONATION_OPTION": "Add Donation Option",
      "IOC_WARNING": "This is an extra profit item. Only GalaBid staff may edit it.",
      "ITEM_HAS_RAFFLE_PURCHASE": "Cannot change the item type as participants have already purchased tickets",
      "ITEM_HAS_BIDS": "Cannot change the item type as participants have already placed bids",
      "ITEM_HAS_DONATION": "Cannot change the item type as participants have already made donations",
      "ITEM_HAS_PURCHASE": "Cannot change the item type as participants have already made purchases",
      "ITEM_HAS_BIDDING_PURCHASES": "Cannot change this field as participants have already made buy now purchases",
      "BACK": "Items List",
      "CREATE_SUCCESS": "Item Created",
      "UPDATE_SUCCESS": "Item Updated",
      "EDIT_TITLE": "Edit Item",
      "DELETE_SUCCESS": "Item Deleted",
      "EDIT_IMAGES": "Edit Images",
      "VIEW_IMAGES": "View Images",
      "IMAGES": "Images",
      "UPLOAD_IMAGE": "Upload Images",
      "CHOOSE_IMAGE": "Choose Item Images",
      "CREATE_TITLE": "Create a new item",
      "NAME": "Item Name",
      "ALIAS": "Item Code",
      "TYPE": "Item Type",
      "DESCRIPTION": "Item Description",
      "DESCRIPTION_AI_DISCLAIMER": "Disclaimer: This description was generated using AI and may not be accurate or complete. Please review before saving.",
      "CATEGORIES": "Categories",
      "CREATE": "Create Item",
      "STARTING_PRICE": "Starting Price",
      "UNITS_AVAILABLE": "Units Available",
      "MINIMUM_INCREMENT": "Minimum Increment",
      "TAX": "Tax",
      "TARGET": "Target",
      "PRIZES_AVAILABLE": "Prizes Available",
      "TICKET_PRICE": "Ticket Price",
      "TOTAL_TICKETS_AVAILABLE": "Total Tickets Available",
      "MAXIMUM_TICKETS_PER_PERSON": "Maximum Tickets Per Person",
      "ENABLE_PRE_BIDDING": "Enable Pre-Bidding",
      "MINIMUM_DONATION": "Minimum Donation",
      "UNIT_PRICE": "Unit Price",
      "UNITS_PER_PERSON": "Units Per Person",
      "PAY_NOW": "Pay Now",
      "CATEGORY_HINT": "Add the item to existing categories or enter a new category to create one",
      "CATEGORIES_PLACEHOLDER": "Type to add categories",
      "CATEGORY_CREATE_NEW_PROMPT": "Press ENTER to create a new category",
      "GENERATE_ITEM_DESC_NO_TITLE_ERROR": "Please provide a title before generating an item description",
      "BIDDING_TYPE": {
        "LIVE": "Only use this for items presented in a traditional auction setting with an auctioneer",
        "SILENT": "Select this option for items that will be part of a silent auction, where bids are made via participants' devices",
        "SEALED": "The 'Hide Bidder', 'Hide Price', and 'Hide Status Badge' options will be turned on. The 'Send Outbid Notification' option will be turned off. You can find these options in the 'Advanced Options' section at the bottom of the form if you wish to change them"
      },
      "LABEL": "Item Label",
      "ORDER": "Display Order",
      "IS_VISIBLE": "Item Visible",
      "LOCK": "Who can Bid / Buy",
      "LOCK_MESSAGE": "Lock Message",
      "LOCK_TYPE": {
        "NONE": "Everyone",
        "ADMIN": "Admins only",
        "VOLUNTEER": "Volunteers only"
      },
      "ITEM_ACTIVITY_FEED_VISIBILITY": "Enable Activity Feed",
      "OUTBID_NOTIFICATION": "Enable Outbid Notifications",
      "HIDE_BIDDER": "Hide Bidder",
      "HIDE_PRICE": "Hide Price",
      "HIDE_STATUS_BADGE": "Hide Status Badge",
      "HIDE_UNITS_AVAILABLE": "Hide Units Available",
      "BID_STRENGTH_ENABLED": "Enable Bid Strength",
      "BID_STRENGTH_PERCENTAGE": "Bid Strength Percentage",
      "RESERVE_PRICE_ENABLED": "Enable Reserve Price",
      "HIDE_RESERVE_PRICE": "Hide Reserve Price",
      "SHOW_LABEL": "Enable Item Label",
      "IMAGE_COVER": "Fill Image",
      "SHARE_ITEM": "Share Item Options",
      "SHARE_FACEBOOK": "Share on Facebook",
      "SHARE_LINK": "Share Link",
      "FOOTNOTE": "Footnote",
      "FOOTNOTE_TOOLTIP": "A custom message displayed at the bottom of the item page",
      "SHARE_TWITTER": "Share on X",
      "SHOW_DONATION_AMOUNTS": "Suggest Donation Amounts",
      "USE_INCREMENTS": "Suggest Donation Amounts",
      "INCLUDE_OTHER_AMOUNT": "Include 'Other' Amount",
      "SHOW_NUMBER_OF_TICKETS_AVAILABLE": "Show Number of Tickets Available",
      "MARKET_VALUE": "Market Value",
      "SHOW_LABEL_TOOLTIP": "Show a custom label in place of the default item type",
      "LABEL_TOOLTIP": "Specify a custom label to be shown when \"Enable Item Label\" is selected",
      "ORDER_TOOLTIP": "Set the numerical position of this item in the list",
      "VISIBILITY_TOOLTIP": "If hidden, the item is still accessible via direct link",
      "ITEM_ACTIVITY_FEED_VISIBILITY_TOOLTIP": "Show a live feed of participant activity on the item page",
      "OUTBID_NOTIFICATION_TOOLTIP": "Send a notification when a participant is outbid",
      "HIDE_BIDDER_TOOLTIP": "Hide the bidder's identity from other participants",
      "HIDE_PRICE_TOOLTIP": "Hide the current and next minimum bid amounts",
      "HIDE_STATUS_BADGE_TOOLTIP": "Hide bidding status badge (e.g. \"Winning\", \"Outbid\")",
      "HIDE_UNITS_AVAILABLE_TOOLTIP": "Hide the number of units available for this item",
      "BID_STRENGTH_ENABLED_TOOLTIP": "Show a colour-coded indicator of how competitive a bid is",
      "BID_STRENGTH_PERCENTAGE_TOOLTIP": "Percentage above the current amount required for a \"Strong\" bid",
      "BID_STRENGTH_DISABLED_MESSAGE": "Bid strength unavailable when price is hidden",
      "RESERVE_PRICE_ENABLED_TOOLTIP": "Set a reserve price that must be met for the sale to occur",
      "HIDE_RESERVE_PRICE_TOOLTIP": "Toggle to hide the reserve price from bidders",
      "RESERVE_PRICE_TOOLTIP": "If no one bids at or above the reserve price, the item will not be sold",
      "RESERVE_PRICE": "Reserve Price",
      "SHOW_DONATION_AMOUNTS_TOOLTIP": "Enable to display preset donation amounts",
      "DONATION_AMOUNT": "Donation Amount",
      "DONATION_OPTIONS": "Add Donation Option",
      "INCLUDE_OTHER_AMOUNT_TOOLTIP": "Allow participants to enter a custom donation amount",
      "SHOW_NUMBER_OF_TICKETS_AVAILABLE_TOOLTIP": "Show the total tickets and amount remaining to participants",
      "MARKET_VALUE_TOOLTIP": "Used for invoice and reporting purposes only",
      "IMAGE_COVER_TOOLTIP": "Scale image to fill box in the item list",
      "VOUCHER_ENABLED_TOOLTIP": "Issue a voucher to the winner upon payment (e.g. for stays, experiences, or services).",
      "COLLECTION_ENABLED_TOOLTIP": "Send collection / pickup instructions to the winner upon payment",
      "SHARE_FACEBOOK_TOOLTIP": "Show a button for participants to share this item on Facebook",
      "SHARE_LINK_TOOLTIP": "Show a button to copy the direct item link to the clipboard",
      "SHARE_TWITTER_TOOLTIP": "Show a button for participants to share this item on X",
      "ENABLE_PRE_BIDDING_TOOLTIP": "Pre-bids are never counted as winning bids. Disable pre-bidding then enter the winning bid via a Volunteer account",
      "ENABLE_PRE_BIDDING_REQUEST_ACTIVATION": "Request activation via livechat if you would like to enable pre-bidding",
      "STARTING_PRICE_TOOLTIP": "Enter the initial bid amount for this item. We recommend starting at 50% of the item's value.",
      "MINIMUM_INCREMENT_TOOLTIP": "Specify the smallest bid increase allowed over the current bid",
      "UNITS_AVAILABLE_TOOLTIP": "The number of units of this item available",
      "MINIMUM_DONATION_TOOLTIP": "Set the lowest donation amount accepted for this item",
      "TARGET_TOOLTIP": "Enter the fundraising goal amount for this item",
      "PAY_NOW_TOOLTIP": "Enable to require immediate payment",
      "PRIZES_AVAILABLE_TOOLTIP": "The number of prizes available in the raffle",
      "TICKET_PRICE_TOOLTIP": "Set the price for each raffle ticket",
      "TOTAL_TICKETS_AVAILABLE_TOOLTIP": "Indicate the total number of raffle tickets for sale",
      "MAXIMUM_TICKETS_PER_PERSON_TOOLTIP": "Specify the maximum number of tickets an individual can purchase",
      "UNIT_PRICE_TOOLTIP": "Enter the price per unit for this item",
      "UNITS_PER_PERSON_TOOLTIP": "Limit the number of units one person can buy",
      "ADD_RAFFLE_PACKAGE": "Add Raffle Package",
      "ENABLE_LIVE_AUCTION": "Enable Pre-bidding",
      "BIDDING_UNITS_AVAILABLE": "Units Available (Auction Item)",
      "MAX_BID_ENABLED": "Enable Max Bidding",
      "MAX_BID_ENABLED_TOOLTIP": "Allow participants to set a max bid and have the system place bids on their behalf",
      "BUY_NOW_SECTION": "Buy Now",
      "BIDDING_ALLOW_BUY_NOW": "Enable Buy Now",
      "BIDDING_ALLOW_BUY_NOW_TOOLTIP": "Allow participants to purchase this item immediately at the buy now price",
      "BIDDING_UNITS_PER_PERSON": "Units Per Person",
      "BIDDING_UNITS_PER_PERSON_TOOLTIP": "Limit the number of units one person can buy",
      "BIDDING_BUY_NOW_PRICE": "Buy Now Price",
      "BIDDING_BUY_NOW_PRICE_TOOLTIP": "Set the price for this item when buying now",
      "BIDDING_PAY_NOW": "Pay Now",
      "BIDDING_PAY_NOW_TOOLTIP": "Applies only when buy now is enabled",
      "DONATION_PAY_NOW": "Pay Now (Donation Item)",
      "DONATION_PAY_NOW_TOOLTIP": "Require immediate payment upon making a donation",
      "TICKETS_AVAILABLE": "Tickets Available",
      "TICKETS_AVAILABLE_TOOLTIP": "Total number of tickets available for the event or raffle",
      "MAX_TICKETS_PER_PERSON": "Max Tickets Per Person",
      "MAX_TICKETS_PER_PERSON_TOOLTIP": "Limit the number of tickets one person can purchase",
      "PURCHASE_UNITS_AVAILABLE": "Units Available (Buy-It-Now Item)",
      "PURCHASE_UNITS_AVAILABLE_TOOLTIP": "Indicate the number of units available for purchase",
      "PURCHASE_UNITS_PER_PERSON": "Purchase Limit Per Person",
      "PURCHASE_UNITS_PER_PERSON_TOOLTIP": "Set a limit on the number of units one person can purchase",
      "PURCHASE_PAY_NOW": "Pay Now (Buy-It-Now Item)",
      "PURCHASE_PAY_NOW_TOOLTIP": "Require immediate payment upon purchase",
      "COLLECTION_ENABLED_TOGGLE": "Physical (Collection)",
      "COLLECTION_ENABLED": "Enable Collection",
      "COLLECTION_INSTRUCTIONS": "Collection Instructions",
      "COLLECTION_INSTRUCTIONS_PLACEHOLDER": "Enter instructions, e.g. Collect at the event desk or email info@example.com to arrange pickup",
      "VOUCHER_ENABLED_TOGGLE": "Digital (Voucher)",
      "VOUCHER_ENABLED": "Enable Digital Vouchers",
      "VOUCHER_INSTRUCTIONS": "Voucher Instructions",
      "VOUCHER_PDF": "Voucher PDF",
      "VOUCHER_REDEMPTION_INSTRUCTIONS": "Voucher Redemption Instructions",
      "VOUCHER_REDEMPTION_INSTRUCTIONS_TOOLTIP": "Provide instructions for how to redeem vouchers",
      "UPLOAD_VOUCHER_PDF": "Upload Voucher PDF",
      "INVALID_PDF_FILE": "Invalid PDF file. Please select a valid PDF file",
      "PDF_TOO_LARGE": "PDF file size exceeds the maximum limit of {{size}}MB",
      "DOWNLOAD_PDF": "Download PDF",
      "REMOVE_PDF": "Remove PDF",
      "IOC": "Enable IOC",
      "ENABLE_IOC_UPDATE": "Enable IOC Catalog Update",
      "IOC_COST_APPLICATION_FEE": "Charge IOC cost with Stripe",
      "IOC_COST_APPLICATION_FEE_TOOLTIP": "Automatically send item cost directly to GalaBid when sold",
      "IOC_COST": "IOC Cost",
      "TICKET_PACKAGES": "Raffle Packages",
      "TICKETS": "Tickets",
      "PRICE": "Price",
      "REMOVE_PACKAGE": "Remove Package",
      "REMOVE_DONATION_OPTION": "Remove Donation Option",
      "SUPPLIER_NAME": "Supplier Name",
      "SUPPLIER_NAME_TOOLTIP": "Enter the name of the item supplier",
      "SUPPLIER_EMAIL": "Supplier Email",
      "SUPPLIER_EMAIL_TOOLTIP": "Enter the supplier's email address",
      "VOUCHER_REDEMPTION_CODE_ENABLED": "Enable Voucher Redemption Code",
      "VOUCHER_REDEMPTION_CODE_ENABLED_TOOLTIP": "Toggle to enable a redemption code for the voucher",
      "SUPPLIER_PHONE": "Supplier Phone",
      "SUPPLIER_PHONE_TOOLTIP": "Enter the supplier's phone number",
      "SUPPLIER_COST": "Supplier Cost",
      "SUPPLIER_COST_TOOLTIP": "Enter the cost charged by the supplier",
      "SUPPLIER_NOTES": "Supplier Notes",
      "SUPPLIER_AGREEMENT": "Supplier Agreement",
      "SUPPLIER_AGREEMENT_EXPIRY": "Supplier Agreement Expiry",
      "TERMS_AND_CONDITIONS_ENABLED": "Enable Terms & Conditions",
      "TERMS_AND_CONDITIONS": "Terms & Conditions",
      "TERMS_AND_CONDITIONS_TOOLTIP": "Show terms for this item on the item page",
      "TERMS_AND_CONDITIONS_RAFFLE_TOOLTIP": "Show terms for this item on the raffle ticket and item page",
      "LINK_COPIED": "Item Link Copied to Clipboard",
      "LINK_UNAVAILABLE": "Shareable link will be available once item has been saved",
      "SHOW_BADGE": "Enable Badge",
      "SHOW_BADGE_HINT": "Show a custom badge in the App Catalog (e.g. \"Waitlist\")",
      "BADGE": "Badge Label",
      "BADGE_HINT": "Specify a custom badge to be shown when \"Enable Badge\" is selected",
      "IOC_SHOP_LABEL": "IOC Shop Label",
      "IOC_SHOP_LABEL_HINT": "Show a custom label in the Dashboard IOC shop (e.g. \"Best Seller\")",
      "IOC_SHOP_LABEL_COLOR": "IOC Shop Label Colour",
      "GENERAL_OPTIONS_TITLE": "General Options",
      "BIDDING_OPTIONS_TITLE": "Bidding Options",
      "ADVANCED_OPTIONS_TITLE": "Advanced Options",
      "STAFF_OPTIONS_TITLE": "Staff Options",
      "VISIBILITY_ACCESS_TITLE": "Visibility & Access",
      "VISIBILITY_ACCESS_TOOLTIP": "Control who can see and interact with this item.",
      "TAXES_TITLE": "Taxes",
      "TAXES_TOOLTIP": "Manage tax settings for this item. Global tax rates can be configured in Setup > Taxes.",
      "ITEM_FULFILMENT_TITLE": "Item Fulfilment",
      "ITEM_FULFILMENT_TOOLTIP": "Manage how participants receive or redeem this item.",
      "CATEGORIES_TITLE": "Categories",
      "CATEGORIES_TOOLTIP": "Add categories to group and filter this item.",
      "TERMS_CONDITIONS_TITLE": "Terms & Conditions",
      "TERMS_CONDITIONS_TOOLTIP": "Set optional terms & conditions for this item.",
      "NOTIFICATIONS_TITLE": "Notifications",
      "NOTIFICATIONS_TOOLTIP": "Manage bidding-related notifications for this item.",
      "VISIBILITY_PRIVACY_TITLE": "Visibility & Privacy",
      "VISIBILITY_PRIVACY_TOOLTIP": "Control which information is shown to participants.",
      "BID_STRENGTH_TITLE": "Bid Strength",
      "BID_STRENGTH_TOOLTIP": "Configure how bid strength is displayed and calculated.",
      "BID_HANDLING_TITLE": "Bid Handling",
      "BID_HANDLING_TOOLTIP": "Control how bids are placed and accepted for this item.",
      "ADVANCED_DISPLAY_TITLE": "Item Display",
      "ADVANCED_DISPLAY_TOOLTIP": "Manage how this item and its activity are shown.",
      "SOCIAL_SHARING_TITLE": "Social Sharing",
      "SOCIAL_SHARING_TOOLTIP": "Control which share options are shown on the item page.",
      "SUPPLEMENTARY_DETAILS_TITLE": "Supplementary Details",
      "SUPPLEMENTARY_DETAILS_TOOLTIP": "Manage reference values and additional item notes.",
      "STAFF_SUPPLIER_TITLE": "Supplier & Fulfillment",
      "STAFF_SUPPLIER_TOOLTIP": "Manage supplier details and redemption settings.",
      "IOC_TITLE": "IOC",
      "IOC_TOOLTIP": "Manage IOC settings and catalog appearance."
    }
  },
  "FILE_UPLOADER": {
    "DRAG_AND_DROP_HERE": "Drop file here",
    "BROWSE": "Choose file"
  },
  "IMAGE_UPLOADER": {
    "BROWSE": "Choose Image",
    "DRAG_AND_DROP_HERE": "Drop image here",
    "RECOMMENDED_SIZE": "{{width}}px wide x {{height}}px high",
    "MULTI_IMAGE_INDICATOR": "+ {{qty}} more ",
    "TOO_LARGE_WARNING": "Image must be no larger than {{size}}mb",
    "DIMENSIONS_WARNING": "Image must be no larger than {{width}}px x {{height}}px",
    "FORMAT_ERROR": "Image must be one of the following formats: {{formats}}",
    "IMAGE_UPLOADING_DELAY": "Please wait for the image to finish uploading",
    "UPLOAD_FAILED": "Image upload failed, please try again",
    "ROTATE_LEFT": "Rotate Left",
    "ROTATE_RIGHT": "Rotate Right",
    "ENABLE_EDITOR": "Enable Editor",
    "GIF_UPLOAD_SIZE_WARNING": "GIF must be no larger than 10 MB"
  },
  "CAMPAIGNS": {
    "DASHBOARD": "Dashboard",
    "CREATE": {
      "STEPPER": {
        "ACCOUNT": "Account",
        "CAMPAIGN": "Campaign",
        "PRICING": "Fee Options"
      },
      "STEP": "Step {{step}}/{{total}}",
      "NO_CREDITS_MESSAGE_STAFF": "This organisation has no campaign creation credits remaining. As a staff user, you can create this campaign anyway.",
      "NO_CREDITS_MESSAGE": "Your organisation has no campaign creation credits remaining, contact GalaBid if you need more.",
      "CLIENT_ACCOUNT_SETTING_CREDIT_MESSAGE_ONE": "Creating this campaign will use the organisation's last remaining campaign creation credit.",
      "CLIENT_ACCOUNT_SETTING_CREDIT_MESSAGE": "Creating this campaign will use one of the organisation's {{credit}} remaining campaign creation credits.",
      "ADD_CREDITS": "Add Credits",
      "SUCCESS": "Campaign Created",
      "CLIENT_ACCOUNT": "Organisation",
      "SUBMIT": "Create Campaign",
      "HEADER": "Campaign Details",
      "HEADER_ONBOARDING": "Create your fundraising page",
      "SUB_HEADER": "Don't worry, you can update these details at any time.",
      "NAME_ONBOARDING": "What would you like to call your fundraiser?",
      "URL_ONBOARDING": "Choose a URL for your fundraiser",
      "URL_PLACEHOLDER_ONBOARDING": "your-fundraiser-page",
      "COUNTRY_ONBOARDING": "Where are you located?",
      "SELECT_ALL": "Select All",
      "DESELECT_ALL": "Deselect All",
      "CAMPAIGN_TYPE": "Campaign Type",
      "PRICING": "Pricing",
      "CAMPAIGN": "Campaign",
      "RAFFLE": "Raffle",
      "BIDDING": "Auction",
      "ADD_CREDIT_DIALOG": {
        "TITLE": "Edit Campaign Creation Credits",
        "ORGANIZATION": "Organisation",
        "DESCRIPTION_1": "Each time an admin creates a campaign, a campaign creation credit is deducted from their organisation. If an organisation has used all of its credits, its admins will not be able to create new campaigns.",
        "DESCRIPTION_2": "As a staff user, you will be able to create campaigns even if there are no credits remaining.",
        "FIELD_LABEL": "Auction Creation Credits"
      },
      "FEATURES": {
        "BIDDING": "Auction",
        "BIDDING_DESC": "Items to be bid on and won by the highest bidder at the close of the auction",
        "RAFFLE": "Raffle",
        "RAFFLE_DESC": "Prizes to be drawn at random from purchased raffle tickets",
        "DONATION": "Donation",
        "DONATION_DESC": "Donation amounts with the option to pay now or pay later",
        "PURCHASE": "Buy-It-Now",
        "PURCHASE_DESC": "Items with a fixed price and quantity, with the option to pay now or pay later",
        "TICKETING": "Ticketing",
        "TICKETING_DESC": "Tickets for event attendance"
      }
    },
    "LIST": {
      "VIEW_CAMPAIGN": "View Campaign",
      "NAME": "Name",
      "URL": "URL",
      "SEARCH": "Search Campaigns",
      "TITLE": "Campaigns",
      "EDIT_CAMPAIGN": "Edit Campaign",
      "CAMPAIGN_LIST": "Campaign List",
      "CREATED": "Created",
      "CLOSED": "Closed",
      "ORGANISATION": "Organisation",
      "STATUS": "Status",
      "PENDING_ORG_WARNING_1": "You have <strong>{{count}}</strong> pending organisation invite(s). Accept them in",
      "PENDING_ORG_WARNING_2": "to gain access to all your available campaigns."
    },
    "CREATE_CAMPAIGN": "Create New Campaign",
    "CAMPAIGN_UPDATED_SUCCESS": "Campaign Saved",
    "CAMPAIGN_UPDATED_ERROR": "There was an error saving your campaign",
    "CAMPAIGN_LOAD_ERROR": "There was an error with loading this campaign",
    "CLONE": {
      "CLONE_CAMPAIGN": "Clone Campaign",
      "CLONE": "Clone",
      "NEW_CAMPAIGN_NAME": "New Campaign Name",
      "NEW_CAMPAIGN_URL": "New Campaign URL",
      "SUCCESS": "Your campaign is being cloned. You will receive an email when the cloning is complete."
    }
  },
  "AUTH": {
    "LOGIN": {
      "NOT_AUTHED_WARNING": "Please log in to access the dashboard",
      "EMAIL_LABEL": "Email",
      "PASSWORD_LABEL": "Password",
      "SUBMIT": "Login",
      "FORGOT_PASSWORD": "Forgot your password?",
      "DONT_HAVE_AN_ACCOUNT": "Don't have an account?",
      "SIGN_UP_NOW": "Sign up now",
      "CONTACT_US": "Contact Us",
      "RETURN_TO_SIGN_IN": "Return to sign in",
      "FORGOT_PASSWORD_PROMPT": "Enter your email address and we'll send you a link to reset your password.",
      "FORGOT_PASSWORD_SUBMIT": "Send Link",
      "RESET_EMAIL_SENT_HEADER": "Check your email",
      "RESET_EMAIL_SENT": "If <strong>{{email}}</strong> is associated with an account in our system, you'll receive an email with instructions to reset your password.",
      "RESET_EMAIL_NOT_RECEIVED": "If you don't receive an email within a few minutes, please check your spam folder. You can also ",
      "RESET_EMAIL_NOT_RECEIVED_LINK_1": "resend the request ",
      "RESET_EMAIL_NOT_RECEIVED_LINK_2": " use a different email address",
      "NEW_PASSWORD": "New Password",
      "CONFIRM_PASSWORD": "Confirm Password",
      "PWD_NOT_MATCH": "Passwords do not match",
      "INVALID_RESET_LINK": "The reset link is invalid",
      "RESET_PASSWORD_HEADER": "Reset your password",
      "RESET_PASSWORD_PROMPT": "Set a new password for your account below.",
      "RESET_PASSWORD_SUBMIT": "Reset",
      "RESET_PASSWORD_SUCCESS": "Your password has been updated",
      "MFA_HEADER": "Two-Factor Authentication",
      "MFA_PROMPT": "Enter the 6-digit code shown in your authenticator app.",
      "MFA_CODE": "MFA Code",
      "DISTRIBUTOR_LABEL": "Distributor",
      "SSO": {
        "FACEBOOK": "Sign in with Facebook",
        "GOOGLE": "Sign in with Google",
        "APPLE": "Sign in with Apple",
        "MICROSOFT": "Sign in with Microsoft"
      }
    },
    "LOGOUT": "Logout",
    "LOGOUT_BODY": "Are you sure you want to logout?",
    "CLIENT_ACCOUNT_INVITE": {
      "HEADER": "Accept your invitation",
      "DESCRIPTION": "You have been invited to join the <strong>{{clientAccount}}</strong> organisation. Please enter the following information to complete your profile.",
      "FIRST_NAME": "First Name",
      "LAST_NAME": "Last Name",
      "PASSWORD": "Password",
      "CONFIRM_PASSWORD": "Confirm Password",
      "PASSWORDS_MUST_MATCH": "Passwords must match",
      "CHANGE_PASSWORD": "Change Password",
      "CANCEL_PASSWORD_CHANGE": "Cancel Password Change",
      "SUBMIT": "Join Organisation",
      "SUCCESS": "Joined organisation successfully. Please login to continue"
    },
    "VERIFY_UPDATE_EMAIL": {
      "SUCCESS_TITLE": "Email update verified",
      "SUCCESS_DESC": "Your email address has been successfully updated.",
      "ERROR_TITLE": "Email update failed",
      "ERROR_DESC": "There was a problem verifying your email update.",
      "GO_TO_ACCOUNT": "Go to Account"
    }
  },
  "NAVIGATION": {
    "LABEL": {
      "CAMPAIGN": "Campaign",
      "ORGANIZATION": "Organisation",
      "ORGANIZATIONS": "Organisations",
      "STAFF": "Staff",
      "DISTRIBUTOR": "Distributor",
      "HELP": "Help",
      "ACCOUNT": "Account",
      "ANNOUNCEMENTS": "Alerts"
    }
  },
  "SIDENAV": {
    "HINTS": {
      "UNPAID_INVOICES": "{{unpaid_count}} Unpaid Invoices"
    },
    "HEADER": {
      "VIEW_CAMPAIGN": "View Campaign",
      "SHARE": "Share",
      "COPY_URL": "Copy URL",
      "LINK_COPIED": "Campaign URL Copied to Clipboard",
      "REGISTRATION_INSTRUCTIONS": "Registration Instructions",
      "TIME_LEFT": "Auction Closing in: {{timeLeft}}",
      "PROCESSING_LAST_BIDS": "Processing final bids..."
    },
    "LABEL": {
      "CAMPAIGN_LIST": "Campaign List",
      "RESOURCES": "Resources",
      "IOC_SHOP": "Extra Profit Items",
      "EXPERIENCES": "Experiences",
      "MEMORABILIA": "Ticketed Events",
      "AUCTION_LIST": "Campaign List",
      "SUMMARY": "Summary",
      "SETUP": "Setup",
      "SETUP_GUIDE": "Setup Guide",
      "GIFTAID": "Gift Aid",
      "GENERAL": "General",
      "PAYMENT": "Payment",
      "TAXES": "Taxes",
      "INVOICING": "Invoicing",
      "REGISTRATION": "Registration",
      "REGISTRATION_QUESTIONS": "Registration Questions",
      "MENU": "Menu",
      "INFOBOOTH": "Info Pages",
      "BRANDING": "Branding",
      "INFOBOOTH_SETTINGS": "Settings",
      "WIDGETS": "Widgets",
      "NEW_WIDGET_PAGE": "New Widget Page",
      "PROJECTOR_DISPLAYS": "Projector Displays",
      "CONTROLS": "Controls",
      "AUCTION_CONTROLS": "Auction Controls",
      "HOW_TO_REGISTER": "How to Register",
      "RAFFLE_CONTROLS": "Raffle Controls",
      "TICKETING_AND_CHECK_IN": "Ticketing & Check-In",
      "EVENT_DETAILS": "Event Details",
      "TICKETS": "Tickets",
      "CUSTOM_QUESTIONS": "Custom Questions",
      "QUESTIONS": "Questions",
      "TICKETING_QUESTIONS": "Ticketing Questions",
      "GUESTS": "Guests",
      "TICKET_PURCHASES": "Ticket Purchases",
      "ITEM": "Item",
      "ITEMS": "Items",
      "NEW_ITEM": "New Item",
      "BIDS_AND_BUYS": "Bids and Buys",
      "PARTICIPANTS": "Participants",
      "TEAMS": "Teams",
      "VOLUNTEERS": "Volunteers",
      "TABLES": "Tables",
      "COMMUNICATION": "Communication",
      "NOTIFICATIONS": "Notifications",
      "COMMENT_FEED": "Comment Feed",
      "REPORTS": "Reports",
      "USEFUL_DOCUMENTS": "Useful Documents",
      "CHECKOUT_CONSOLE": "Checkout Console",
      "CHECKOUT": "Checkout",
      "CHECKOUT_BADGE": "{{unpaid_count}} Unpaid",
      "PAYMENTS": "Payments",
      "VOUCHERS": "Vouchers",
      "INVOICE_LIST": "Invoice List",
      "BULK_UPDATE": "Bulk Update",
      "CATEGORIES": "Categories",
      "QUESTION_LIBRARY": "Question Library",
      "DISCOUNT_CODES": "Discount Codes"
    }
  },
  "ACCOUNT": {
    "TITLE": "My Account",
    "MULTI_FACTOR_SUBTITLE": "Provides a one-time password using an authenticator app.",
    "RESET_PASSWORD": "Change Password",
    "RESET_PASSWORD_SUCCESS": "Your password has been updated",
    "UPDATE_SUCCESS": "Your account details have been updated",
    "UPDATE_EMAIL": "Update Email",
    "UPDATE_EMAIL_SUCCESS": "You will receive an email to verify your new email address",
    "SUBMIT": "Save Details",
    "DETAILS_FORM": {
      "PLEASE_VERIFY": "Please verify your email",
      "CLICK_HERE_TO_VERIFY": "Click here to resend the verification email",
      "RESEND_VREIFY_EMAIL_SUCCESS": "Verification email resent",
      "FIRST_NAME": "First Name",
      "LAST_NAME": "Last Name",
      "EMAIL": "Email",
      "OLD_PASSWORD": "Old Password",
      "NEW_PASSWORD": "New Password",
      "CONFIRM_PASSWORD": "Confirm New Password",
      "SUBMIT": "Submit",
      "PW_NO_MATCH": "Password and confirm password don't match",
      "MFA_PWD": "Multi-Factor Password",
      "MFA_PWD_DESC": "Provides a one-time password using an authenticator app.",
      "MFA_ENABLE_SUCCESS": "Multi-Factor Authentication Enabled successfully",
      "MFA_DISABLE_SUCCESS": "Multi-Factor Authentication Disabled successfully"
    },
    "MFA_DIALOG": {
      "ENABLE_TITLE": "Enable Multi-Factor Authentication",
      "DISABLE_TITLE": "Disable Multi-Factor Authentication",
      "DESC": "Provides Multi-Factor authentication using codes generated by the authenticator App.",
      "STORE_LINK": "Link to download Google Authenticator app from the App Store or Google Play.",
      "STEP_1": "<b>Step 1</b>: Open the authenticator app.",
      "STEP_2": "<b>Step 2</b>: Scan the QR code or enter ",
      "STEP_3": "<b>Step 3</b>: Enter the generated code.",
      "MFA_CODE": "Enter the 6-digit code that you see in the app",
      "VERIFY": "Verify",
      "DISABLE_DESC": "Would you like to disable the Multi-Factor Authentication?",
      "DISABLE_WARNING": "*After disabling, please remove the account from your authenticator app.",
      "DISABLE": "Disable",
      "ENABLE": "Enable",
      "MFA_CODE_LENGTH": "The code must be 6 digits long"
    },
    "UPDATE_EMAIL_DIALOG": {
      "TITLE": "Update Email",
      "NEW_EMAIL": "New Email",
      "SUBMIT": "Update Email",
      "CANCEL": "Cancel",
      "NEW_EMAIL_LABEL": "Enter your new email address",
      "EMAIL_UPDATED_SUCCESS": "Email updated successfully. Please check your inbox for a verification email.",
      "EMAIL_UPDATED_ERROR": "There was an error updating your email address",
      "INVALID_EMAIL": "Please enter a valid email address",
      "EMAIL_REQUIRED": "Email is required"
    }
  },
  "SETTINGS": {
    "GIFTAID": {
      "TITLE": "Customise Gift Aid",
      "ENABLE": "Enable Gift Aid",
      "GIFT_AID_TITLE": "Gift Aid Title",
      "DESCRIPTION": "Description",
      "CHECKBOX_TEXT": "Checkbox Text",
      "ADDRESS_PLACEHOLDER": "Address Placeholder",
      "CONFIRM_BUTTON_LABEL": "Confirm Button Label",
      "UPDATE_GIFTAID_SUCCESS": "Gift Aid Updated",
      "GIFT_AID_DEFAULT_ADDRESS": "Enter your Address here",
      "GIFT_AID_DEFAULT_CHECKBOX": "I am eligible for Gift Aid",
      "GIFT_AID_DEFAULT_TITLE": "Gift Aid",
      "GIFT_AID_DEFAULT_DESCRIPTION": "If you are a UK taxpayer and pay more than your donation amount in tax annually, complete the information below to increase your donation by 25% at no extra cost with Gift Aid.",
      "GIFT_AID_DEFAULT_CONFIRM": "+ 25% Free"
    },
    "GENERAL": {
      "DONT_REUSE": "Do not reuse existing campaigns for new fundraising campaigns.",
      "DONT_REUSE_YOU_CAN": "You can ",
      "DONT_REUSE_CLONE": "clone ",
      "DONT_REUSE_THIS": "this campaign or ",
      "DONT_REUSE_CREATE": "create a new one.",
      "CLONE": "Clone",
      "NEW_CAMPAIGN": "New Campaign",
      "NO_COUNTRY": "Can't find your country?",
      "CONTACT_US": "Contact Us",
      "TIMEZONE": "Timezone",
      "ORGANIZATION": "Organisation",
      "TITLE": "Edit Campaign Details",
      "NAME": "Campaign Name",
      "URL": "Campaign URL",
      "COUNTRY": "Country",
      "CURRENCY": "Currency",
      "TARGET": "Target",
      "TARGET_HINT": "The amount of money you are hoping to raise",
      "DONATION_TARGET_HINT": "The amount of money you are hoping to raise from donations",
      "DONATION_TARGET": "Donation Target",
      "BASE_TOTAL_RAISED": "Base total raised",
      "BASE_TOTAL_RAISED_HINT": "The amount here will be added to the total raised figure displayed around the app and projectors",
      "ENABLE_SMS": "Enable SMS",
      "ENABLE_EMAIL": "Enable email",
      "ENABLE_EMAIL_HINT": "Disable to prevent this campaign from sending emails to participants",
      "SMS_SERVICE": "Sms Service",
      "ENABLE_SMS_HINT": "Allow SMS messages such as outbid warnings to be sent to participants",
      "SMS_NUMBER": "SMS Number",
      "SMS_NUMBER_HINT": "Select an SMS provider. All messages will be sent to and from this number",
      "TIPPING_CALLOUT_ENABLED": "Show Tipping Message",
      "TIPPING_CALLOUT_ENABLED_HINT": "Allow Tipping Message to be shown to participants",
      "TIPPING_CALLOUT_TEXT": "Tipping Message",
      "TIPPING_CALLOUT_TEXT_HINT": "The tipping message to be shown to participants",
      "NAME_HINT": "The name to be shown across your site",
      "URL_HINT": "Participants will enter this URL to access the campaign",
      "COUNTRY_HINT": "The country your campaign will be held in",
      "TIMEZONE_HINT": "The timezone in which all campaign times will be displayed",
      "CURRENCY_HINT": "The currency used to display prices and for payments",
      "TIMEZONE_CHANGED_WARNING": "Changing the timezone may affect your auction's scheduled open/close times and scheduled notifications",
      "COMMENT_FEED_ENABLED": "Enable comment feed",
      "COMMENT_FEED_ENABLED_HINT": "Participants can write comments and messages for the event",
      "ITEM_ACTIVITY_FEED_VISIBILITY": "Enable item activity feed",
      "ITEM_ACTIVITY_FEED_VISIBILITY_HINT": "Display names and amounts of the recent bids/donations/buys on each item",
      "BID_NOTIFICAITONS_ENABLED": "Enable bid notifications",
      "BID_NOTIFICAITONS_ENABLED_HINT": "Participants can get notifications for new bids",
      "DONATION_NOTIFICATIONS_ENABLED": "Enable donation notifications",
      "DONATION_NOTIFICATIONS_ENABLED_HINT": "Notify participants when donations are made",
      "PURCHASE_NOTIFICATIONS_ENABLED": "Enable purchase notifications",
      "PURCHASE_NOTIFICATIONS_ENABLED_HINT": "Notify participants when items are purchased",
      "RAFFLE_NOTIFICATIONS_ENABLED": "Enable raffle notifications",
      "RAFFLE_NOTIFICATIONS_ENABLED_HINT": "Notify participants when a raffle purchases occurs",
      "CHECKOUT_PROMT_ENABLED": "Enable checkout prompt",
      "CHECKOUT_PROMT_ENABLED_HINT": "Prompt participants to checkout at end of event",
      "INCLUDE_TICKET_SALES_IN_TOTAL_RAISED": "Add ticket sales to the Total Raised",
      "INCLUDE_TICKET_SALES_IN_TOTAL_RAISED_HINT": "When enabled, the \"Total Raised\" amount in the projector and the app's side menu will include event ticket sales",
      "ENABLE_EVENT_TICKETS_PREVIEW": "Enable event tickets preview",
      "ENABLE_EVENT_TICKETS_PREVIEW_HINT": "Display a preview of event tickets in the Item List",
      "PADDLE_NUMBERS_ENABLED": "Enable paddle numbers",
      "PADDLE_NUMBERS_ENABLED_HINT": "When enabled additional features to run a paddle raise pledge drive will be available",
      "PADDLE_NUMBER_REQUIRE_LINKED_PAYMENT_METHOD": "Require linked payment method",
      "PADDLE_NUMBER_REQUIRE_LINKED_PAYMENT_METHOD_HINT": "When enabled, a guest will not be able to be assigned a paddle number without a payment method linked to their account",
      "PADDLE_START_NUMBER": "Paddle start number",
      "PADDLE_START_NUMBER_HINT": "The number that the first paddle in this campaign will be assigned. Subsequent paddles will automatically follow in sequence.",
      "BIDDING_ITEM_ENABLED": "Enable auction items",
      "BIDDING_ITEM_ENABLED_HINT": "Allow creation and management of auction (bidding) items.",
      "DONATION_ITEM_ENABLED": "Enable donation items",
      "DONATION_ITEM_ENABLED_HINT": "Allow creation and management of donation items.",
      "PURCHASE_ITEM_ENABLED": "Enable buy-now items",
      "PURCHASE_ITEM_ENABLED_HINT": "Allow creation and management of buy-now (purchase) items.",
      "RAFFLE_ITEM_ENABLED": "Enable raffle items",
      "RAFFLE_ITEM_ENABLED_HINT": "Allow creation and management of raffle items.",
      "PRE_BIDDING_ENABLED": "Enable pre-bidding",
      "PRE_BIDDING_ENABLED_HINT": "Allow non-staff admins to disable and enable pre-bidding on live auction items. Non-saas admins will always be able to enable and disable pre-bidding.",
      "ENABLE_SETUP_GUIDE": "Enable Setup Guide",
      "ENABLE_SETUP_GUIDE_HINT": "Allow the setup guide to be shown",
      "ENABLE_AI_ASSISTANT": "Enable AI Assistant",
      "ENABLE_AI_ASSISTANT_HINT": "Allow the AI assistant to be shown in the setup guide",
      "ENABLE_BULK_INVITE": "Enable Bulk Invite",
      "ENABLE_BULK_INVITE_HINT": "Allow admins to bulk invite participants via spreadsheet (email registration only)",
      "TICKETING_ENABLED": "Enable ticketing",
      "TICKETING_ENABLED_HINT": "If turned off, event tickets cannot be created by admins and ticketed guests cannot be checked in",
      "RAFFLE_ITEMS_ADMIN_REFUND_ALLOWED": "Allow admins to refund raffle purchases",
      "RAFFLE_ITEMS_ADMIN_REFUND_ALLOWED_HINT": "If turned off, admins cannot refund raffle purchases",
      "ADD_IOC_COST_ENABLED": "Add the IOC cost to the Total Raised",
      "ADD_IOC_COST_ENABLED_HINT": "When enabled, the \"Total Raised\" amount in the projector and the app's side menu will include IOC costs",
      "PARTICIPANTS_REGISTRATION_OPTIONS": "Participants Registration Options",
      "PARTICIPANTS_REGISTRATION_OPTIONS_WARNING": "Registration must be Email for ticketing enabled campaigns",
      "ADDITIONAL_REGISTRATION": "Additional Login/Registration Methods",
      "ENABLE_CHECKBOX_FACEBOOK": "Enable Facebook Login",
      "ENABLE_CHECKBOX_GOOGLE": "Enable Google Login",
      "TEAM_SCORING": "Team Scoring",
      "TEAM_WARNING": "Please ensure you have created teams to use this feature",
      "GO_TO_TEAM_SETTINGS": "Team Settings",
      "OFF": "Off",
      "OPTIONAL": "Optional",
      "REQUIRED": "Required",
      "DISABLE_AUCTION": "Disable Campaign",
      "DISABLE_AUCTION_WARNING": "If you suspect this campaign is fraudulent then you may disable it to prevent further activity.",
      "ENABLE_AUCTION": "Enable Campaign",
      "ENABLE_AUCTION_WARNING": "This campaign is currently disabled. Enable it to allow new activity from participants.",
      "ARCHIVE_AUCTION": "Archive Campaign",
      "ARCHIVE_AUCTION_HINT": "Archive this campaign to make it inaccessible to admins and participants. Archived campaigns can be restored for 2 weeks.",
      "ARCHIVE_AUCTION_SUCCESS": "Campaign archived successfully",
      "ARCHIVE_AUCTION_ALREADY_HIDDEN": "This campaign was <b>hidden on {{hide_date}}</b> and will be <b>deleted on {{delete_date}}</b>",
      "METADATA": "Metadata",
      "METADATA_DESC": "Define custom key-value pairs to include in webhook payloads",
      "METADATA_BUTTON": "Manage Metadata",
      "EDIT_METADATA_DIALOG": {
        "TITLE": "Campaign Metadata",
        "BODY": "Add up to {{0}}{{limit}}{{1}} custom key-value pairs to webhook payloads for this campaign. Each key must be unique.",
        "KEY": "Key",
        "VALUE": "Value",
        "ERROR_REQUIRED": "Both metadata key and value are required",
        "ERROR_DUPLICATE_KEY": "A metadata entry with this key already exists",
        "ERROR_INVALID": "Please fix errors in the table before saving"
      },
      "ENABLE_TICKETING_CONFIRMATION_DIALOG": {
        "TITLE": "Enable Ticketing",
        "BODY": "Enabling ticketing will disable phone registration for this campaign. Do you want to continue?",
        "OK": "Continue"
      },
      "DISABLE_AUCTION_CONFIRMATION_DIALOG": {
        "TITLE": "Disable Campaign",
        "BODY": "Are you sure you want to disable this campaign? This will prevent any further activity from participants.",
        "OK": "Disable"
      },
      "ENABLE_AUCTION_CONFIRMATION_DIALOG": {
        "TITLE": "Enable Campaign",
        "BODY": "Are you sure you want to enable this campaign? This will allow new activity from participants.",
        "OK": "Enable"
      },
      "ARCHIVE_AUCTION_CONFIRMATION_DIALOG": {
        "TITLE": "Archive Campaign",
        "BODY": "Are you sure you want to archive this campaign? This will make it inaccessible to admins and participants, but staff can access and restore it within 2 weeks before it is deleted.",
        "OK": "Archive"
      },
      "SECTION": {
        "GENERAL_DETAILS": "General Details",
        "DATE_TIME": "Date & Time",
        "LOCATION": "Location"
      },
      "PARTICIPANTS_REGISTRATION_OPTIONS_VALUES": {
        "EMAIL": "Email",
        "PHONE_NUMBER": "Phone Number",
        "EMAIL_AND_PHONE": "Email and Phone Number"
      },
      "AUCTION_OPEN_DATE_TIME": "Auction Open Date/Time",
      "AUCTION_CLOSE_DATE_TIME": "Auction Close Date/Time",
      "EDIT_AUCTION_DATES_BUTTON": "Edit in Auction Controls",
      "EVENT_START_DATE_TIME": "Event Start Date/Time",
      "EVENT_END_DATE_TIME": "Event End Date/Time",
      "EVENT_DATE_WARNING": "<strong>Note:</strong> Changes to the event date will trigger a notification to be sent to all ticket holders on save.",
      "DATE_RANGE_ERROR": "Both start date and end date must be provided together, or leave both empty.",
      "LOCATION": {
        "ADDRESS": "Address",
        "ONLINE": "Online",
        "HYBRID": "Hybrid",
        "TO_BE_ANNOUNCED": "To be announced"
      },
      "EVENT_LOCATION": "Event Location",
      "EVENT_LOCATION_PLACEHOLDER": "Enter event location",
      "EVENT_LOCATION_WARNING": "<strong>Note:</strong> Changes to the event location will trigger a notification to be sent to all ticket holders on save.",
      "EVENT_EXPECTED_GUESTS_COUNT": "Expected Number of Guests"
    },
    "MENU": {
      "TITLE": "Customise Campaign Menu",
      "DESCRIPTION": "Here you can customise the main menu of your campaign. You can choose which buttons will be shown, add custom buttons, change their text, and change their order.",
      "DESCRIPTION_2": "You will need to create widget pages, info pages, items, and categories before you can add them as menu buttons.",
      "HOMEPAGE": "Homepage",
      "HOMEPAGE_HINT": "The homepage is the item list by default. You can also select a widgets or info page if you have created one.",
      "BUTTON_TYPE": "Button Type",
      "CREATE": "Add Menu Item",
      "DEFAULT_PAGES": "Default Pages",
      "WIDGET_PAGES": "Widget Pages",
      "HUBS": "Classic Widget Pages",
      "INFO_PAGES": "Info Pages",
      "EVENT_TICKETS": "Event Tickets",
      "ITEM_LIST": "Item List",
      "BUTTON_TYPE_LABEL": {
        "TICKETING": "Event Tickets",
        "TOTAL_RAISED": "Total Raised",
        "FAVOURITE_ITEMS": "Favourite Items",
        "COMMENT_FEED": "Comment Feed",
        "ITEM_TYPE": "Item Type",
        "ITEM": "Item",
        "CATEGORIES": "Categories",
        "CATEGORY": "Category",
        "ALL_ITEMS": "All Items",
        "MY_ACCOUNT": "My Account",
        "CONTACT_ORGANIZER": "Contact Organiser",
        "HUB": "Classic Widget Page",
        "WIDGET_PAGE": "Widget Page",
        "INFOBOOTH": "Info Page",
        "EXTERNAL_LINK": "External Link",
        "CONTACT_HOST": "Contact Host"
      },
      "DISABLED_BUTTON_MESSAGE": "This button type cannot be removed. Set its visibility to 'Hidden' to remove it from the menu.",
      "MENU_ITEM_CREATE_SUCCESS": "Menu Item Created",
      "MENU_ITEM_UPDATE_SUCCESS": "Menu Item Updated",
      "MENU_ITEM_DELETE_SUCCESS": "Menu Item Deleted",
      "CONFIRM_DELETE_TITLE": "Delete Menu Item",
      "CONFIRM_DELETE_BODY": "Are you sure you would like to delete this menu item? This action is irreversible",
      "CONFIRM_DELETE_CONFIRM": "Delete",
      "CONFIRM_DELETE_CANCEL": "Cancel",
      "REORDER_SUCCESS": "Ordering saved",
      "EDIT": {
        "NO_ITEMS_FOUND": "No items found",
        "EDIT_ICON": "Change Icon",
        "TITLE": "Menu Option Details",
        "SUBMIT": "Done",
        "LABEL": "Label",
        "BUTTON_TYPE": "Section Type",
        "VISIBILITY": "Visible",
        "ICON": "Icon",
        "ICON_SEARCH_LABEL": "Search Icons",
        "INFOBOOTH": "Select Info Page",
        "HUB": "Select Classic Widget Page",
        "WIDGET_PAGE": "Select Widget Page",
        "CATEGORY": "Select Category",
        "ITEM": "Link to Item",
        "EXTERNAL_LINK": "Link URL",
        "OPEN_NEW_TAB": "Open In New Tab",
        "URL": "Url",
        "ITEM_TYPE": "Item Type: {{item_type}}"
      },
      "LINK_COPIED": "Menu Page Link Copied"
    },
    "INVOICING": {
      "SAVE_AND_PREVIEW": "Save and Preview",
      "WARNING": "Add your invoice details",
      "TITLE": "Campaign Taxes/Fees",
      "INVOICE_DETAILS": "Invoice Details",
      "DESCRIPTION_1": "Here, you can specify a tax/fee to be applied at the point of payment.",
      "DESCRIPTION_2": "To ensure the tax/fee is applied, it must also be enabled for the item. This can be done in the item edit form, by clicking the 'Apply Now' button in the taxes table, or by selecting the 'Apply to new items' checkbox in the tax edit dialog.",
      "DESCRIPTION_3": "Note the tax/fee  must be enabled on auction items before bids placed in order to take effect.",
      "FORM": {
        "COMPANY_NAME": "Company Name",
        "STREET_ADDRESS": "Street Address",
        "SUBURB": "Suburb",
        "CITY": "City",
        "POST_CODE": "Postcode",
        "STATE": "State",
        "COUNTRY": "Country",
        "PHONE": "Phone",
        "EMAIL": "Email",
        "WEBSITE": "Website",
        "MORE_INFORMATION": "More Information",
        "BANK_DETAILS": "Bank Details",
        "FOOTER_MESSAGE": "Footer Message",
        "IMAGE": "Invoice Image",
        "USE_A_DIFFERENT_LOGO": "Use the auction logo on the invoice.",
        "UPLOAD_IMAGE": "Upload Invoice Image"
      }
    },
    "TAXES": {
      "EMPTY_STATE_TITLE": "No Taxes Yet",
      "EMPTY_STATE_SUBTITLE": "Add a new tax using the button below",
      "FORM": {
        "TAX_LABEL": "Label",
        "TAX_PERCENTAGE": "Tax rate (%)",
        "TAX_METHOD": "Tax Method",
        "TAX_METHOD_ADD": "Add to subtotal",
        "TAX_METHOD_INCLUDE": "Include in subtotal",
        "APPLY_TO_NEW_ITEMS": "Apply to new items",
        "APPLY_TO_NEW_ITEMS_HINT": "Apply this tax automatically to all the new items created",
        "APPLY_TO_EXISTING_ITEMS": "Apply to existing items",
        "APPLY_TO_EXISTING_ITEMS_HINT": "Apply this tax automatically to all the existing items",
        "APPLY_NOW": "Apply Now",
        "APPLY_NOW_CONFIRM_TITLE": "Apply Tax to All Items",
        "APPLY_NOW_CONFIRM_DESC": "Are you sure you want to apply this tax to all the current items? This will overwrite any existing tax applied before.",
        "APPLY_NOW_YES": "Apply",
        "APPLY_SUCCESS": "Tax applied to all items successfully",
        "AUTO_APPLY_WARNING_TITLE": "Apply to new items Warning",
        "AUTO_APPLY_WARNING_DESC": "If you set this tax to apply to all new items, any other tax with apply enabled will be now disabled. Are you sure you want to continue?",
        "DELETE_TAX_CONFIRM_TITLE": "Delete Tax",
        "DELETE_TAX_CONFIRM_DESC": "Are you sure you want to delete this tax?",
        "DELETE_TAX_SUCCESS": "Tax deleted successfully",
        "EDIT_TAX": "Edit Tax",
        "EDIT_TAX_SUCCESS": "Tax updated successfully",
        "CREATE_TAX": "Add Tax",
        "CREATE_TAX_SUCCESS": "Tax added successfully"
      },
      "SAVING_ERROR": "Saving taxes failed",
      "LOADING_ERROR": "Loading taxes failed",
      "ADD_NEW_TAX": "Add New Tax"
    },
    "PAYMENTS": {
      "ADD_CARD_DIALOG": {
        "NO_PAYMENT_METHODS": "No payment methods",
        "TITLE": "{{profileName}}'s  Payment Methods",
        "TITLE_NO_NAME": "Payment Methods",
        "DELETE_CARD": "Delete",
        "ADD_CARD": "Add Card"
      },
      "PAYMENT_DONATION": {
        "TITLE": "Payment Donation",
        "DESCRIPTION": "When enabled, participants will be asked to make a donation to your cause during the payment process.",
        "DISABLED_MESSAGE": "Payment donation cannot be enabled when tipping is active.",
        "DONATION_COMPONENT": "Donation Component",
        "SLIDER": "Slider",
        "BUTTONS": "Buttons"
      },
      "TIP_CONFIG": {
        "TIP_CHOICE": "Tip Choice (%)",
        "ADD_TIP_CHOICE": "Add Tip Choice",
        "SOFTWARE_FEE": "Software Fee (%)",
        "DEFAULT_TIPPING_FEE": "Default Tipping Fee Option (%)",
        "TITLE": "Auction Tip Configuration",
        "COMMISSION_ENABLED": "Enable GalaBid Commission",
        "COMMISSION_ENABLED_HINT": "It will charge a percentage of each payment.",
        "TIP_ENABLED": "Enable Tipping Fee",
        "TIP_ENABLED_HINT": "At payment, participants will be asked to add a GalaBid Tip."
      },
      "TIP_REVENUE_SHARE_PERCENTAGE": "Tipping Revenue Share Percentage (%)",
      "NO_STRIPE_WARNING": "You must create or connect a Stripe account to accept online card payments.",
      "SAAS_NO_STRIPE_WARNING": "Please set up payment settings so that you can process incoming funds.",
      "POWERED_BY": "Powered By",
      "TITLE": "Payment Settings",
      "DESCRIPTION": "All campaign payments must be processed by Stripe. Connect an existing Stripe account or easily create a new one. A mandatory or optional additional fee can be added to all participants' invoices to cover Stripe's transaction fees. To add these fees follow the instructions in this <a href='https://help.galabid.com/fundraising-help-center/article/how-can-i-add-a-fee-service-fee-to-cover-transaction-costs-etc/' target='_blank'>help article</a>. Please contact <a href='mailto:helpdesk@galabid.com' target='_blank'>helpdesk@galabid.com</a> for more information.",
      "HELP_SAAS_EXPRESS": "To start accepting online payments we'll need some more details from you.",
      "CLEAR_PAYMENT_SETTINGS": "Clear payment settings",
      "STRIPE_ACCOUNT": "Stripe Account",
      "SEARCH_BY_NAME": "Search by name...",
      "NO_RESULTS": "No Stripe Accounts found",
      "DETECTED_DEFAULT_PAYMENT": "We've detected default payment settings in your organisation, apply them now.",
      "APPLY_DEFAULT_PAYMENT": "Apply Default Payment Settings",
      "SUPER_LOW_FIXED_FEE": "Super Low Fixed Percentage Fee",
      "PAYMENT_METHODS_TABLE_TITLE": "Payment Methods",
      "ADD_PAYMENT_METHOD": "Add payment method",
      "NAME": "Name",
      "FLAT_FEE": "Flat Fee",
      "PERCENTAGE_FEE": "Percentage Fee",
      "FEE_METHOD": "How should fee be applied?",
      "CHARGES_ENABLED": "Charges Enabled",
      "PAYOUTS_ENABLED": "Payouts Enabled",
      "CHARGES_DISABLED": "Charges Disabled",
      "PAYOUTS_DISABLED": "Payouts Disabled",
      "CONNECT_DISABLED": "Account Disabled",
      "DETAILS_NEEDED": "Additional details required to accept payments",
      "REQUIREMENTS": "Please review your Stripe account. Additional information is required now or in the future to maintain access to all account capabilities.",
      "GO_TO_STRIPE": "Go to Stripe",
      "HELP_ARTICLE": "Check Out Help Article",
      "COUNTRY": "COUNTRY",
      "LOGIN_TO_STRIPE": "Login to Stripe",
      "CREATE_STRIPE_ACCOUNT": "Create Stripe account",
      "STRIPE_EXPRESS_UPDATE_PAYMENT_DETAILS": "Update payment details",
      "STRIPE_EXPRESS_CONNECT": "Connect Express Stripe account",
      "STRIPE_STANDARD_CONNECT": "Connect Stripe account",
      "STRIPE_EXPRESS_RESTART": "Restart",
      "STRIPE_EXPRESS_CANCEL": "Cancel",
      "CREDIT_CARD_PREAUTH": "Credit Card Pre-Authorisation",
      "CREDIT_CARD_PREAUTH_RECOMMENDED": "Recommended",
      "CREDIT_CARD_PREAUTH_NON_SAAS": "When enabled, participants must provide payment details before participating in the campaign.",
      "CREDIT_CARD_PREAUTH_NON_SAAS_HINT": "Pre-authorised cards are NOT automatically charged when the campaign closes.",
      "CREDIT_CARD_PREAUTH_HINT_1": "Participants will be required to add a payment method. If notifications are enabled, participants with invoices owing are sent notifications to pay when the campaign closes.",
      "CREDIT_CARD_PREAUTH_HINT_1_LINK_TEXT": "Edit notification settings here",
      "CREDIT_CARD_PREAUTH_HINT_2": "Pre-authorised cards are NOT automatically charged when the campaign closes. Charge individual pre-authorised cards in the",
      "CREDIT_CARD_PREAUTH_HINT_2_LINK_TEXT": "Checkout Console",
      "CREDIT_CARD_PREAUTH_ACTIVITY_LABEL": "Bid/Buy/Donate",
      "CREDIT_CARD_PREAUTH_ACTIVITY_TOOLTIP": "Select this option if participants must provide a credit card when placing an activity, such as placing a bid or purchasing an item",
      "CREDIT_CARD_PREAUTH_REGISTRATION_LABEL": "Registration",
      "CREDIT_CARD_PREAUTH_REGISTRATION_TOOLTIP": "Select this option if participants must provide a credit card when registering for the campaign",
      "CREDIT_CARD_PREAUTH_BOTH_LABEL": "Both",
      "CREDIT_CARD_PREAUTH_BOTH_TOOLTIP": "Select this option to prompt participants for a credit card during registration (optional). If not provided, they must enter one when placing an activity",
      "PAYMENT_METHOD_EDIT_FEE_TYPE_OPT_NONE": "No fee",
      "PAYMENT_METHOD_EDIT_OPTIONAL_FEE_NA": "N/A",
      "PAYMENT_METHODS_LIST_NONE_WARNING": "No payment methods!",
      "PAYMENT_METHODS_LIST_NONE_DESCRIPTION": "No payments can be made unless a payment method is added.",
      "CONFIRM_REMOVE_PAYMENT_GATEWAY": "Remove Payment Provider",
      "CONFIRM_REMOVE_PAYMENT_GATEWAY_BODY": "Are you sure you wish to remove the payment provider for your campaign? Any items requiring instant payment will require a volunteer to complete payment for participants. This includes all raffle items and any items with Pay Now enabled.",
      "EDIT_FEE_DIALOG": {
        "ADD_PAYMENT_TITLE": "Add Payment Method",
        "TITLE": "Edit Payment Method",
        "EDIT_NAME": "Name",
        "EDIT_NAME_HINT": "The human-friendly name that will show in the app when participants are selecting a payment method.",
        "EDIT_PAYMENT_PROCESS": "Payment Process",
        "EDIT_PAYMENT_PROCESS_HINT": "The process this payment method uses to collect payments. Use \"Custom\" for payments outside of the GalaBid platform such as bank transfers, cash, etc.",
        "ONLINE_CARD_STRIPE": "Online Card (Stripe)",
        "MANUAL_CARD": "Manual Card",
        "CUSTOM": "Custom",
        "REQUEST_INVOICE": "Request Invoice",
        "REQUEST_INVOICE_WARNING": "This payment method is only available for ticketing purchases. To use it, you must enable invoice requests for the ticket types you want to offer it for.",
        "EDIT_FLAT_FEE": "Flat Fee Amount",
        "EDIT_FLAT_FEE_HINT": "A flat amount of money to charge as a fee on each payment using this method.",
        "EDIT_PERC_FEE": "Percentage Fee Amount",
        "EDIT_PERC_FEE_HINT": "A percentage of the payment amount to charge as a fee on payments using this method.",
        "EDIT_SERVICE_FEE_LABEL": "Service Fee Label",
        "EDIT_SERVICE_FEE_LABEL_HINT": "The label that will show in the app when participants see this fee being applied",
        "FEE_METHOD_1": "Optional for donations",
        "FEE_METHOD_1_HINT": "Participants can choose not to pay this fee when paying for a \"Pay Now\" donation, but must pay the fee for all other types of payments.",
        "FEE_METHOD_2": "Optional for all payments",
        "FEE_METHOD_2_HINT": "Participants can choose not to pay the fee if they do not wish to.",
        "FEE_METHOD_3": "Mandatory",
        "FEE_METHOD_3_HINT": "Participants must always pay the fee when using this payment method.",
        "APPLY_FEE_FINAL": "Apply Fee to Final Charge",
        "APPLY_FEE_FINAL_HINT": "Enabling this will take into consideration that increasing the final amount also increases the fee charged by the payment processor.",
        "PARTICIPANTS_CHECKBOX": "Participants can use this payment method",
        "PARTICIPANTS_CHECKBOX_HINT": "Participants will be able to select this payment method as an option while making payments on their own device.",
        "VOLUNTEERS_CHECKBOX": "Volunteers can use this payment method",
        "VOLUNTEERS_CHECKBOX_HINT": "Volunteers will be able to select this payment method as an option while making payments for participants.",
        "DONE": "Done",
        "NON_GUEST_WARNING": "This payment method is only available to volunteers and admins. Participants will not be able to use it.",
        "NON_GUEST_OR_VOLUNTEER_WARNING": "This payment method is only available to admins via the dashboard. Participants and volunteers will not be able to use it."
      },
      "CONFIRM_DELETE_TITLE": "Delete payment method",
      "CONFIRM_DELETE_BODY": "Are you sure you would like to delete this payment method? This action is irreversible",
      "CONFIRM_DELETE_CONFIRM": "Delete",
      "CONFIRM_DELETE_CANCEL": "Cancel",
      "GENERIC_ERROR": "An error occurred",
      "PAYMENT_UPDATE_SUCCESS": "Successfully updated payment method",
      "PAYMENT_ADD_SUCCESS": "Successfully added payment method",
      "PAYMENT_DELETE_SUCCESS": "Successfully deleted payment method",
      "ONLINE_PAYMENT_PROVIDER": {
        "TITLE": "Online Payment Provider",
        "NONE": "None",
        "NONE_EXTRA_INFO": "No online payment needed for this campaign.",
        "GALABID": "GalaBid Payments",
        "GALABID_EXTRA_INFO": "Online payment into our Australian bank account only. If you are an international client or would like more information, please contact your account manager. Please note that any payments will have a percentage transaction fee deducted from the reconciliation amount.",
        "STRIPE": "Stripe Payments",
        "STRIPE_EXTRA_INFO": "Online payment via your Stripe account."
      },
      "SELECT_COUNTRY": "Select Country"
    },
    "INFOBOOTH": {
      "TITLE": "Info Pages",
      "DESCRIPTION_1": "Info pages are simple pages you can use to display styled text, images, and videos to your participants.",
      "DESCRIPTION_2": "Info pages will not show in the campaign's side menu until you add them using the menu settings.",
      "GO_TO_MENU": "Go to Menu Settings.",
      "NAME": "Infopage Name",
      "NAME_TOOLTIP": "The info page's name will appear in the side menu as a button",
      "EDIT": "Edit Info Page",
      "CREATE": "Add Info Page",
      "INFOBOOTH_ERROR": "An error occurred",
      "INFOBOOTH_UPDATED_SUCCESS": "Info page updated",
      "INFOBOOTH_CREATE_SUCCESS": "Info page created",
      "CONFIRM_DELETE_TITLE": "Delete Info Page",
      "CONFIRM_DELETE_BODY": "Are you sure you would like to delete this info page? This action is irreversible",
      "CONFIRM_DELETE_CONFIRM": "Delete",
      "CONFIRM_DELETE_CANCEL": "Cancel",
      "INFOBOOTH_DELETE_SUCCESS": "Info page deleted"
    }
  },
  "CUSTOM_QUESTIONS": {
    "PHONE_CAPTURE_WARNING": "Want to collect phone numbers and allow participants to opt into SMS?",
    "ENABLE_PHONE": "Enable Phone",
    "EMAIL_CAPTURE_WARNING": "Want to collect email?",
    "ENABLE_EMAIL": "Enable Email",
    "DEFAULT_PARTICIPANT_FIELDS_INTRO": "By default, the participant is always asked:",
    "DEFAULT_TICKET_HOLDER_FIELDS_INTRO": "By default, the ticket holder is always asked:",
    "TICKET_PURCHASERS_REQUIRED_PREFIX": "Ticket purchasers will be required to answer the",
    "REGISTRATION_QUESTIONS_LINK": " registration questions",
    "FIRST_NAME": "First Name",
    "LAST_NAME": "Last Name",
    "NO_LINKED_FORMS": "No linked forms",
    "REQUIRED": "Required",
    "LABEL": "Label",
    "ADD_QUESTION": "Add Question",
    "QUESTION_LIBRARY_EMPTY_STATE_SUBTITLE": "Please add any additional questions you would like to ask participants",
    "EDIT_QUESTION": "Edit Question",
    "EDIT_TERMS_AND_CONDITIONS": "Edit Participant Terms & Conditions",
    "EDIT_TERMS_AND_CONDITIONS_SUBTITLE": "These are the terms your participants must agree to when registering for the campaign. Please ensure they accurately reflect your organisation's requirements.",
    "TNC_CONFIRM_RESET_TITLE": "Reset Terms & Conditions",
    "TNC_CONFIRM_RESET_BODY": "On Reset, your current Terms & Conditions will be replaced with the default text. Changes will only be applied after you click 'Save'.",
    "CREATE_NEW_WITH_LABEL_PREFIX": "Create a new question: ",
    "QUICK_SELECT": "Commonly Asked Questions",
    "DELETE_CONFIRM_TITLE": "Delete Question",
    "DELETE_CONFIRM_BODY": "Are you sure you would like to delete this question? This action is irreversible",
    "UNLINK_CONFIRM_TITLE": "Unlink Question",
    "UNLINK_CONFIRM_BODY": "Are you sure you would like to unlink this question?",
    "EVENT_TICKET_EMAIL_CONFIRM_TITLE": "Confirm change",
    "EVENT_TICKET_EMAIL_CONFIRM_BODY": "Removing or making email optional allows purchasers to assign tickets with only names. Note: If guest emails are not provided, tickets will be sent to the purchaser.",
    "DEFAULT": "Default Field",
    "TEXT": "Text",
    "CHECKBOX": "Checkbox",
    "MULTIPLE_CHOICE": "Multiple Choice",
    "MULTIPLE_SELECT": "Multiple Select",
    "MAX_OPTIONS_REACHED": "Maximum of {{limit}} options allowed",
    "ADDRESS": "Address",
    "COMPANY_NAME": "Company Name",
    "COMPANY_ADDRESS": "Company Address",
    "EMAIL": "Email",
    "PHONE_NUMBER": "Phone Number",
    "VIEW_SUPPORTED_SMS_COUNTRIES": "View supported SMS countries",
    "TERMS_AND_CONDITIONS": "Terms & Conditions",
    "TYPE": "Type",
    "QUESTION_DESCRIPTION": "Question Description",
    "QUESTION": "Question",
    "APPLY_QUESTION_TO": "Apply question to:",
    "ALL_TICKET_TYPES": "All ticket types",
    "SELECTED_TICKET": "Selected ticket types",
    "OPTIONS": "Options",
    "ADD_OPTION": "Add Option",
    "AT_LEAST_ONE_OPTION": "At least one option must be added",
    "CHECKED": "Checked",
    "UNCHECKED": "Unchecked",
    "LINKED_FORMS": "Linked Forms",
    "LINKED_FORMS_OPTIONS": {
      "REGISTRATION_FORM": "Registration Form",
      "TICKETING_FORM": "Ticketing Form",
      "BOTH": "Both",
      "REGISTRATION_FORM_HELP_TEXT": "Asked when participants register for the campaign",
      "TICKETING_FORM_HELP_TEXT": "Asked when participants accept or are assigned a ticket",
      "BOTH_HELP_TEXT": "Asked of all participants, whether they register for the campaign or accept a ticket",
      "NO_LINKED_FORMS_HELP_TEXT": "This question is not currently linked to any forms"
    },
    "UPDATED_SUCCESS": "Question Updated",
    "QUESTIONS_CREATE_SUCCESS": "Question Created",
    "QUESTIONS_DELETE_SUCCESS": "Question Deleted",
    "DUPLICATE_QUESTION_LABEL_ERROR": "The question '{{ question }}' already exists",
    "DELETE_DIALOG": {
      "DELETE_QUESTION_TITLE": "Delete Question",
      "UNLINK_QUESTION_TITLE": "Unlink Question",
      "DELETE_QUESTION_BODY": "Are you sure you want to permanently delete {{0}}\"{{question}}\"{{1}} from the {{target}}?",
      "UNLINK_QUESTION_BODY": "Are you sure you want to unlink {{0}}\"{{question}}\"{{1}} from the {{target}}?",
      "DELETE_QUESTION_CALLOUT": "This will delete this question and all associated responses. {{0}}This action cannot be undone.{{1}}",
      "DELETE_QUESTION_MULTI_FORM_CALLOUT": "This will remove this question from all forms and delete all associated responses. {{0}}This action cannot be undone.{{1}}",
      "UNLINK_QUESTION_CALLOUT": "This question remains in your Question Library and any other linked forms. To delete it permanently, go to the",
      "UNLINK_QUESTION_CALLOUT_LINK": "Question Library",
      "UNLINK": "Unlink",
      "TARGET_LABELS": {
        "ALL": "Question Library",
        "REGISTRATION": "Registration form",
        "TICKETING": "Ticketing form"
      }
    }
  },
  "SUPPORTED_SMS_COUNTRIES_DIALOG": {
    "TITLE": "Supported SMS Countries"
  },
  "PROJECTOR": {
    "CREATE_SUCCESS_MESSAGE": "Successfully created projector",
    "CREATE_SLIDE_SUCCESS_MESSAGE": "Successfully created slide",
    "UPDATE_PROJECTOR_SUCCESS": "Successfully updated projector",
    "EMPTY_STATE": "No Displays Yet",
    "EMPTY_STATE_SUBTITLE": "Set up a new display to enhance your presentations and meetings",
    "PAYMENT_REMINDER_MESSAGE": "Please set up payment settings so that you can process incoming funds.",
    "GO_TO_PAYMENT_SETTINGS": "Go to payment settings.",
    "TITLE": "Projector Displays",
    "DESCRIPTION": "Create, edit and launch big screen displays for your campaign here.",
    "ADD_PROJECTOR": "Add projector",
    "ADD_PROJECTOR_TEMPLATE": "Add projector template",
    "EDIT_PROJECTOR": "Edit projector",
    "ADD_SLIDE": "Add slide",
    "DUPLICATE_SLIDE": "Duplicate slide",
    "PROJECTOR_NAME": "Projector Name",
    "SLIDE_NAME": "Slide Name",
    "USE_TEMPLATE": "Use template",
    "PROJECTOR_URL": "URL",
    "TEMPLATES_TITLE": "Projector Templates",
    "NEW_TEMPLATES_TITLE": "New Projector Templates",
    "NEW_TEMPLATES_DESCRIPTION": "This is currently just for testing & demo purposes",
    "TEMPLATE_NAME": "Template Name",
    "TEMPLATE_DESCRIPTION": "Template Description",
    "DIST_WARNING": "Only client accounts under your distributor will have access to this template",
    "CONFIRM_DELETE_TITLE": "Delete Projector Template",
    "CONFIRM_DELETE_BODY": "Are you sure you would like to delete this projector template? This action is irreversible",
    "CONFIRM_DELETE_CONFIRM": "Delete",
    "CONFIRM_DELETE_CANCEL": "Cancel",
    "CONFIRM_DELETE_TITLE_PROJECTOR": "Delete Projector",
    "CONFIRM_DELETE_BODY_PROJECTOR": "Are you sure you would like to delete this projector? This action is irreversible",
    "CONFIRM_DELETE_TITLE_CONTAINER": "Delete Projector",
    "CONFIRM_DELETE_BODY_CONTAINER": "Are you sure you would like to delete this projector? This action is irreversible",
    "DELETE_SUCCESS_MESSAGE": "Successfully deleted projector template",
    "DELETE_SUCCESS_MESSAGE_P": "Successfully deleted projector",
    "GENERIC_ERROR": "An error occurred",
    "DONE": "Done",
    "PROJECTOR_TEMPLATE": "Projector Template",
    "COPY": "Copy",
    "COPIED_TO_CLIPBOARD": "Copied to clipboard",
    "TEMPLATE": {
      "SETTINGS": "Settings"
    }
  },
  "PROJECTOR_CONTAINER_DELETE_SUCCESS": "Projector Deleted",
  "AUCTION_CONTROLS": {
    "UPDATE_AUCTION_CLOSED_MESSAGE": "To customise the messages displayed when the auction is closed, go to ",
    "UPDATE_AUCTION_CLOSED_MESSAGE_BRANDING": "branding settings",
    "UNSAVED_CHANGES_DIALOG": {
      "TITLE": "You have unsaved changes",
      "BODY": "Would you like to continue closing the auction without saving?",
      "CANCEL": "Cancel",
      "CONTINUE": "Continue without saving"
    },
    "CONFIRM_OPEN_DIALOG": {
      "TITLE": "Confirm Open Auction",
      "SCHEDULE_TITLE": "Schedule Auction Open",
      "WARNING": "Reopening the auction may change the outcome for participants who have already been notified as winners.",
      "MESSAGE": "Please review the following before proceeding:",
      "SUBMIT": "Open Auction",
      "SCHEDULE_SUBMIT": "Continue",
      "BULLETS": {
        "WINNERS_NOTIFIED": "Winners have already been notified and could be outbid by other participants if the auction is reopened.",
        "WINNERS_PAID": "Winners may have already made payments; these will appear as a credit on their invoice until the auction is closed again, provided they are not outbid."
      }
    },
    "STATUS_CHANGES_DIALOG": {
      "TITLE": "Auction Status Log",
      "SCHEDULED_CHANGE": "Auction  <strong>scheduled {{label}} time</strong> set",
      "SCHEDULED_REMOVED": "Auction <strong>scheduled {{label}} time</strong> removed",
      "STATUS_CHANGED": "Auction status changed to",
      "BY": "by",
      "SYSTEM": "System",
      "OPEN": "open",
      "CLOSE": "close",
      "SCHEDULED": "Scheduled {{label}}",
      "EMPTY_STATE": "No status changes recorded yet"
    },
    "WARNING": "We recommend setting a time for your auction to close automatically",
    "OPEN": "Open",
    "PAUSED": "Paused",
    "CLOSED": "Closed",
    "CLOSING": "Closing",
    "HIDDEN": "Hidden",
    "AUCTION": {
      "OPEN": "Auction Open",
      "PAUSED": "Auction Paused",
      "CLOSED": "Auction Closed",
      "CLOSING": "Auction Closing",
      "HIDDEN": "Hidden"
    },
    "N/A": "N/A",
    "TITLE": "Auction Status",
    "VIEW_LOG": "View Status Log",
    "DESCRIPTION": "Use the below buttons to change the status of the auction items. This does not affect raffle, buy-it-now or live auction (locked) items.",
    "PAUSE_AUCTION": "Pause Auction",
    "PAUSE_AUCTION_DESC": "Participants will no longer be able to bid on auction items.",
    "PAUSE_AUCTION_DESC_CURRENT": "Participants can no longer bid on auction items.",
    "PAUSE_AUCTION_SUCCESS": "Paused auction successfully.",
    "OPEN_AUCTION": "Open Auction",
    "OPEN_AUCTION_DESC": "Participants will be able to bid on auction items.",
    "OPEN_AUCTION_DESC_CURRENT": "Participants can bid on auction items.",
    "OPEN_AUCTION_SUCCESS": "Opened auction successfully.",
    "CLOSE_AUCTION": "Close Auction",
    "CLOSE_AUCTION_DESC": "Participants will no longer be able to bid on auction items and auction winners will be selected. Winner invoices will be available for payment.",
    "CLOSE_AUCTION_DESC_CURRENT": "Participants are no longer able to bid on auction items and winners have been selected. Winner invoices are available for payment.",
    "CLOSE_AUCTION_SUCCESS": "Closed auction successfully.",
    "START_DATE": "Schedule open date & time",
    "CONFIRM_CLOSE_AUCTION": "Confirm Close Auction",
    "CONFIRM_CLOSE_AUCTION_TEXT": "Closing this auction is going to send notifications to everyone.<br><br>Do you really want to close and send notifications?",
    "CONFIRM_CLOSE_AUCTION_OK": "Confirm",
    "CONFIRM_CLOSE_AUCTION_CANCEL": "Cancel",
    "SEND_END_OF_AUCTION": "Send end of auction notifications on close",
    "SEND_END_OF_AUCTION_HINT": "Automatically send the end of auction notifications when the auction closes.",
    "CLOSE_DATE": "Schedule close date & time",
    "AUCTION_CLOSED_AT": "Auction Closed at: ",
    "OVERTIME": "Overtime",
    "ENABLE_OVERTIME": "Enable overtime",
    "ENABLE_OVERTIME_WARNING": "Set an auction close time to enable overtime",
    "OVERTIME_DURATION": "Overtime Duration (Seconds)",
    "OVERTIME_DURATION_HINT": "If enabled, the auction will only close when no bids have been placed for the overtime duration set above. Overtime will start again when a new bid is placed.",
    "AUCTION_PAUSED": "Auction Paused",
    "AUCTION_OPENED": "Auction Opened",
    "AUCTION_CLOSING": "Auction Closing in: ",
    "PLEASE_WAIT": "Please wait while we're checking the auction status...",
    "AUCTION_CLOSED": "Auction Closed",
    "TIMEZONE": "Timezone: ",
    "HOW_TO_REGISTER": {
      "TITLE": "How to Register for the campaign",
      "DESCRIPTION": "Once you have completed set up, send participants the instructions below to provide access to the campaign. The instructions can be copied and sent via email, SMS, social media or email.",
      "CARD_TITLE": "Register via Browser",
      "CARD_STEP_1": "Go to <b>{{campaign_link}}</b>",
      "CARD_STEP_2": "Click on the 'Register' button",
      "CARD_STEP_3": "Follow the instructions to complete registration.",
      "COPY": "Copy instructions",
      "COPIED_TO_CLIPBOARD": "Instructions copied to clipboard.",
      "VIEW": "View/Download QR code",
      "DIALOG_SHARE_QR": "Share this QR code to help new participants access the campaign",
      "SMS_HEADER": "Register via SMS",
      "SMS_STEP_1": "Send a text to {{smsService}} with the message “{{urlName}} Your Full Name”.",
      "SMS_STEP_2": "You will receive a link to complete your registration."
    },
    "ERRORS": {
      "START_DATE_SELECT": "Please select the auction start date & time",
      "END_DATE_SELECT": "Please select the auction close date & time",
      "START_DATE_LESS_THAN_FIVE_MINS": "Start date must be at least five minutes from now",
      "END_DATE_LESS_THAN_FIVE_MINS": "Close date must be at least five minutes from now",
      "END_DATE_BEFORE_START_DATE": "Close date must be after the start date"
    },
    "AUCTION_CLOSED_DIALOG": {
      "DESC": "The auction is no longer accepting bids. You can see all the invoices now, or check them later.",
      "SEE_INVOICES": "See Invoices",
      "LATER": "Later"
    },
    "SEND_EOA_DIALOG": {
      "TITLE": "Send End of Auction Messages",
      "DESC": "You many send End of Auction messages to any successful or unsuccessful participants in the auction by clicking \"Send\" below.",
      "PREVIEW_SUCCESSFUL": "Successful Bidders Message Preview",
      "PREVIEW_SUCCESSFUL_MESSAGE": "Congratulations Peter, you've won items 10, 42, 59, in the {{campaign_name}} auction. To view/pay your invoice for $100 please click the link https://galabid.com/s/ABC123",
      "PREVIEW_UNSUCCESSFUL": "Unsuccessful Bidders Message Preview",
      "PREVIEW_UNSUCCESSFUL_MESSAGE": "Hi Peter, thanks for taking part in the {{campaign_name}} auction. Unfortunately, your bids have not been successful.",
      "EDIT_MESSAGE": "Edit Messages",
      "SEND": "Send",
      "EOA_SUCCESS": "End of Auction messages sent successfully"
    }
  },
  "BIDS_AND_BUYS": {
    "EMPTY_STATE": "Nothing Here Yet",
    "EMPTY_STATE_SUBTITLE": "You'll see all the bids and purchases here once they start coming in",
    "SEARCH": "Search Bids and Buys",
    "TITLE": "Bids and Buys",
    "SHOW_ITEM_TYPES": "Show Item Types",
    "TABLE": {
      "IMAGE": "Image",
      "ITEM_CODE": "Item Code",
      "ITEM": "Item",
      "PARTICIPANT": "Participant",
      "AMOUNT": "Amount",
      "QUANTITY": "Qty",
      "UNITS_AVAILABLE": "Units Available",
      "CREATED": "Time/Date",
      "ITEM_TYPE": "Item Type",
      "AUTO_BID": "Auto Bid",
      "AUTO_BID_TOOLTIP": "System bid placed on participant's behalf when Max Bidding enabled",
      "MAX_BID": "Max Bid",
      "DELETE": "Delete {{item_name}}",
      "DELETE_CONFIRM_TEXT": "Are you sure you would like to delete this item activity? This action is irreversible.",
      "DELETE_WINNING_BID_TEXT": "Are you sure you would like to delete this item activity? This action is irreversible.<br><br>This is the highest bid on the item. When this bid is deleted this bidder will receive a notification. A second notification will be sent to the new highest bidder if there is one.<br>",
      "CONFIRM_SEND_NOTIFICATION": "Send deleted bid notification & Send new highest bidder notification",
      "DELETE_OK": "Delete",
      "DELETE_CANCEL": "Cancel",
      "REFUND": "Refund {{item_type}}",
      "REFUND_CONFIRM_TEXT": "This will delete the {{item_type}} and refund the participant. Are you sure you wish to continue?",
      "REFUND_OK": "Refund",
      "REFUND_CANCEL": "Cancel",
      "DELETE_SUCCESS": "Deleted successfully",
      "REFUND_SUCCESS": "Refunded successfully"
    },
    "DELETE_DIALOG": {
      "TITLE": "Delete Activity",
      "TITLE_REFUND": "Refund Activity",
      "MESSAGE": "This action will delete the activity and cannot be undone.",
      "MESSAGE_REFUND": "This action will delete the activity and issue a refund to the participant. This action cannot be undone.",
      "MESSAGE_WINNING_BID": "This is the highest bid on the item. Deleting it may result in a new highest bidder and cannot be undone.",
      "MESSAGE_WINNING_MAX_BID": "This is the highest bid on the item. Deleting it will also remove the related max bid and may result in a new highest bidder.",
      "MESSAGE_MAX_BID": "This is a system-placed auto-bid. Deleting it will also remove the related max bid and cannot be undone.",
      "RADIO_LABEL": "Please select the reason for deleting this activity:",
      "RADIO_OTHER_PLACEHOLDER": "Specify reason for deletion (e.g. Item description incorrect)",
      "NOTIFY_BIDDERS_LABEL": "Do you want to notify the bidder(s)?",
      "NOTIFY_BIDDERS_CHECKBOX": "Yes, send notifications",
      "DELETION_REASON": "Deleted \"{{itemName}}\" ({{amount}}). Reason: {{reason}}"
    }
  },
  "RAFFLE_CONTROLS": {
    "OPEN": "Open",
    "DRAWING": "Drawing",
    "CLOSED": "Closed",
    "LOCKED_PROMPT": {
      "TITLE": "Raffle Not Enabled",
      "DESCRIPTION": "Boost your fundraising with engaging raffles and effortless ticket management. Contact your account manager or reach out to us to activate raffles for your event.",
      "GO_BACK": "Go Back",
      "CONTACT_US": "Contact Us"
    },
    "EMPTY_STATE": "No Raffle Items",
    "EMPTY_STATE_SUBTITLE": "Create a new raffle item to start drawing winners",
    "TITLE": "Raffle Draw",
    "DESC": "Draw and view winners for your raffle items here.",
    "PROJECTOR_NOTE_1": "If you are showing the raffle draw on a ",
    "PROJECTOR_NOTE_LINK": "projector display",
    "PROJECTOR_NOTE_2": ", please ensure the display is visible before drawing the raffle.",
    "NO_RAFFLES": "You have no raffle items in your campaign.",
    "TABLE": {
      "CODE": "Code",
      "NAME": "Name",
      "STATUS": "Status",
      "WINNERS": "Winners Drawn",
      "TICKETS": "Tickets Purchased",
      "SHOW_RAFFLE_DRAW": "Show Raffle Draw"
    },
    "DRAW_DIALOG": {
      "NOTIFICATION_WARNING": "Each time raffle is drawn or redrawn the winner is automatically notified of their win.",
      "PROJECTOR_WARNING": "If you are showing the raffle draw on a projector display, please ensure the display is visible before drawing the raffle.",
      "BEING_DRAWN": "This raffle is being drawn and participants cannot purchase tickets at this time.",
      "OPEN": "Open for Purchase",
      "CONCLUDE": "Conclude Raffle",
      "CLOSE": "Close for Draw",
      "REOPEN": "Reopen for Draw",
      "PRIZE": "Prize",
      "WINNERS": "Winners",
      "WINNER": "Winner",
      "WINNERS_DRAWN": "{{actual}}/{{total}} winners drawn",
      "WINNER_ANONYMOUS": "Anonymous ({{name}})",
      "TICKET_NUMBER": "Ticket Number",
      "STATUS_MSG_CONCLUDED": "This raffle has completed its prize draw.",
      "STATUS_MSG_OPEN": "This raffle is open for ticket purchases. You will need to click \"Close For Draw\" to draw prizes.",
      "STATUS_MSG_DRAWING": "This raffle is being drawn and participants cannot purchase tickets at this time.",
      "DRAW": "Draw",
      "DRAW_ALL": "Draw All",
      "REDRAW": "Redraw",
      "DRAW_STATUS": "Status: {{draw_status}}",
      "DELETE_RAFFLE_DRAW_TITLE": "Delete Raffle Draw - {{winner_name}}",
      "DELETE_RAFFLE_DRAW_DESC": "Are you sure you want to delete this raffle draw? In case the notification was already sent, you must contact the participant.",
      "REDRAW_RAFFLE_TITLE": "Redraw Raffle - Prize {{prize}}",
      "REDRAW_RAFFLE_DESC": "Are you sure you want to redraw this raffle prize? The current winner will be notified of the redraw.",
      "BULK_DRAW_TITLE": "Draw All Prizes",
      "BULK_DRAW_DESC": "Are you sure you want to draw all remaining prizes? All winners will be notified of their win.",
      "BULK_DRAW_NOTE": "{{0}}Note:{{1}} If using a projector display, the Raffle Draw animation will only trigger for the final ticket drawn."
    },
    "WINNER_DIALOG": {
      "TITLE": "New Winner",
      "ANON": "Anonymous",
      "TICKET_NUM": "Ticket Number: {{ticket_num}}"
    },
    "BULK_WINNERS_DIALOG": {
      "TITLE": "New Winners",
      "PRIZE_LABEL": "Prize {{prize}}"
    },
    "CONFIRM": {
      "BEGIN_TITLE": "Begin Raffle Draw",
      "BEGIN_DESC": "You will be able to draw prizes for this raffle and participants will not be able to purchase raffle tickets.",
      "OK_TEXT": "Yes",
      "CANCEL_TEXT": "No",
      "OPEN_TITLE": "Open Raffle Ticket Purchases",
      "OPEN_DESC": "Participants will be able to purchase tickets for this raffle, and you will not be able to draw tickets until you close this raffle item again.",
      "OPEN_OK_TEXT": "Open for Purchase",
      "OPEN_CANCEL_TEXT": "Cancel",
      "CONCLUDE_TITLE": "Conclude Raffle",
      "CONCLUDE_DESC": "Once the raffle has been concluded no further prizes can be drawn. Would you like to send notifications to participants?",
      "CONCLUDE_OK_TEXT": "Send",
      "CONCLUDE_CANCEL_TEXT": "Don't Send"
    }
  },
  "EVENT_EDIT": {
    "SETUP_TITLE": "Do you want to sell tickets for your event? To get started, complete the form below.",
    "EDIT_TITLE": "Edit Event Details",
    "EDIT_WARNING": "<strong>Note:</strong> Changes to the event location or date will trigger a notification to be sent to all ticket holders on save.",
    "FORM": {
      "EVENT_NAME": "Event Name",
      "LOCATION": "Location",
      "LOCATION_PLACEHOLDER": "Search for a venue or address",
      "LOCATION_NOT_CONFIRMED": "Location not confirmed?",
      "SET_LOCATION_TBC": "Set location as \"TBC\"",
      "START_DATE": "Start Date/Time",
      "END_DATE": "End Date/Time",
      "EVENT_CAPACITY": "Event Capacity",
      "NO_VENUE_LIMIT": "No venue limit?",
      "SET_CAPACITY_UNLIMITED": "Set as unlimited",
      "HAS_VENUE_LIMIT": "Need to set a limit?",
      "ENTER_CAPACITY": "Enter capacity",
      "TICKETS_LABEL": "Tickets Label",
      "TICKETS_LABEL_HINT_TEXT": "The label which will be used to refer to tickets in your campaign",
      "TICKET_LABEL_OPTIONS": {
        "ADMISSIONS": "Admissions",
        "TICKETS": "Tickets",
        "SEATS": "Seats",
        "SPOTS": "Spots"
      },
      "ADDITIONAL_INFORMATION": "Additional Information",
      "ADDITIONAL_INFORMATION_HINT_TEXT": "Optionally enter additional details to include on the ticket (i.e. terms and conditions, parking)"
    }
  },
  "EVENT_TICKET_PURCHASES": {
    "SEARCH": "Purchaser or ticket name",
    "HIDE_REFUNDED": "Hide refunded",
    "PURCHASER": "Purchaser",
    "TICKET_NAME": "Ticket Name",
    "QUANTITY": "Qty",
    "TOTAL": "Total",
    "PURCHASE_DATE": "Purchase Date",
    "REFUND_DATE": "Refund Date",
    "PAYMENT_STATUS": "Payment Status",
    "PAID": "Paid",
    "UNPAID": "Unpaid",
    "MARK_AS_PAID_LABEL": "Mark as Paid",
    "REFUNDED": "Refunded",
    "CANCELLED": "Cancelled",
    "PAYMENT_PROCESS": "Payment Process",
    "PRICE": "Price",
    "SUBTOTAL": "Subtotal",
    "FEE": "Fee",
    "TAX": "Tax",
    "DISCOUNT": "Discount",
    "DISCOUNTED_QTY": "Discount Quantity",
    "DONATION": "Donation",
    "ACTIONS": "Actions",
    "PURCHASE_SUCCESS": "Purchase Successful",
    "DETAIL": {
      "TITLE": "Purchase Details - {{name}}",
      "INVOICE_REQUESTED_INFO_1": "This guest has requested an invoice. Once you've sent the invoice and received payment, you'll need to ",
      "INVOICE_REQUESTED_INFO_LINK": "mark as paid",
      "INVOICE_REQUESTED_INFO_2": " to issue the tickets.",
      "PAYMENT_PROCESS": "Payment Process",
      "DISCOUNT_APPLIED": "Discount Applied"
    },
    "REFUND": {
      "TITLE": "Refund Purchase",
      "DELETE_TICKETS": "Delete Tickets",
      "DESCRIPTION": "This will refund the purchaser ({{participant}}) and cancel the tickets for the below guest/s. Are you sure you wish to continue?",
      "REFUND_SUCCESS": "Purchase refunded successfully",
      "DELETE_SUCCESS": "Tickets deleted successfully",
      "CONFIRM": "Refund",
      "CANCEL": "Cancel",
      "DESCRIPTION_NO_TICKET_HOLDERS": "This will refund the purchaser ({{participant}}) and cancel the tickets. Are you sure you wish to continue?",
      "DELETE_TICKETS_ONLY_DESCRIPTION": "This will cancel the tickets for the below guest/s. Are you sure you wish to continue?",
      "DELETE_TICKETS_ONLY_NO_TICKET_HOLDERS": "This will cancel the tickets. Are you sure you wish to continue?"
    },
    "MARK_AS_PAID": {
      "TITLE": "Mark Purchase as Paid",
      "DESCRIPTION": "This will mark the purchase for <strong>{{participant}}</strong> as paid and issue the ticket/s. Are you sure you wish to continue?",
      "CONFIRM": "Mark as Paid",
      "SUCCESS": "Purchase marked as paid successfully"
    }
  },
  "EVENT_TICKET_PACKAGES": {
    "ADD_TICKET_TYPE": "Add Ticket Type",
    "EMPTY_STATE": "No Tickets Yet",
    "EMPTY_STATE_SUBTITLE": "Get started by adding a ticket type to purchase and attend your event",
    "WARNING_NOTIFICATION": "Tickets with purchases cannot be deleted",
    "GO_TO_PURCHASES": "Go to purchases",
    "CAPACITY_WARNING": "The event capacity has been reached. Tickets can no longer be purchased to prevent overbooking",
    "FINISH_SETTING_UP": "Please finish setting up your event details before creating tickets",
    "TICKET_TYPE": {
      "INDIVIDUAL": "Individual",
      "TABLE": "Table"
    },
    "PRICE_TYPE": {
      "PAID": "Paid",
      "FREE": "Free"
    },
    "LOCKED_PROMPT": {
      "TITLE": "Ticketing & Check-In Not Enabled",
      "DESCRIPTION": "Enhance your fundraising with streamlined ticket sales and check-in. Contact your account manager or reach out to us to enable this feature for your event.",
      "GO_BACK": "Go Back",
      "CONTACT_US": "Contact Us"
    },
    "LIST": {
      "NAME": "Name",
      "IMAGE": "Image",
      "ORDER": "Order",
      "TYPE": "Type",
      "PRICE": "Price",
      "VISIBILITY": "Visibility",
      "NUMBER_SOLD": "Number Sold",
      "REQUEST_INVOICE_TOTAL": "Number Pending",
      "LOCK": "Lock",
      "TAX": "Tax",
      "VISIBLE": "Visible",
      "HIDDEN": "Hidden",
      "CONFIRM_DELETE_TITLE": "Delete Ticket",
      "CONFIRM_DELETE_BODY": "Are you sure you would like to delete this ticket? This action is irreversible",
      "CONFIRM_DELETE_CONFIRM": "Delete",
      "CONFIRM_DELETE_CANCEL": "Cancel",
      "DELETE_SUCCESS": "Ticket Deleted",
      "PURCHASE": "Purchase"
    },
    "EDIT": {
      "BACK": "Tickets List",
      "GUEST_LIST_BACK": "Guest List",
      "CREATE_TITLE": "Add a new ticket type",
      "EDIT_TITLE": "Edit ticket",
      "NAME": "Ticket Title",
      "NAME_TOOLTIP": "Enter a name for the ticket type (i.e. General Admission)",
      "TICKET_TYPE_INDIVIDUAL_TOOLTIP": "Select this option if you are selling individual tickets (admission for one person)",
      "TICKET_TYPE_TABLE_TOOLTIP": "Select this option if you are selling a table (admission for multiple people)",
      "TICKET_TYPE_HAS_ACTIVITY": "Cannot change the ticket type as guests have already purchased tickets",
      "TICKETS_INCLUDED": "Tickets Included",
      "TICKETS_INCLUDED_TOOLTIP": "Enter the number of tickets included in the table",
      "TICKETS_INCLUDED_HAS_ACTIVITY": "Cannot change tickets included as guests have already purchased tickets",
      "PRICE": "Price",
      "PAID_TOOLTIP": "Select this option if ticket/table requires payment",
      "FREE_TOOLTIP": "Select this option if ticket/table is available at no cost",
      "PRICE_TOOLTIP": "Enter the price per ticket/table",
      "NUMBER_AVAILABLE": "Number of Tickets Available",
      "NUMBER_AVAILABLE_TABLE": "Number of Tables Available",
      "NUMBER_AVAILABLE_TOOLTIP": "Enter the total number of tickets/tables for sale",
      "MAXIMUM_PER_PERSON": "Maximum Per Person",
      "MAXIMUM_PER_PERSON_TOOLTIP": "Enter the maximum number of tickets/tables an individual can purchase",
      "REQUEST_INVOICE_ALLOWED": "Allow purchasers to request invoice",
      "REQUEST_INVOICE_ALLOWED_TOOLTIP": "Select this option to allow purchasers to request an invoice instead of paying immediately",
      "DESCRIPTION": "Ticket Description",
      "TAX": "Tax",
      "TAX_TOOLTIP": "Enter any applicable tax for the ticket",
      "ADMIN_PURCHASE_NOTIFICATION_ENABLED": "Receive purchase notifications",
      "ADMIN_PURCHASE_NOTIFICATION_ENABLED_TOOLTIP": "Send an automated email to all members in your organisation when this ticket is purchased",
      "HIDE_ON_UI": "Hide ticket on UI",
      "HIDE_ON_UI_TOOLTIP": "Select this option to hide the ticket in the user interface while it remains available for purchase with a direct link",
      "HIDE_NUMBER_AVAILABLE": "Hide number of tickets available",
      "HIDE_NUMBER_AVAILABLE_TOOLTIP": "Select this option to hide the number of tickets remaining from participants",
      "LINK_COPIED": "Ticket Link Copied to Clipboard",
      "LINK_UNAVAILABLE": "Shareable link will be available once ticket has been saved",
      "FILL_IMAGE": "Fill image box",
      "FILL_IMAGE_TOOLTIP": "Select this option to make the image cover the image box in the ticketing list",
      "LOCK_TYPE_NONE": "Everyone can purchase",
      "LOCK_TYPE_LOCKED": "No one can purchase",
      "LOCK_TYPE_NONE_TOOLTIP": "Select this option to make the ticket available for purchase",
      "LOCK_TYPE_LOCKED_TOOLTIP": "Select this option to lock the ticket from being purchased",
      "LOCK_MESSAGE": "Lock Message",
      "SHARE_FACEBOOK": "Share on Facebook",
      "SHARE_FACEBOOK_TOOLTIP": "Allow participants to share the ticket on Facebook",
      "SHARE_TWITTER": "Share on X",
      "SHARE_TWITTER_TOOLTIP": "Allow participants to share the ticket on X",
      "SHARE_LINK": "Share Link",
      "SHARE_LINK_TOOLTIP": "Provide a direct link for sharing the ticket",
      "CHOOSE_IMAGE": "Choose Ticket Images",
      "TICKET_IMAGES": "Ticket Images",
      "CREATE_SUCCESS": "Ticket Created",
      "UPDATE_SUCCESS": "Ticket Updated",
      "FAIR_MARKET_VALUE": "Fair Market Value",
      "FAIR_MARKET_VALUE_TOOLTIP": "Enter the fair market value of the ticket",
      "DISCOUNT_CODES": "Discount Codes",
      "DISCOUNT_CODES_NONE": "No discount codes linked to this ticket type",
      "DISCOUNT_CODES_READONLY_HINT": "Discount codes are managed from the Discount Codes section.",
      "MANAGE_DISCOUNT_CODES_BUTTON": "Manage Discount Codes",
      "DISCOUNT_CODE": "Discount Code",
      "DISCOUNT_TYPE": "Discount Type",
      "DISCOUNT_TYPE_PERCENTAGE": "Percentage",
      "DISCOUNT_TYPE_FLAT": "Flat Amount",
      "DISCOUNT_VALUE": "Discount Value",
      "ADD_DISCOUNT_CODE": "Add Discount Code"
    },
    "PURCHASE": {
      "TITLE": "Add Ticket Purchase",
      "STEP_LABEL_GUEST": "Guest",
      "STEP_LABEL_PURCHASE": "Purchase",
      "STEP_LABEL_ASSIGN": "Assign",
      "GUEST_DESCRIPTION": "Search for an existing guest or add a new guest to purchase <strong>{{name}}</strong>.",
      "SEARCH_GUESTS": "Search Guests",
      "PURCHASING_FOR": "<strong>Purchasing for:</strong> {{name}}",
      "QUANTITY": "Quantity",
      "REQUEST_INVOICE_WARNING": "Tickets will not be issued immediately when using this payment method. You'll need to send the guest an invoice, and once payment is received, mark the purchase as paid to issue the tickets."
    },
    "SELECT_TICKET_PACKAGES": "Select Ticket Types"
  },
  "DISCOUNT_CODES": {
    "EMPTY_STATE": "No discount codes found",
    "EMPTY_STATE_SUBTITLE": "Create your first discount code to get started",
    "EDIT_TITLE": "Edit Discount Code",
    "CREATE_TITLE": "Create Discount Code",
    "ADD": "Add Discount Code",
    "FIELDS": {
      "CODE": "Unique Code",
      "CODE_PLACEHOLDER": "e.g. VIP20",
      "CODE_HINT": "Enter a unique code for the discount",
      "DISCOUNT_TYPE": "Discount Type",
      "DISCOUNT_VALUE": "Discount Per Ticket Type",
      "DISCOUNT_VALUE_HINT": "Enter the discount amount",
      "QUANTITY": "Use Limit",
      "QUANTITY_PLACEHOLDER": "No Limit",
      "QUANTITY_HINT": "Number of times this code can be used (leave empty for no limit)",
      "MAX_PER_ORDER": "Maximum Use Per Order",
      "MAX_PER_ORDER_HINT": "Amount of tickets that can be discounted in a single order",
      "IS_ACTIVE": "Enabled",
      "APPLY_DISCOUNT_TO": "Apply discount to:",
      "ALL_TICKET_TYPES": "All ticket types",
      "SELECTED_TICKET_TYPES": "Selected ticket types"
    },
    "TYPE": {
      "PERCENTAGE": "Percentage",
      "FLAT": "Flat Amount"
    },
    "COLUMNS": {
      "CODE": "Unique Code",
      "TYPE": "Discount Type",
      "VALUE": "Discount Per Ticket Type",
      "USE_LIMIT": "Use Limit",
      "MAX_PER_ORDER": "Maximum Use Per Order",
      "STATUS": "Status"
    },
    "UNLIMITED": "Unlimited",
    "ACTIVE": "Enabled",
    "INACTIVE": "Disabled",
    "CONFIRM_DELETE_TITLE": "Delete Discount Code",
    "CONFIRM_DELETE_BODY": "Are you sure you want to delete this discount code?",
    "CONFIRM_DELETE_CONFIRM": "Delete",
    "CONFIRM_DELETE_CANCEL": "Cancel",
    "CODE_AVAILABLE": "Code is available",
    "TICKET_PACKAGES_REQUIRED": "Please select at least one ticket type",
    "UPDATE_SUCCESS": "Discount code updated successfully",
    "DELETE_SUCCESS": "Discount code deleted successfully",
    "CODE_COPIED": "Code copied to clipboard",
    "SHARE_DIALOG": {
      "TITLE": "Your discount code is ready!",
      "BODY": "Share this code with your supporters so they can redeem it at checkout.",
      "DONE": "Done"
    }
  },
  "ITEM_TYPES": {
    "DONATION": "Donation",
    "AUCTION": "Auction",
    "BIDDING": "Auction",
    "SILENT_AUCTION": "Silent Auction",
    "LIVE": "Live Auction",
    "SEALED": "Sealed Bid",
    "RAFFLE": "Raffle",
    "PURCHASE": "Buy-It-Now",
    "BIDDING_PURCHASE": "Auction (Buy-It-Now)",
    "BID": "Bid"
  },
  "CLIENT_ACCOUNT": {
    "SIDENAV": {
      "LIST": "Organisation List",
      "DETAILS": "Details",
      "AUCTIONS": "Campaigns",
      "ADMINS": "Admins",
      "PASSWORD_POLICY": "Password Policy",
      "API_KEYS": "API Keys",
      "PAYMENTS": "Payments"
    },
    "SALESFORCE": {
      "CONNECT": "Connect Salesforce"
    },
    "PREFERRED_CONTACT_EMAIL_VERIFICATION": {
      "SUCCESS_TITLE": "Preferred contact email verified",
      "SUCCESS_DESCRIPTION": "You've successfully verified the preferred contact email for this organisation.",
      "SUCCESS_TOAST": "Preferred contact email verified successfully",
      "INVALID_TITLE": "Verification link is invalid",
      "INVALID_DESCRIPTION": "This verification link is invalid. Please ask an organisation admin to add the preferred contact email again.",
      "EXPIRED_TITLE": "Verification link has expired",
      "EXPIRED_DESCRIPTION": "This verification link has expired. Please ask an organisation admin to add the preferred contact email again.",
      "RETURN_TO_DASHBOARD": "Return to Dashboard",
      "GO_TO_CLIENT_ACCOUNT": "Go to Organisation"
    }
  },
  "STAFF": {
    "AWS_TOOLS": {
      "TITLE": "Cloudfront Invalidation",
      "DESCRIPTION": "Use this option to manually clear cached content from AWS CloudFront's edge locations. This action forces the CDN to fetch the latest files from the origin server, ensuring that updates are reflected immediately. Use this button when <b> many participants from different campaigns </b> are experiencing issues loading the app.",
      "NOTE": "CloudFront invalidations are <b>rate-limited</b> and should only be used in critical scenarios.",
      "CAUCTION": "Proceed with caution. Ensure this is necessary before triggering.",
      "CREATE_INVALIDATION": "Create Invalidation",
      "CONFIRM": {
        "TITLE": "Confirm CloudFront Invalidation",
        "DESCRIPTION": "Are you sure you want to trigger a CloudFront invalidation? This action is rate-limited and should only be used in critical scenarios."
      },
      "SUCCESS": "Cloudfront invalidation successfully triggered"
    },
    "SIDENAV": {
      "HOME": "Home",
      "REPORTS": "Reports",
      "ANNOUNCEMENTS": "Announcements",
      "TUTORIAL_VIDEOS": "Tutorial Videos",
      "USER_ACCOUNTS": "User Accounts",
      "SYSTEM": "System"
    },
    "CARD": {
      "VOUCHERS": "Vouchers Report",
      "VOUCHERS_DESC": "This report shows all vouchers that have been created and redeemed. It also includes the a Summary Sheet.",
      "APPLICATION_FEE": "Application Fee Report",
      "APPLICATION_FEE_DESC": "This report shows all payments made in the selected date range. It also includes the Application Fee, Stripe charges, tax etc.,",
      "IOC_PROFIT": "IOC Profit Report",
      "IOC_PROFIT_DESC": "This report shows all the profit made from the IOC items in the selected date range.",
      "AUCTION_CREATED": "Campaign Created Report",
      "AUCTION_CREATED_DESC": "This report shows all the campaigns created in the selected date range.",
      "GOOGLE_CAMPAIGN": "Google Campaign Report",
      "CLOSED_CAMPAIGNS_DESC": "This report shows all of the campaigns which have been closed within the provided date range.",
      "CLOSED_CAMPAIGNS": "Closed Campaigns Report",
      "GOOGLE_CAMPAIGN_DESC": "This report shows all the Campaigns created using Google ads. It includes the utm_campaign column to identify the campaign.",
      "IOC_ITEMS": "IOC Items Report",
      "IOC_ITEMS_DESC": "This report shows the full list of items created for IOC in the selected date range. It includes the item name, item code, item type, and the IOC cost etc.,",
      "TICKETING_REVENUE": "Ticketing Revenue Report",
      "TICKETING_REVENUE_DESC": "This report shows all the revenue generated from ticket sales in the selected date range. It also includes the ticket purchases count.",
      "DONATION_SLIDER_REVENUE": "Donation Slider Revenue Report",
      "DONATION_SLIDER_REVENUE_DESC": "This report shows all the revenue generated from the Donation Slider in the selected date range. It also includes the donation count."
    },
    "SECTION": "Reports",
    "DATE_PICKER_DIALOG_TEXT": "Select the start and end dates for the report",
    "DATE_PICKER_RANGE": "Enter a date range",
    "DATE_PICKER_START_DATE": "Start Date",
    "DATE_PICKER_END_DATE": "End Date",
    "DATE_PICKER_DOWNLOAD_TEXT": "Download",
    "EXPORT_REPORT_SUCCESS": "You will receive an email with your report.",
    "DOWNLOAD_REPORT_SUCCESS": "Downloaded Report successfully",
    "EXPORT_REPORT_ERROR": "Could not export report. Try again later.",
    "SELECT_DATE_RANGE": "Select Date Range",
    "TUTORIAL_VIDEOS": {
      "TUTORIAL_VIDEO_PROMPT_HEADING_DEFAULT": "Need some help?",
      "TUTORIAL_VIDEO_PROMPT_DESCRIPTION_DEFAULT": "Check out the tutorial video or visit our",
      "DASHBOARD_PAGE": "Dashboard Page",
      "VIDEO_URL": "Video URL",
      "ADD_TUTORIAL_VIDEO": "Add Tutorial Video",
      "NEED_SOME_HELP": "Need some help?",
      "CHECKOUT_TUTORIAL_VIDEO": "Watch a tutorial or visit our",
      "HELP_CENTER": "help center",
      "DESCRIPTION": "Add tutorial video popups to show on certain pages across the dashboard. Copy and paste the URL of a page in the dashboard and enter the URL of a YouTube video to popup when an admin goes to that page.",
      "DELETE_CONFIRM_TITLE": "Delete Tutorial Video",
      "DELETE_CONFIRM_DESC": "Are you sure you want to delete this tutorial video popup?",
      "TITLE": "Video Title"
    },
    "EDIT_TUTORIAL_VIDEO_DIALOG": {
      "TITLE": "Edit Tutorial Video",
      "DESC_1": "The <b>Dashboard Page URL</b> is the page on which the tutorial video will open when entered. Use the path from the / after the domain onwards.",
      "DESC_2": "You may use an asterisk (*) as a wildcard character, which will match any text. This is useful for matching against segments of the path which are dynamic (like the campaign URL or an item ID), or for matching all subpages within one section (all settings pages, for example).",
      "EXAMPLES": "Examples:",
      "LI_1": "<b>/campaigns</b> - The main campaigns list page.",
      "LI_2": "<b>/campaign/*/items/edit-item/*</b> - The item edit page. The wildcards* match any campaign URL and any item ID.",
      "DESC_3": "Get the <b>YouTube Video ID</b> from the video's URL. This is the video that will play in the popup.\n\nFor example - https://www.youtube.com/watch?v=<b>dQw4w9WgXcQ</b>",
      "DASHBOARD_PAGE_URL": "Dashboard Page URL",
      "YOUTUBE_VIDEO_ID": "YouTube Video ID",
      "TITLE_FIELD": "Video Title"
    }
  },
  "BRANDING": {
    "SETTINGS": {
      "COLORS_CONTRAST_WARNING": "Please make sure background and primary colours are contrasting to ensure that all important links are visible",
      "BANNER_WARNING": "We recommend uploading a banner image to your campaign",
      "BANNER": "Banner",
      "LOGO": "Logo",
      "TITLE": "Branding",
      "CUSTOM_TEXT": {
        "TITLE": "Custom Text",
        "SUBTITLE": "These options allow you to customise the messages displayed when the auction is closed.",
        "POPUP_MESSAGE_LABEL": "Auction Closed Popup Message",
        "CLOSED_BANNER_MESSAGE_LABEL": "Auction Closed Banner Message",
        "PAUSED_BANNER_MESSAGE": "Auction Paused Banner Message"
      },
      "PRIMARY_COLOR": "Primary",
      "ACCENT_COLOR": "Accent",
      "BACKGROUND_COLOR": "Background",
      "WARN_COLOR": "Warning",
      "SUCCESS_COLOR": "Success",
      "BANNER_BACKGROUND_COLOR": "Banner Background",
      "UPDATE_BANNER": "Select Banner Image",
      "EDIT_BANNER": "Edit Banner",
      "UPDATE_LOGO": "Update Logo",
      "GENERATE_LOGO": "✨ Generate Logo with AI",
      "GENERATE_BANNER": "✨ Generate Banner with AI",
      "SHOW_BANNER_TEXT": "Display campaign name",
      "SHOW_BANNER_OVERLAY": "Show banner overlay",
      "LIMIT_BANNER_HEIGHT": "Limit banner height",
      "LIMIT_BANNER_HEIGHT_DISABLED": "Required when using multiple banner images",
      "CUSTOM_CSS": "Custom CSS",
      "PRESET": {
        "TITLE": "Preset",
        "ZENITH": "Zenith",
        "WHIMSY": "Whimsy",
        "NOIR": "Noir",
        "SERENITY": "Serenity",
        "FIESTA": "Fiesta",
        "VINTAGE": "Vintage"
      },
      "CUSTOM_CSS_DESCRIPTION": "Here you can edit your custom CSS that will be applied to your campaign",
      "PREVIEW": {
        "TITLE": "Preview",
        "NOTE": "*Note: Please use a bigger screen to be able to see the preview. You can rotate your device to Landscape mode to see the preview if on a mobile or a smaller tablet.",
        "DESKTOP": "Desktop",
        "MOBILE": "Mobile",
        "TABLET": "Tablet",
        "OPEN_DESKTOP_PREVIEW": "Open Desktop Preview",
        "DESKTOP_PREVIEW": "Desktop Preview"
      }
    },
    "GENERATE_LOGO_AND_BANNER": {
      "LOGO_TITLE": "Generate Logo",
      "BANNER_TITLE": "Generate Banner",
      "PROMPT_LABEL": "Prompt",
      "PROMPT_HINT": "Enter a prompt to generate a logo",
      "BANNER_PROMPT_HINT": "Enter a prompt to generate a banner",
      "GENERATE_BUTTON": "Generate",
      "NO_LOGO_YET": "No logo generated yet",
      "NO_BANNER_YET": "No banner generated yet",
      "SAVED_SUCCESS": "Saved successfully",
      "TIPS_TITLE": "Tips for better results:",
      "TIP_1": "To add text to your image, make sure to wrap the text in double quotes. For example: A shield with the text \"GalaBid\".",
      "TIP_2": "Be as descriptive as you can.",
      "TIP_3": "Specify the style you are after. For example: modern, minimalist, abstract, etc.",
      "DISCLAIMER_GENERAL": "Disclaimer: The images are generated by AI. We recommend that you do not use any trademarked names in your prompts. ",
      "DISCLAIMER_LOGO_BG": "Please note that the AI may not generate the exact background colour you choose; it will be close, but may be a slightly different shade.",
      "BACKGROUND_COLOR": "Background Colour",
      "TRANSPARENT": "Transparent Background"
    }
  },
  "FORMS": {
    "URL_NAME_PLACEHOLDER": "your-campaign-name",
    "ERROR": {
      "GENERIC": "Please check the form for errors and try again",
      "SELECT_TEXT_TO_ADD_LINK": "Please select some text to add a link",
      "INVALID_PHONE_NUMBER": "Please enter a valid phone number",
      "INVALID_CHARACTERS": "Only letters, numbers, dashes and underscores allowed",
      "FIELD_REQUIRED": "This field is required",
      "NO_OPTION_SELECTED": "Please select a valid option",
      "EMAIL": "Please enter a valid email address",
      "INCORRECT": "Incorrect",
      "MIN": "Must be at least {{min}}",
      "MAX": "Must be no more than {{max}}",
      "MAX_LENGTH": "Must be no more than {{requiredLength}} characters",
      "MIN_LENGTH": "Must be at least {{requiredLength}} characters",
      "WHOLE_NUMBER": "Must be a whole number",
      "ALPHANUMERIC_ONLY": "Only letters and numbers are allowed",
      "UPPER_LOWER_CASE": "Must contain at least one uppercase and one lowercase letter",
      "LESS_THAN_OR_EQUAL_TO": "Must be less than or equal to {{max}}",
      "GREATER_THAN_OR_EQUAL_TO": "Must be greater than or equal to {{min}}",
      "TOTAL_UNITS_EXCEEDED": "Must be fewer than total {{unitName}} available {{max}}",
      "INVALID_COLOR": "Must be a valid colour",
      "DATE_AFTER": "End date must be after start date",
      "UNITS": "units",
      "TICKETS": "tickets",
      "INVALID_DATE_FORMAT": "Invalid date format",
      "INVALID_FUTURE_DATE": "The date cannot be in the future",
      "INVALID_PAST_DATE": "The date cannot be in the past",
      "START_DATE_REQUIRED": "Start date is required",
      "END_DATE_REQUIRED": "End date is required",
      "INVALID_START_DATE": "Invalid start date format",
      "INVALID_END_DATE": "Invalid end date format",
      "CODE_ALREADY_EXISTS": "A discount code with this code already exists"
    }
  },
  "REPORT": {
    "SECTION": {
      "REPORT_PAYMENTS_SECTION": "Payments",
      "REPORT_ACTIVITY_SECTION": "Activity",
      "REPORT_ITEMS_SECTION": "Items",
      "REPORT_USERS_SECTION": "Participants",
      "REPORT_EVENT_TICKETING_SECTION": "Event Ticketing",
      "REPORT_SALESFORCE_SECTION": "Salesforce"
    },
    "CARD": {
      "REPORT_LIST_DOWNLOAD_ITEMS": "Items",
      "REPORT_LIST_DOWNLOAD_BIDDERS": "Participants",
      "REPORT_LIST_DOWNLOAD_INVOICES": "Invoices",
      "REPORT_LIST_DOWNLOAD_SUMMARY": "Summary",
      "REPORT_LIST_DOWNLOAD_BIDSBUYS": "Bids & Buys",
      "REPORT_LIST_DOWNLOAD_IOC": "Items on Consignment (IOC)",
      "REPORT_LIST_DOWNLOAD_PAYMENTS": "Payments",
      "REPORT_LIST_DOWNLOAD_RAFFLETICKETS": "Raffle Tickets & Winners",
      "REPORT_LIST_DOWNLOAD_NOTIFICATIONMESSAGES": "Notification Messages",
      "REPORT_LIST_DOWNLOAD_EVENTTICKETS": "Event Tickets",
      "REPORT_LIST_DOWNLOAD_SALESFORCE": "Salesforce",
      "REPORT_SUMMARY_TOOLTIP": "This report includes a summary sheet for each item type - Auction, Donation, Buy Now and Raffle. Auction items include winning bidder by item. The Participants & Invoices reports are also included as individual sheets.",
      "REPORT_BIDSBUYS_TOOLTIP": "This report details participant activity by item type - Auction, Donation, Buy Now and Raffle.",
      "REPORT_PAYMENTS_TOOLTIP": "This report details all campaign payments including any taxes or fees, Stripe fees and refunded amounts. The campaign profit total excludes refunds.",
      "REPORT_ITEMS_TOOLTIP": "This report includes a summary sheet for each item type - Auction, Donation, Buy Now and Raffle. Auction items include winning bidders by item. The Donation, Buy Now and Raffle sheets include the total for each individual item.",
      "REPORT_ITEMS_ON_CONSIGNMENT_TOOLTIP": "This report includes the cost of any IOC included in the campaign and the winning bidder, winning bid amount and profit for any sold items.",
      "REPORT_BIDDERS_TOOLTIP": "This report includes all participants' details completed during campaign registration, along with the registration status for each participant.",
      "REPORT_INVOICES_TOOLTIP": "This report lists participants' invoice details, invoice total, payment total, payment status and payment breakdown.",
      "REPORT_RAFFLETICKETS_TOOLTIP": "This report lists individual raffle tickets sold and winning tickets.",
      "REPORT_NOTIFICATIONMESSAGES_TOOLTIP": "This report details each notification sent to campaign participants by email or text (SMS).",
      "REPORT_EVENTTICKETS_TOOLTIP": "This report contains information about purchases and tickets, including guest information.",
      "REPORT_SALESFORCE_TOOLTIP": "This report contains information about each participant from your campaign, including their spending and activity."
    },
    "ERRORS": {
      "DOWNLOAD_FAILED": "Could not download. Try again later."
    }
  },
  "DOCUMENTS": {
    "REG_DOCUMENTS": "Registration Documents",
    "RAFFLE_DOCUMENTS": "Raffle Documents",
    "TITLE": "Useful Documents",
    "RAFFLE_FINAL_CHECKLIST_TITLE": "Raffle Final Checklist",
    "RAFFLE_FINAL_CHECKLIST_DESC": "A helpful reference checklist for a raffle campaign.",
    "SILENT_AUCTION_FINAL_CHECKLIST_TITLE": "Silent Auction Final Checklist",
    "SILENT_AUCTION_FINAL_CHECKLIST_DESC": "A helpful reference checklist for a silent auction.",
    "RAFFLE_INSTRUCTIONS_TITLE": "Visual Raffle Instructions",
    "RAFFLE_INSTRUCTIONS_DESC": "Useful for printing and displaying at a live event.",
    "VISUAL_REG_INST_TITLE": "Visual Registration Instructions",
    "VISUAL_REG_INST_DESC": "Customise and preview registration instructions.",
    "MC_INSTRUCTIONS": "MC Instructions",
    "MC_INSTRUCTIONS_DESC": "The most effective way to register participants at a live event. Give this script to your MC to read during the introduction.",
    "CAMPAIGN_CHEATSHEET_TITLE": "Campaign Cheatsheet",
    "CAMPAIGN_CHEATSHEET_DESC": "A helpful reference sheet to assist with operating your campaign when onsite at a live event or for online only campaigns.",
    "RAFFLE_CHEATSHEET_TITLE": "Raffle Cheatsheet",
    "RAFFLE_CHEATSHEET_DESC": "How to draw the raffle and use the raffle draw display.",
    "VOLUNTEER_CHEATSHEET_TITLE": "Volunteer Cheatsheet",
    "VOLUNTEER_CHEATSHEET_DESC": "How to setup and use the volunteer accounts.",
    "POST_CAMPAIGN_CHEATSHEET_TITLE": "Post-campaign Cheatsheet",
    "POST_CAMPAIGN_CHEATSHEET_DESC": "A helpful reference for when your campaign has finished.",
    "REGISTRATION_INSTRUCTIONS": {
      "TITLE": "Registration Instructions",
      "CONFIGURE": "Configure Registration Instructions",
      "HEADING": "Heading",
      "COLOR": "Registration Instructions Colour",
      "LOGO": "Registration Instructions Logo",
      "CHOOSE_LOGO": "Choose Logo",
      "SHOW_LOGO_BACKGROUND": "Show background colour behind logo",
      "PRINT": "Print",
      "PRINT_TITLE": "Print Registration Instructions",
      "PRINT_BODY": "Are you sure you want to print these registration instructions? Remember to enable Background Graphics in More Settings inside the print dialog if you do not see all the colours.",
      "PDF_NOTE": "To download the PDF, use the Print option and select \"Save as PDF\" as the destination.",
      "SAVE_PREVIEW_NOTE": "Click on \"Save\" to see the updated preview.",
      "DOWNLOAD": "Download PDF",
      "DOWNLOAD_SUCCESS": "Registration Instructions PDF downloaded successfully",
      "SAVE": "Save",
      "RESET": "Reset to Defaults",
      "RESET_SUCCESS": "Registration instructions reset to defaults",
      "STEPS": "Steps",
      "STEP_X": "Step {{index}}",
      "STEP_HEADING": "Step Heading",
      "STEP_TEXT": "Step Text",
      "DEFAULT_HEADING": "Make an Impact",
      "DEFAULT_STEPS": {
        "SCAN_QR_CODE": {
          "HEADING": "Scan the QR Code",
          "TEXT": "Browse the campaign and view the items"
        },
        "BID_OR_BUY": {
          "HEADING": "Bid or Buy",
          "TEXT": "Click on an item to view details and place a bid or purchase"
        },
        "REGISTER": {
          "HEADING": "Register",
          "TEXT": "Fill out the form and accept the verification link"
        },
        "EASY_AND_SECURE_PAYMENT": {
          "HEADING": "Easy and Secure Payment",
          "TEXT": "Pay securely by adding your credit card or using Apple Pay/Google Wallet."
        }
      }
    }
  },
  "FEE_OPTIONS": {
    "HEADER": "Choose your fee option",
    "SUB_HEADER": "You can change this selection at any time.",
    "TOGGLE_LABEL": "Suggested Tips",
    "GALABID_TIP": "Free platform",
    "GALABID_TIP_TIP_SHARE": " + {{ tipShare }}% of tips back to you!",
    "GALABID_TIP_TIP_SHARE_DESC": "GalaBid is free to use. A suggested tip for GalaBid is shown at checkout, which participants can change or set to $0.",
    "GALABID_TIP_TIP_SHARE_DESC_TIP_SHARE": " {{ tipShare }}% of every tip goes back to your fundraiser in cash.",
    "GALABID_TIP_STRIPE": "Payments are processed by Stripe — funds go directly to your Stripe account, which you can set up or connect in minutes.",
    "COMMISSION": "{{commission}}% Platform Fee",
    "COMMISSION_DESC": "With suggested tips turned off, participants won't be shown the option to tip GalaBid. Instead, a {{commission}}% platform fee is deducted from each payment on your campaign.",
    "COMMISSION_STRIPE": "Payments are processed by Stripe. GalaBid does not hold or control your funds — donations go directly to your Stripe account. Stripe processing fees still apply and can be absorbed by the fundraiser or passed on to participants.",
    "BENEFITS": {
      "MORE_FUNDS": "More funds for your cause",
      "MORE_FUNDS_DESC": "{{ tipShare }}% tip share in cash",
      "FUNDS_CONTROL": "Full control of funds",
      "FUNDS_CONTROL_DESC": "Stripe-powered payments",
      "EASY_SETUP": "Easy setup",
      "EASY_SETUP_DESC": "create or link a Stripe account from your dashboard",
      "SUPPORT": "Human support, 7 days a week",
      "SUPPORT_DESC": "live chat and Zoom calls",
      "FEATURES": "100+ Features included",
      "PREDICTABLE_PRICING": "Predictable pricing",
      "PREDICTABLE_PRICING_DESC": "a flat {{commission}}% platform fee per transaction"
    }
  },
  "USER_ACCOUNTS": {
    "CLIENT_ACCOUNTS": "Organisations",
    "SEARCH": "Search User or Campaign",
    "IS_DISTRIBUTOR": "Distributor",
    "STAFF": "Staff",
    "SUPERUSER": "Superuser",
    "MFA_ENABLED": "MFA Enabled",
    "ARCHIVE": "Archive",
    "ARCHIVE_SUCCESS": "User Archived Successfully",
    "CAMPAIGNS": "Campaigns",
    "NO_CAMPAIGNS": "No Campaigns",
    "NO_CLIENT_ACCOUNTS": "No Organisations",
    "ARCHIVE_DIALOG": {
      "TITLE": "Confirm Archive User",
      "WARNING": "This action will archive the following user and cannot be undone. Please review the details carefully before proceeding.",
      "NAME": "Name",
      "EMAIL": "Email",
      "PHONE": "Phone",
      "SUBMIT": "Archive User",
      "BULLETS": {
        "NAME_CHANGED": "The user's name will appear as <i>User deleted</i> and can no longer be searched by their original name.",
        "CONTACT_REMOVED": "The user's contact details will be archived.",
        "ACCESS_REVOKED": "The user will be logged out and no longer be able to log in, make payments, or receive notifications.",
        "HIGHEST_BID": "<strong>If the user holds the highest bid in an active auction, you will not be able to collect payment or notify them of their win. Check their campaigns and remove any active bids before proceeding.</strong>"
      }
    }
  },
  "USERS": {
    "PAYMENT_METHODS": "Payment methods",
    "UNSUBSCRIBED": "Unsubscribed",
    "SUBSCRIBED": "Subscribed",
    "INVITE_DIALOG": {
      "SUCCESS": "New participants have been invited to your campaign",
      "TITLE": "Invite Participant",
      "BODY": "Enter your participants' details and we will send them a link to sign up to your campaign",
      "SEND": "Send",
      "EMAIL": "Email",
      "PHONE_NUMBER": "Phone Number",
      "USE_PHONE_NUMBER": "Change to phone number",
      "USE_EMAIL": "Change to email"
    },
    "EMPTY_STATE": "No Participants Yet",
    "EMPTY_STATE_SUBTITLE": "Invite participants to get them involved in the campaign",
    "SEARCH": "Search Participants",
    "ADD": {
      "INVITE": "Invite Participant",
      "INVITE_BULK": "Bulk Invite"
    },
    "INVITE": "Invite Participant",
    "FIRST_NAME": "First Name",
    "LAST_NAME": "Last Name",
    "PHONE_NUMBER": "Phone",
    "PREFERRED_CONTACT": "Preferred Contact",
    "PAYMENT_METHOD": "Payment Method",
    "PHONE_UNSUBSCRIBED": "Phone Unsubscribed",
    "EMAIL": "Email",
    "REGISTRATION_STATUS": "Registration Status",
    "STATUS": {
      "COMPLETE": "Complete",
      "NONE": "No Invite",
      "VERIFIED": "Verified",
      "SENT": "Invite Sent"
    },
    "ANONYMOUS": "Anonymous",
    "EMAIL_VERIFIED": "Email Verified",
    "PHONE_VERIFIED": "Phone Verified",
    "PADDLE_NUMBER": "Paddle Number",
    "DELETE_SUCCESS": "Participant Deleted",
    "EDIT_USER": {
      "TITLE": "Participant's Details",
      "SUBTITLE": "Update the participant's details below. Participants can take part in the campaign and manage accounts after completing registration.",
      "PHONE_OR_EMAIL": "Phone or Email",
      "FIRST_NAME": "First Name",
      "LAST_NAME": "Last Name",
      "TABLE": "Table",
      "MAKE_ANONYMOUS": "Make participant anonymous",
      "SAVE_AND_SEND": "Save and Send Invite",
      "UPDATE_SUCCESS": "Participant Updated",
      "SMS_INVITE_CODE": "SMS Verification Code",
      "EMAIL_INVITE_CODE": "Email Verification Code",
      "INVITE_EMAIL_LABEL": "Participant has registered using email",
      "INVITE_PHONE_LABEL": "Participant has registered using phone number",
      "CHANGE_PASSWORD": "Change Password"
    },
    "CHANGE_PASSWORD": {
      "SUBTITLE": "Warning: By submitting this form you will change the participant's password and they will not be able to log in to your campaign with their old password.",
      "TITLE": "Change Password",
      "SUCCESS": "Password Updated",
      "NEW_PASSWORD": "New Password",
      "CONFIRM_PASSWORD": "Confirm Password",
      "NO_MATCH": "New password and confirm password must match",
      "BACK": "Participant Details"
    },
    "CREATE_USER": {
      "EMAIL": "Email",
      "SAVE_AND_SEND_INVITE": "Save and Send Invite",
      "SUCCESS": "Participant Created",
      "USE_EMAIL": "Use email instead",
      "USE_PHONE": "Use mobile number instead"
    },
    "DELETE_USER": {
      "TITLE": "Delete Participant",
      "BODY": "When you delete a participant, all of their bids, donations, purchases and raffle purchases will also be deleted, are you absolutely sure? This action is irreversible."
    },
    "MESSAGE": {
      "MESSAGE": "Message",
      "TITLE": "Send Message",
      "BODY": "This message template accepts some placeholders to customise the message",
      "SUBMIT": "Send Message",
      "SUCCESS": "Message Sent",
      "MESSAGE_TEMPLATE": "Message template",
      "SEND_INVITE_SUCCESS": "Invite Sent",
      "PLACEHOLDER": {
        "CAMPAIGN_NAME_PLACEHOLDER": "{{campaign_name}}",
        "CAMPAIGN_NAME": "The campaign name",
        "FIRST_NAME_PLACEHOLDER": "{{first_name}}",
        "FIRST_NAME": "The participant's first name",
        "LAST_NAME_PLACEHOLDER": "{{last_name}}",
        "LAST_NAME": "The participant's last name"
      }
    }
  },
  "SITE_ANNOUNCEMENTS": {
    "UNREAD": "Unread",
    "MARK_AS_READ": "Mark as Read",
    "EMPTY_STATE": "No Announcements Yet",
    "EMPTY_STATE_CLIENT": "No New Announcements at the Moment",
    "EMPTY_STATE_CLIENT_SUBTITLE": "Check back here for updates on what's new in GalaBid",
    "EMPTY_STATE_SUBTITLE": "Post an announcement to keep everyone informed and updated",
    "TITLE": "Announcements",
    "DESCRIPTION": "Add announcements to keep everyone informed and updated.",
    "SUBTITLE": "Keep up-to-date with what's changed in GalaBid",
    "CREATE": "Create Site Announcement",
    "EDIT": "Edit Site Announcement",
    "TABLE": {
      "TITLE": "Title",
      "DISPLAY": "Display",
      "PUBLISH_DATE": "Publish Date",
      "DISPLAY_UNTIL": "Display Until",
      "TARGET": "Target"
    },
    "DIALOG": {
      "PREVIEW": "Preview Text",
      "CONTENT": "Content",
      "ALL": "All",
      "NON": "Non SAAS",
      "SAAS": "SAAS"
    },
    "DELETE_CONFIRM_TITLE": "Are you sure you want to delete this announcement?",
    "DELETE_CONFIRM_DESC": "You are going to delete the {{title}}.",
    "DELETE_CONFIRM_OK": "Yes",
    "DELETE_CONFIRM_CANCEL": "Cancel",
    "READ_MORE": "Read More"
  },
  "ORGANIZATIONS": {
    "NO_SELECTION": "No organisations selected",
    "SEARCH": "Search Organisations",
    "ACCEPT_INVITATION": "Accept Invitation",
    "ACCEPT_INVITATION_SUCCESS": "Invitation Accepted",
    "TITLE": "Organisations",
    "CREATE": "Add new organisation",
    "LOADING": "Loading Organisations",
    "TABLE": {
      "NAME": "Name",
      "NO_OF_CAMPAIGNS": "Campaign Count",
      "ADMINS": "Admins",
      "CREDITS": "Credits",
      "DATE_CREATED": "Date Created",
      "SAAS": "SAAS",
      "NONSAAS": "Non SAAS",
      "NO_ADMINS": "No admins",
      "EMAIL": "Admin Email",
      "ADMIN_NAME": "Admin Name"
    },
    "CREATE_DIALOG": {
      "TITLE": "Add A New Organisation",
      "DESC": "Fill in the organisation's name below to start managing their campaigns.",
      "NAME": "Organisation Name",
      "SAVE": "Save",
      "CANCEL": "Cancel",
      "CREATE_SUCCESS": "Organisation Created"
    },
    "DETAILS": {
      "LOGIN_ALIAS": "The login alias for this organisation is ",
      "ORG_NAME": "Organisation Name",
      "CREDITS": "Campaign Creation Credits",
      "PREF_EMAILS": "Preferred Contact Emails",
      "EMAIL": "Email",
      "UPDATE_PREF_EMAIL": "Update Emails",
      "ADD_PREF_EMAIL": "Add Emails",
      "PREF_EMAIL_VERIFY": "You need to verify your email, check your inbox.",
      "RESEND_VERIFICATION": "Click here to resend your verification link.",
      "SAAS": "SAAS",
      "STAFF_NOTES": "Staff Notes",
      "UPDATE_SUCCESS": "Successfully updated",
      "DEFAULT_TIP_REVENUE_SHARE_PERCENTAGE": "Default Tipping Revenue Share Percentage (%)",
      "PREFERRED_CONTACTS": {
        "EMAIL": "Email",
        "STATUS": "Status",
        "VERIFICATION_TIMESTAMP": "Verified At",
        "ACTIONS": "Actions",
        "ADD_EMAIL": "Add email address",
        "ADD_EMAIL_HINT": "A verification email will be sent if the email is not already verified",
        "ADD": "Add",
        "INVALID_EMAIL": "Please enter a valid email address",
        "STATUS_VERIFIED": "Verified",
        "STATUS_UNVERIFIED": "Unverified",
        "VERIFY_SENT": "Verification email sent",
        "RESEND": "Resend",
        "DELETE": "Delete",
        "DELETE_CONFIRM_DIALOG": {
          "TITLE": "Delete Preferred Contact",
          "DESC": "Are you sure you want to delete this preferred contact email?"
        }
      }
    },
    "PREFERRED_CONTACT_EMAIL_DIALOG": {
      "TITLE": "Update Preferred Contact Email",
      "ADD_TITLE": "Manage Preferred Contact Emails",
      "DESC": "Enter the preferred contact email for participant messages.",
      "ADD_DESC": "Add or remove preferred contact emails for participant messages. If no email is set, participant messages will be sent to all organisation admins.",
      "PREF_EMAIL": "Preferred Contact Email",
      "ADD_EMAIL": "Add Email",
      "NEW_EMAIL": "New Email Address",
      "CURRENT_EMAILS": "Current Emails",
      "VERIFIED": "Verified",
      "UNVERIFIED": "Unverified",
      "RESEND": "Resend",
      "SAVE_SUCCESS": "Preferred contact emails saved successfully",
      "DUPLICATE_ERROR": "Duplicate emails are not allowed",
      "REMOVE_SUCCESS": "Preferred contact emails removed successfully",
      "VERIFY_SENT_DESC": "We've sent a verification link to your preferred contact email. Please check your inbox or spam/junk folder.",
      "OK": "OK"
    },
    "CAMPAIGNS": {
      "LINK_DESC": "This campaign already belongs to {{old_client_name}}. Are you sure you wish to remove {{auction_url}} from {{old_client_name}} and add it to {{new_client_name}}?",
      "LINK_OK": "Yes",
      "LINK_CANCEL": "Cancel",
      "LINK_SUCCESS": "Campaign Linked",
      "LINK_CAMPAIGN": "Link Campaign",
      "LINK_CAMPAIGN_DIALOG_DESC": "Select one or more campaigns below to add them to the organisation. If you select an campaign that already belongs to another organisation, it will be moved to this one.",
      "NO_RESULTS": "No results",
      "CAMPAIGN_URL": "Campaign URL",
      "CAMPAIGN_NAME": "Campaign Name",
      "ORG_NAME": "Organisation Name"
    },
    "ADMINS": {
      "TITLE": "Admins",
      "CREATE": "Add Admin",
      "TABLE": {
        "FIRST_NAME": "First Name",
        "LAST_NAME": "Last Name",
        "EMAIL": "Email",
        "INVITE_STATUS": "Invite Status",
        "EMAIL_VERIFIED": "Email Status",
        "MFA_STATUS": "MFA Status",
        "ENABLED": "Enabled",
        "DISABLED": "Disabled",
        "DISABLE_MFA": "Disable MFA",
        "DISABLE_MFA_CONFIRM_DIALOG_TITLE": "Disable MFA",
        "DISABLE_MFA_CONFIRM_DIALOG_CONTENT": " Are you sure you want to disable MFA for the admin <strong>{{email}}</strong>?",
        "DISABLE_MFA_CONFIRM_DIALOG_OK": "Yes",
        "DISABLE_MFA_CONFIRM_DIALOG_CANCEL": "Cancel"
      },
      "INVITE_ADMIN_DIALOG": {
        "TITLE": "Invite Admin",
        "DESC": "Enter the new admin's email, to send the invitation",
        "FIRST_NAME": "First Name",
        "LAST_NAME": "Last Name",
        "EMAIL": "Email",
        "CAN_EDIT": "Can add and edit organisation admins",
        "OK_TEXT": "Send invite",
        "CANCEL_TEXT": "Cancel"
      },
      "CONFIRM_EMAIL_VERIFICATION": "Confirm Email Verification",
      "CONFIRM_EMAIL_VERIFICATION_DESC": "Do you want to verify this email? - {{admin_email}}",
      "REMOVE_ADMIN": "Remove Admin",
      "REMOVE_ADMIN_DESC": "Are you sure you want to remove this organisation admin?",
      "EDIT_ADMIN_DIALOG": {
        "TITLE": "Admin Details",
        "DESC": "Admins will have full access to view and edit campaigns for the organisation through the admin dashboard.\n\nFill in the details below to create an organisation admin.",
        "PASSWORD": "Password",
        "RETYPE_PASSWORD": "Confirm password",
        "CHANGE_PASSWORD": "Change password",
        "MUST_MATCH": "Passwords must match",
        "OK_TEXT": "Save",
        "CANCEL_TEXT": "Cancel"
      },
      "INVITE_SUCCESS": "Invite sent",
      "RESEND_INVITE_SUCCESS": "Invite resent",
      "UPDATE_SUCCESS": "Admin updated",
      "ACCEPT_INVITE_DESC": "Fill in the admin details below to finish setup and verify their account. They will be able to reset their password when they log in. ",
      "ACCEPT_OK_TEXT": "Verify"
    },
    "PAYMENTS": {
      "EXPRESS_TITLE": "Payment Settings",
      "EXPRESS_DESC": "To start accepting online payments we'll need some more details from you.",
      "EXPRESS_DISABLED": "Express connect is not enabled for this organisation, however Express Stripe accounts have been detected.",
      "DEFAULT_PAYMENT_PROFILE": "Default Payment Profile",
      "RESET_EXPRESS": "Reset Default Express Stripe Account",
      "STANDARD_TITLE": "Stripe Accounts",
      "STANDARD_DESC": "Stripe Connect allows you to create an account with Stripe which you can use to accept and manage payments from your participants. By using this feature, payments will not go through the GalaBid platform but will be self-managed and completely private. You can choose a Stripe Connect account to use for your campaign in Setup > Payment.",
      "STANDARD_DISABLED": "Standard connect is not enabled for this organisation, however Standard Stripe accounts have been detected.",
      "RESET_STANDARD": "Reset Default Standard Stripe Account",
      "TABLE": {
        "NAME": "Name",
        "ACCOUNT_TYPE": "Account Type",
        "ACCOUNT_ID": "Account ID"
      },
      "SHARE_TITLE": "Share Stripe Account",
      "SHARE_DESC": "This will allow you to share your Stripe account with another organisation on GalaBid.",
      "SHARE": "Share",
      "SHARE_SUCCESS": "Successfully shared",
      "DEFAULT": "Default",
      "SEARCH_ORG": "Search for an organisation",
      "CONTINUE": "Continue",
      "SETUP_PAYMENT": "Setup Payment"
    },
    "PWD_POLICY": {
      "TITLE": "Password Complexity Policy",
      "DESC": "Set the password complexity policy for this organization. This policy will ensure that campaign participants adhere to minimum length and complexity requirements when creating passwords.",
      "WEAK": "Weak",
      "MEDIUM": "Medium",
      "STRONG": "Strong",
      "MIN_LEN": "Minimum Length {{min_length}}",
      "MIN_UPPER": "Minimum {{min_upper}} Uppercase",
      "MIN_LOWER": "Minimum {{min_lower}} Lowercase",
      "MIN_NUMBERS": "Minimum {{min_numbers}} Numbers/Digits",
      "MIN_SPECIAL": "Minimum {{min_special_chars}} Special Characters"
    },
    "API_KEYS": {
      "TITLE": "API Keys",
      "DESC": "Create API keys to allow third party applications to access your GalaBid account. You can create multiple API keys for different applications.",
      "NAME": "Name",
      "CREATED_AT": "Created At",
      "KEY": "Key",
      "ACTIONS": "Actions",
      "CREATE_SUCCESS": "API key created",
      "DELETE_SUCCESS": "API key deleted",
      "COPY": "Copy",
      "DIALOG": {
        "TITLE": "Create API Key",
        "DESCRIPTION": "An API key will give you read-only access to the API for your integrations and automations.  Give your API key a name to identify it.",
        "NAME": "Name",
        "CREATE": "Create",
        "CANCEL": "Cancel"
      }
    }
  },
  "NOTIFICATIONS": {
    "TITLE": "Notifications",
    "NEW_NOTIFICATION": "New Notification",
    "SET_PROMO_ITEM": "Set Promo Item",
    "SCHEDULED": {
      "NO_CONTENT": "No scheduled notifications",
      "TITLE": "Scheduled Notifications",
      "DESC": "Notifications which you have scheduled to be sent.",
      "TABLE": {
        "NOTIFICATION_LABEL": "Notification Label",
        "RECIPIENTS": "Recipients",
        "TRIGGER": "Trigger",
        "SCHEDULED_AT": "Scheduled At",
        "LAST_SENT": "Last Sent",
        "DELETE_CONFIRM_TITLE": "Delete Notification",
        "DELETE_CONFIRM_TEXT": "Are you sure you want to delete notification {{notification_label}}?\n\nOn \"Confirm\", the scheduled notification will be deleted and not sent to participants."
      }
    },
    "DEFAULT": {
      "TITLE": "Default Notifications",
      "DESC": "Notifications which are automatically sent by the system."
    },
    "SAVED": {
      "NO_CONTENT": "No saved notifications",
      "TITLE": "Saved/Sent Notifications",
      "DESC": "Notifications which you have saved for later or already sent."
    },
    "EDIT_DIALOG": {
      "NEW_NOTIFICATION": "New Notification",
      "EDIT_NOTIFICATION": "Edit Notification",
      "VIEW_NOTIFICATION": "View Notification",
      "VIEW_MODE_MESSAGE": "This notification is automatically sent by the system and cannot be edited.",
      "VIEW_MODE_SENT_MESSAGE": "This notification has already been sent and cannot be edited.",
      "NOTIF_TEMPLATE": "Notification Template",
      "SUBJECT": "Subject",
      "MESSAGE": "Message",
      "SMS_MESSAGE": "SMS Message",
      "LABEL": "Notification label",
      "LABEL_HINT_TEXT": "Enter a short label to describe your notification",
      "ALREADY_IN_USE": "Label already in use, please use a different label",
      "PLACEHOLDERS": "Placeholders",
      "PLACEHOLDERS_DESC": "This message template accepts some placeholders to customise the message:",
      "SHOW": "Show",
      "SYNC_SMS_CHECKBOX": "Use same message for SMS",
      "SYNC_SMS_INFO": "Synced with Email message",
      "SYNC_SMS_LINK": "Edit manually",
      "RECIPIENTS": "Recipients",
      "RECIPIENTS_HINT": "The target audience for this notification",
      "SEGMENT_NAME": "Segment name",
      "SEGMENT_NAME_HINT": "Enter a short label to describe these recipients (e.g. High-Value Donors)",
      "EVERYONE_LABEL": "Everyone",
      "FILTERED_LABEL": "Filtered",
      "TABS_LABEL": "Message templates",
      "EMAIL": "Email",
      "SMS": "SMS",
      "HIDE": "Hide",
      "PREVIEW": "Preview",
      "WHEN_TO_SEND": "When to send",
      "DATE_TIME": "Date & time",
      "SEND_NOW": "Send now",
      "SAVE_FOR_LATER": "Save as template",
      "SAVE_ONLY": "Save only",
      "SPECIFIC_TIME": "Schedule at a specific time",
      "NOTE": "Note: ",
      "NOTE_TEXT": "Messages are currently no-reply. To allow participants to reply to you, add a preferred contact email in {{0}}Organisation > Details{{1}}.",
      "SMS_NOTE_TEXT": "SMS messages are one-way and cannot be replied to.",
      "COPY_FROM_EMAIL": "Copy from Email",
      "EMPTY_MESSAGE": "[Message content will appear here]",
      "ENABLE": "Enable",
      "SEND": "Send",
      "SCHEDULE": "Schedule",
      "SAVE": "Save",
      "SEND_NOTIFICATION": "Send Notification",
      "SEND_NOTIFICATION_DESC": "Are you sure you want to send the <strong>{{notification_label}}</strong> notification now?\n\nOn \"Confirm\", the above notification will be sent immediately to <strong>{{recipients}}</strong>. If you would like to send the notification later, select \"Cancel\" and set a scheduled time to send the notification.",
      "ALL_PARTICIPANTS": "all campaign participants",
      "SEND_SUCCESS": "Notification sent",
      "DELETE_SUCCESS": "Notification deleted",
      "UPDATE_SUCCESS": "Notification updated",
      "RESEND_NOTIFICATION": "Resend Notification",
      "RESEND_NOTIFICATION_DESC": "Are you sure you want to resend the <strong>{{notification_label}}</strong> notification now?\n\nOn \"Confirm\", the notification will be resent immediately to the applicable participants.",
      "CREATED_SUCCESS": "Created successfully",
      "ADMIN_EDITABLE": "Admin Editable",
      "SAAS_EDITABLE": "SAAS Editable",
      "INVALID_MESSAGE_TEMPLATE": "Placeholders must have a valid closing tag",
      "SEGMENT_REQUIRED_ERROR": "Please add at least one filter group or set recipients to 'Everyone'"
    },
    "SET_PROMO_DIALOG": {
      "TITLE": "Set Promo Item",
      "NO_ITEMS": "No items available, please add an item to set the campaign promo item",
      "PROMO_ITEM": "Item Link",
      "NO_RESULTS": "No results",
      "SET_SUCCESS": "End of auction promo item updated",
      "PROMO_ITEM_HINT": "Select an item to include its link in the message"
    }
  },
  "SEGMENTS": {
    "VALUES": {
      "ANY": "Any",
      "YES": "Yes",
      "NO": "No",
      "REQUIRED": "Required Incomplete",
      "ALL_QUESTIONS": "Required or Optional Incomplete"
    },
    "CATEGORIES": {
      "AUCTION": "Auction",
      "BUY_IT_NOW": "Buy-It-Now",
      "DONATION": "Donation",
      "RAFFLE": "Raffle",
      "EVENT_TICKETING": "Event Ticketing",
      "ACCOUNT": "Account",
      "OTHER": "Other"
    },
    "IMPORTER": {
      "TITLE": "Import a Saved Segment",
      "SUBTITLE": "Select a template to pre-fill your recipient list.",
      "SEARCH_LABEL": "Search all templates",
      "SEARCH_PLACEHOLDER": "e.g. Unpaid...",
      "RESULTS_HEADER": "Search Results",
      "BROWSE_HEADER": "Browse Segments",
      "CUSTOM_BADGE": "Custom",
      "LAST_UPDATED": "Last Updated: {{date}}",
      "ADD_TO_CURRENT_FILTERS": "Add to current filters",
      "REPLACE_CURRENT_FILTERS": "Replace current filters",
      "NO_RESULTS": "No segments found"
    },
    "BUILDER": {
      "ADD_FILTER_GROUP": "Add Filter Group",
      "IMPORT": "Import",
      "GROUP_ACTIVE": "{{count}} group active",
      "GROUPS_ACTIVE": "{{count}} groups active",
      "REMOVE_ALL_GROUPS": "Remove All Groups",
      "LABEL_INPUT": "Segment Label",
      "SELECTED_COUNT": "{{count}} Selected",
      "SELECT_DATE": "Select Date",
      "LIST": {
        "EMPTY_TITLE": "Your workspace is empty",
        "EMPTY_SUBTITLE": "Select a group type from the {{0}}Add Filter Group{{1}} menu above to start adding filters.",
        "GO_BACK": "Or go back to options",
        "ADD_FILTER": "Add Filter",
        "REMOVE_GROUP": "Remove Group",
        "OPERATOR_HELP_AND": "Narrow down: Participants must match {{0}}every{{1}} group.",
        "OPERATOR_HELP_OR": "Expand: Participants can match {{0}}any{{1}} group."
      }
    },
    "OPERATORS": {
      "GREATER_THAN": "More than",
      "LESS_THAN": "Less than",
      "EQUALS": "Exactly",
      "AFTER": "After",
      "BEFORE": "Before",
      "ON": "On"
    },
    "SELECTED_SEGMENT": {
      "UPDATE_LABEL": "Edit Original",
      "UPDATE_HINT": "Save changes directly to the current segment.",
      "UPDATE_NOTE": "Changes will be saved to this segment on {{ trigger }}",
      "CREATE_LABEL": "Save as New",
      "CREATE_HINT": "Create a new reusable segment from these filters.",
      "CREATE_NOTE": "A new segment will be created on {{ trigger }}",
      "VIEW_NOTE": "Snapshot from {{ timestamp }}. This cannot be edited."
    },
    "SUMMARY": {
      "PREFIX_AND": "Targeting {{0}}only{{1}} participants who match {{0}}ALL{{1}} of the following:",
      "PREFIX_OR": "Targeting participants who match {{0}}ANY{{1}} of the following:"
    },
    "EMPTY": {
      "TITLE": "Build Your Recipient List",
      "SUBTITLE": "Start from scratch or use an existing segment.",
      "SCRATCH_TITLE": "Start from scratch",
      "SCRATCH_SUBTITLE": "Create your own rules and filters.",
      "IMPORT_TITLE": "Select existing",
      "IMPORT_SUBTITLE": "Use a pre-built or saved segment."
    }
  },
  "ACTIVITY_FEED": {
    "VIEW_REPLIES": "Replies",
    "MESSAGE": "Message",
    "CREATED": "Created",
    "NAME": "Name",
    "EMPTY_STATE": "Looks a Bit Lonely Here",
    "EMPTY_STATE_SUBTITLE": "All updates will show up here as they happen on the comment feed",
    "TITLE": "Comment Feed",
    "LIKES": " Likes",
    "REPLIES": " Replies",
    "NO_ACTIVITY": "This campaign has no posts",
    "DELETE_CONFIRM_TITLE": "Delete Post",
    "DELETE_CONFIRM_TEXT": "Are you sure you would like to delete this post?",
    "DELETE_SUCCESS": "Post deleted",
    "DELETE_REPLY_CONFIRM_TITLE": "Delete Reply to this Post",
    "DELETE_REPLY_CONFIRM_TEXT": "Are you sure you would like to delete the reply to this post?",
    "SHOW_MORE": "Show more",
    "TABLE": {
      "PARTICIPANT": "Participant",
      "MESSAGE": "Message",
      "DATE": "Date/Time"
    }
  },
  "INVOICE_LIST": {
    "REFUND": "Refund",
    "ITEMS": "Items",
    "VIEW_INVOICE": "View",
    "SEND_MESSAGE": "Message",
    "EMPTY_STATE": "No Invoices Yet",
    "EMPTY_STATE_SUBTITLE": "Once a participant makes a purchase, bid or donation their invoice will show up here",
    "NO_INVOICES": "No Invoices Available",
    "VOLUNTEER": "Volunteer",
    "TABLE": {
      "FIRST_NAME": "First Name",
      "LAST_NAME": "Last Name",
      "EMAIL": "Email",
      "PHONE": "Phone Number",
      "VIEW_INVOICE": "View",
      "SEND_MESSAGE": "Message"
    },
    "NOTES": {
      "TITLE": "Notes",
      "NOTE": "Note",
      "TYPE_HERE": "Type your notes here...",
      "ADD_NOTE": "Add Note"
    },
    "PRINT_INVOICE": "Print",
    "ALL_PAYMENTS": "All Payments",
    "PRINT": "Print",
    "DOWNLOAD": "Download",
    "INVOICE_DETAILS": "Invoice Details - {{name}}",
    "HAS_IOC": "Contains IOC",
    "INVOICE_DETAILS_FIELDS": {
      "PAYMENT_DONATION_TOTAL": "Payment Donation Total",
      "CHANGE_INVOICE": "Search Invoices",
      "BACK": "Back",
      "NAME": "Name",
      "PHONE": "Phone",
      "EMAIL": "Email",
      "TEAM": "Team",
      "ADDRESS": "Address",
      "COMPANY_NAME": "Company Name",
      "COMPANY_ADDRESS": "Company Address",
      "SUBTOTAL": "Subtotal",
      "REFUNDED": "Refunded",
      "TAX": "Tax",
      "TOTAL": "Total",
      "AMOUNT_PAID": "Amount Paid",
      "AMOUNT_DUE": "Amount Due",
      "TOTAL_DISCOUNT": "Total Discount"
    },
    "INVOICE_ITEMS_TABLE": {
      "CODE": "Code",
      "QUANTITY": "Quantity",
      "NAME": "Item",
      "TYPE": "Type",
      "PRICE": "Price",
      "CONSIGNMENT": "Consignment",
      "EVOUCHER": "Digital Voucher",
      "DISPATCH": "Dispatch",
      "DISPATCHED": "Undo Dispatch",
      "DISPATCH_ALL": "Dispatch All",
      "ALL_ITEMS_DISPATCHED": "All items are already dispatched",
      "PRIZE": "Prize"
    },
    "SHOW_MORE": "Show more",
    "PAYMENTS": "Payments",
    "INVOICE_PAYMENTS_TABLE": {
      "TIME": "Time",
      "AMOUNT": "Amount",
      "REFUNDED": "Refunded",
      "METHOD": "Method",
      "INITIATOR": "Initiator",
      "REFUNDER": "Refunder"
    },
    "ADD_PAYMENT": "Add Payment",
    "CHARGE_CARD": "Charge Card",
    "ITEM_DISPATCH_DIALOG": {
      "DISPATCH_ALL": "Dispatch All Items",
      "DISPATCH_ITEM": "Confirm Dispatch",
      "ARE_YOU_SURE": "Are you sure you would like to dispatch <b>{{item}}</b> for <b>{{profile}}</b>",
      "ITEM": "ITEM",
      "UPDATE_DISPATCHED_ITEM": "Update Dispatched Item",
      "UPDATE": "Update",
      "PARTICIPANT_NAME": "Participant Name: ",
      "ITEM_NAME": "Item Name: ",
      "ITEM_NAMES": "Item Names: ",
      "DELETE_TITLE": "Undo Dispatch",
      "DELETE_DESC": "Are you sure you wish to undo the dispatch for this item?"
    },
    "WON_PRIZE": "WON PRIZE {{prize}}"
  },
  "ADD_PAYMENT_DIALOG": {
    "TITLE": "Add Payment for {{name}}",
    "PAY_IN_FULL": "Pay in Full",
    "AMOUNT_TO_PAY": "Amount to Pay",
    "SELECT_PAYMENT_METHOD": "Select Payment Method",
    "NO_PAYMENT_METHODS": "No payment methods available for campaign",
    "NO_CARD_SELECTED": "You must add or select a card",
    "ADD_CARD_NO_USER_WARNING": "This participant must complete registration before a card can be added to their account.",
    "SELECT_CARD": "Select Card",
    "ADD_NEW_CARD": "Add New Card",
    "TAX_ADDED": "{{tax_rate}} {{tax_label}} will be added to your payment.",
    "TAX_INCLUDED": "Includes {{tax_rate}} {{tax_label}}",
    "COVER_FEES": "Cover Service Fees",
    "SAAS_TIPPING_WARNING_MESSAGE": "If you process this payment, the participant will not be asked for a GalaBid Tip, instead you will be charged a fixed fee of {{commissionPercentage}}",
    "PAYMENT_FEE_AMOUNT_FLAT": "Using this payment method will incur an additional {{serviceFeeLabel}} of {{flatFee}}.",
    "PAYMENT_FEE_AMOUNT_PERCENTAGE": "Using this payment method will incur an additional {{serviceFeeLabel}} of {{percentageFee}}% ({{totalFee}}).",
    "PAYMENT_FEE_AMOUNT_BOTH": "Using this payment method will incur an additional {{serviceFeeLabel}} of {{percentageFee}}% of the total plus {{flatFee}}, for a total {{serviceFeeLabel}} of {{totalFee}}.",
    "PAYMENT_FEE_AMOUNT_OPTIONAL_TOGGLE": "Would you be happy to cover the {{serviceFeeLabel}} of {{totalFee}}? This helps the organiser to maximise their fundraising profits.",
    "SUBMIT": "Pay {{amount}}",
    "CONFIRM": "Confirm {{amount}}",
    "PAYMENT_SUCCESS": "Payment successful",
    "AMOUNT_ERROR": "Amount cannot be more than the due amount - {{amount_due}}",
    "NO_CARD_ADDED": "Please add a new card",
    "ADD": "Add",
    "CARD_ADDED_SUCCESS": "Card added successfully"
  },
  "PAYMENTS": {
    "EMPTY_STATE": "No Payments to Display",
    "EMPTY_STATE_SUBTITLE": "Once a participant makes a payment, it will show up here",
    "TABLE": {
      "NAME": "Name",
      "EMAIL": "Email",
      "PHONE": "Phone",
      "AMOUNT": "Amount",
      "FEES": "Fees",
      "TAX": "Tax",
      "REFUNDED": "Refunded",
      "METHOD": "Payment Process",
      "VOLUNTEER": "Volunteer",
      "DATE": "Date",
      "TIP": "Tip",
      "IOC": "IOC Cost",
      "PROCESSING_FEE": "Payment Process Fee",
      "TIP_REFUNDED": "Tip Refunded",
      "REFUND": "Refund",
      "DONATION": "Donation",
      "REFUND_DONATION": "Refund Donation",
      "REFUND_TIP": "Refund Tip",
      "REFUND_DONATION_DIALOG": {
        "TITLE": "Confirm Donation Refund",
        "BODY": "Do you want to refund the {{donation_amount}} donation?",
        "CONFIRM_BTN": "Confirm"
      },
      "REFUND_TIP_DIALOG": {
        "TITLE": "Confirm Tip Refund",
        "BODY": "Do you want to refund the {{amount}} tip?",
        "CONFIRM_BTN": "Confirm"
      }
    },
    "PAYMENTS_REPORT": "Payments Report",
    "REFUND_PAYMENT": "Refund Payment",
    "REFUND_AMOUNT": "Amount to Refund",
    "REFUND_IN_FULL": "Refund in Full",
    "MAX_REFUND_AMOUNT": "Max Refund Amount - {{max_refund_amount}}",
    "REFUND_NOT_POSSIBLE": "Refund is not possible for this payment",
    "REFUND_MAX_ERROR": "Amount cannot be more than the amount paid - {{amount_paid}}",
    "REFUND_SUCCESS": "Payment refunded",
    "REFUND_TIP_SUCCESS": "Tip refunded",
    "IOC_REFUND_NON_STAFF_MESSAGE": "This payment includes cost of consignment you cannot perform this refund, contact GalaBid support if you want to refund this payment.",
    "REFUND_PAYMENT_DIALOG_PROCESSING_FEE_HELP": "* The {{processing_fee}} processing fee is not refundable.",
    "CONSIGNMENT_STAFF_HELP": "*This payment has {{ioc_cost}} IOC cost + {{tipping_fee}} GalaBid Tip.",
    "REFUND_IOC_CHECKBOX": "I understand that refunding this payment will refund {{ioc_refund}} IOC cost back to the customer.",
    "REFUND": "Refund {{amount}}",
    "REFUND_REASON": "Select a refund reason",
    "REQUESTED_BY_CUSTOMER": "Requested by customer",
    "REFUND_DUPLICATE": "Duplicate payment",
    "REFUND_FRAUDULENT": "Fraudulent payment",
    "PAYMENT_BREAKDOWN": {
      "TITLE": "Payment Breakdown",
      "AMOUNT": "Amount",
      "FEE": "Fee",
      "TIP": "Tip",
      "IOC_COST": "IOC Cost",
      "TOTAL": "Total"
    },
    "FEE_BREAKDOWN": {
      "TITLE": "Payment Fee Details",
      "FLAT_FEE": "Flat Fee",
      "PERC_FEE": "Percentage Fee",
      "PAYMENT_METHOD": "Payment Method",
      "RESULT": "Result",
      "RESULT_VALUE": "{{amount}} * {{percentage_fee}}% + {{flat_fee}} = {{result}}"
    },
    "STRIPE_BREAKDOWN": {
      "TITLE": "Stripe Payment Details",
      "INTENT_ID": "Payment Intent ID",
      "ACCOUNT_ID": "Stripe Account ID",
      "ACCOUNT_NAME": "Stripe Account",
      "STRIPE_LINK": "https://dashboard.stripe.com/payments/{{intent_id}}"
    }
  },
  "VOUCHERS": {
    "EMPTY_STATE": "Empty Voucher List",
    "EMPTY_STATE_SUBTITLE": "Once a participant purchases an item with vouchers enabled, it will appear here",
    "TABLE": {
      "PREVIEW_VOUCHER": "Preview Voucher",
      "FULL_NAME": "Full Name",
      "ITEM_NAME": "Item Name",
      "ITEM_ALIAS": "Item Alias",
      "REDEMPTION_STATUS": "Redemption Status",
      "DATE_CREATED": "Date Created",
      "DATE_REDEEMED": "Date Redeemed",
      "DATE_CONFIRMED": "Date Confirmed",
      "RESEND_VOUCHER": "Resend Voucher",
      "CONFIRM_RESEND_TITLE": "Resend Voucher",
      "CONFIRM_RESEND_DESC": "Do you want to resend a voucher notification for {{full_name}}?",
      "RESEND_SUCCESS": "Voucher resent successfully"
    },
    "EDIT_VOUCHER_DIALOG": {
      "TITLE": "Edit Voucher",
      "EMAIL": "Email",
      "PHONE": "Phone",
      "ADDRESS": "Address",
      "VOUCHER_STATUS": "Voucher Status",
      "PREF_DATE_1": "Preferred Date 1",
      "PREF_DATE_2": "Preferred Date 2",
      "PREF_DATE_3": "Preferred Date 3",
      "VOUCHER_CODE": "Voucher Code",
      "STATUS_NEW": "New",
      "STATUS_REDEEMED": "Redeemed",
      "STATUS_CONFIRMED": "Confirmed",
      "UPDATE_SUCCESS": "Voucher updated successfully"
    }
  },
  "CHECKOUT": {
    "SUMMARY": "Summary",
    "TABLE": {
      "REFUNDED": "Refunded",
      "NAME": "Participant's Name",
      "ITEM": "Item(s)",
      "DISPATCHED": "Dispatched",
      "TOTAL": "Total",
      "PAID": "Paid",
      "DUE": "Due",
      "PAYMENT_STATUS": "Payment Status",
      "EMAIL": "Email",
      "PHONE": "Phone Number",
      "IOC": "Extra Profit Item(s)",
      "NO_ITEMS": "No items",
      "NA": "N/A",
      "DS_ITEM": "item",
      "DS_ITEMS": "items",
      "UNPAID": "Unpaid",
      "SEND_REMINDER": "Send Reminder",
      "CONFIRM_SEND_REMINDER_TITLE": "Payment Reminder Notification",
      "CONFIRM_SEND_REMINDER_DESC": "Do you want to send a payment reminder notification for {{full_name}}?",
      "SEND_REMINDER_SUCCESS": "Payment reminder sent successfully"
    },
    "ITEMS_TABLE": {
      "TITLE": "Item(s): {{fullName}}",
      "CODE": "Item Code",
      "NAME": "Item Name",
      "TYPE": "Item Type"
    },
    "MORE_ACTIONS": "More Actions",
    "SEND_PAYMENT_REMINDERS": "Send Payment Reminders",
    "PRINT_ALL_INVOICES": "Print All Invoices",
    "DOWNLOAD_REPORT": "Download Report",
    "PAYMENT_SUMMARY": {
      "TITLE": "Payment Summary",
      "DESC": "Includes any campaign added fees & taxes and items on consignment costs. Excludes Stripe fees.",
      "TIPPING_DESC": "Includes any campaign added fees & taxes, GalaBid Tips and items on consignment costs. Excludes Stripe fees.",
      "PAID": "Paid",
      "UNPAID": "Unpaid"
    },
    "PARTICIPANT_SUMMARY": {
      "TITLE": "Participant Summary"
    },
    "CONFIRM_SEND_REMINDERS": "Are you sure you want to send messages?",
    "SEND_REMINDERS_SUCCESS": "Payment reminders sent successfully"
  },
  "VOLUNTEERS": {
    "DESCRIPTION": "Add volunteers to help manage your campaign on-site. Volunteers can assist with setting up participant accounts, placing bids, and more.",
    "LINK_DESCRIPTION": "Volunteers can log in using their assigned passcode at:",
    "LINK_COPIED": "Volunteer Link Copied to Clipboard",
    "LOG_IN_HERE": "Log in here",
    "SHARE_LOGIN_LINK": "Share login link",
    "EMPTY_STATE": "No Volunteer Accounts Yet",
    "EMPTY_STATE_SUBTITLE": "Click add volunteer to create your first volunteer account",
    "ADD_VOLUNTEER": "Add Volunteer",
    "CONFIRM_DELETE_VOL_TITLE": "Delete Volunteer",
    "CONFIRM_DELETE_VOL_DESC": "Are you sure you wish to remove this volunteer from your account?",
    "DELETE_SUCCESS": "Volunteer deleted successfully",
    "TABLE": {
      "NAME": "Name",
      "PASSCODE": "Passcode",
      "VERIF_REQUIRED": "Verification Required"
    },
    "EDIT_VOL_DIALOG": {
      "NEW_VOL": "New Volunteer",
      "EDIT_VOL": "Edit Volunteer"
    }
  },
  "TABLES": {
    "HELP_TEXT": "Tables are useful for managing ticket holders and their seating assignments",
    "LOOKING_FOR_TEAMS": "Looking for teams for the event display? ",
    "GO_TO_TEAMS": "Go to Teams",
    "EMPTY_STATE": "No Tables Set Up",
    "EMPTY_STATE_SUBTITLE": "Create a table to get started",
    "ADD_GUESTS": "Add Guests",
    "VIEW_GUESTS": "View Guests",
    "REMOVE_GUESTS": "Remove Guests",
    "CREATE_TABLE": "Create Table",
    "CREATE_TABLE_DESCRIPTION": "Add tables to manage ticket holders and their seating assignments.",
    "EDIT_TABLE": "Edit Table",
    "EDIT": {
      "ADD_GUESTS": "Add Guests: {{tableName}}",
      "VIEW_GUESTS": "View Guests: {{tableName}}",
      "SEAT_SELECTED": "{{count}} Seat Selected",
      "SEATS_SELECTED": "{{count}} Seats Selected",
      "UNASSIGNED_NAME": "Guest of {{name}}",
      "SEAT_COUNT_WARNING": "The selected seats exceeds the number available. You can still assign them, but the table may be overbooked.",
      "REMOVE_CONFIRM_TITLE": "Confirm Remove",
      "REMOVE_CONFIRM_BODY": "Are you sure you would like to remove <strong>{{count}}</strong> seat allocation(s) from {{table}}?",
      "NO_TABLE": "No Table"
    },
    "TABLE": {
      "ORDER": "Order",
      "TABLE_NAME": "Table Name",
      "SEAT_CAPACITY": "Seat Capacity",
      "SEATS_ASSIGNED": "Seats Assigned",
      "SEARCH": "Search by guest, purchaser, or ticket type",
      "FULL_NAME": "Name",
      "EMAIL": "Email",
      "TICKET_NUMBER": "Ticket Number",
      "TICKET_TYPE": "Ticket Type",
      "TICKET_PURCHASER": "Ticket Purchaser",
      "TICKET_STATUS": "Ticket Status",
      "CURRENT_TABLE": "Current Table"
    },
    "CREATE_TABLE_SUCCESS": "Table created successfully",
    "UPDATE_TABLE_SUCCESS": "Table updated successfully",
    "CONFIRM_DELETE_TABLE_TITLE": "Delete Table",
    "CONFIRM_DELETE_TABLE_DESC": "Are you sure you wish to delete this table? All participants currently assigned to this table will no longer belong to any table.",
    "DELETE_SUCCESS": "Table deleted successfully",
    "ADD_PARTICIPANTS_TITLE": "Add Participants to Table {{table_name}}",
    "ALREADY_IN_TABLE": "All selected participants are already in the table"
  },
  "LOADER": {
    "PRESENTER_WIDGETS": "Loading Widgets",
    "SAVE_ITEM_IMAGES": "Saving Item Images",
    "LOADING": "Loading",
    "LOAD_AUCTIONS": "Loading Campaigns",
    "LOAD_ORGANIZATIONS": "Loading Organisations",
    "LOAD_SITE_ANNOUNCEMENTS": "Loading Site Announcements",
    "DELETING_USER": "Deleting Participant",
    "IMPORTING_USERS": "Uploading Users",
    "DELETING_VOL": "Deleting Volunteer",
    "REORDERING_TABLES": "Reordering Tables",
    "ASSIGNING_SEATS": "Assigning Seats",
    "DELETING_TABLE": "Deleting Table",
    "DELETING_PAYMENT_METHOD": "Deleting Payment Method",
    "REORDERING_MENU_ITEMS": "Reordering Menu Items",
    "DELETING_MENU_ITEM": "Deleting Menu Item",
    "LOADING_MENU_RESOURCES": "Loading Resources",
    "DELETING_INFOBOOTH": "Deleting Info page",
    "EXPORTING_REPORT": "Downloading Report",
    "DOWNLOADING_VOUCHERS": "Downloading Vouchers",
    "DRAWING_RAFFLE": "Drawing Raffle",
    "DOWNLOADING_REGISTRATION_INSTRUCTIONS": "Downloading PDF...",
    "RESETTING_REGISTRATION_INSTRUCTIONS": "Resetting...",
    "REDRAWING_RAFFLE": "Redrawing Raffle",
    "DELETING_PROJECTOR": "Deleting Projector",
    "DELETING_PROJECTOR_TEMPLATE": "Deleting Template",
    "REORDERING_CATEGORIES": "Reordering Categories",
    "DELETING_CATEGORY": "Deleting Category",
    "CREATING_CATEGORY": "Creating Category",
    "DELETING_NOTIFICATION": "Deleting Notification",
    "RESENDING_NOTIFICATION": "Resending Notification",
    "SETTING_PROMO_ITEM": "Setting Promo Item",
    "DELETING_ACTIVITY": "Deleting Activity",
    "UPDATING_ORGANIZATION": "Updating Organisation",
    "LINKING_CAMPAIGN": "Linking Campaign",
    "VERIFYING_ADMIN_EMAIL": "Verifying Admin Email",
    "RESENDING_ADMIN_EMAIL_INVITE": "Resending Admin Email Invite",
    "DELETING_ADMIN": "Deleting Admin",
    "RESENDING_VOUCHER": "Resending Voucher",
    "ADDING_PAYMENT": "Adding Payment",
    "DELETING_BIDS_AND_BUYS": "Deleting",
    "REORDERING_ITEMS": "Reordering Items",
    "REORDERING_SLIDES": "Reordering Slides",
    "DELETING_ITEM": "Deleting Item",
    "RETRACTING_IOC_ITEM": "Retracting Item",
    "LOADING_ITEM": "Loading Item",
    "EXPORTING_ITEMS": "Exporting Items",
    "RESETTING_ALIASES": "Resetting Item Aliases",
    "IMPORTING_ITEMS": "Importing Items",
    "SELECTING_ALL_ITEMS": "Selecting All Items",
    "TRANSFERRING_ITEMS": "Transferring Items",
    "SENDING_PAYMENT_REMINDERS": "Sending Payment Reminders",
    "LOADING_INVOICE": "Loading Invoice",
    "DISABLING_MFA": "Disabling MFA",
    "DOWNLOADING_INVOICE_PDF": "Downloading Invoice",
    "UPDATING_AUCTION": "Updating Campaign",
    "INITIALISING_AUCTION": "Loading Campaign",
    "DELETING_TICKET": "Deleting Ticket",
    "REORDERING_TICKETS": "Reordering Tickets",
    "DOWNLOADING_BOOKLET": "Downloading Booklet"
  },
  "WIDGETS": {
    "NO_HOMEPAGE_SET": "Click the home button to make a widget page the homepage",
    "CURRENT_HOMEPAGE": " (Homepage)",
    "EMPTY_STATE": "It's quite empty here",
    "EMPTY_STATE_SUBTITLE": "Add your first widget page to add extra functionality to your campaign",
    "USE_DESKTOP_HINT": "For the best experience, please use a device with a larger screen.",
    "GRID_CONTROLS": {
      "COLUMNS": "Columns",
      "ROWS": "Rows"
    },
    "PREVIEW": "Preview",
    "VIEW_LAYOUT": "View Layout",
    "DROP_WIDGET_HERE": "Drop widget here",
    "REQUIRES_CONFIG": "Missing Details",
    "BG_IMAGE": "Background Image",
    "PAGE_LAYOUT": "Page Layout",
    "TITLE": "Widget Pages",
    "DESC": "Widget pages are a grid of buttons which can link to several locations such as other websites, items, categories, and other pages within the campaign. To add widget pages to the campaign's side menu, use the",
    "MENU_SETTINGS": "menu settings",
    "SET_AS_HOMEPAGE": "Set as Homepage",
    "SET_HOMEPAGE_CONFIRM_DIALOG": {
      "TITLE": "Set {{widget_page_name}} as Homepage",
      "BODY": "Are you sure you would like to set this widget page as the homepage?"
    },
    "UNSET_HOMEPAGE_CONFIRM_DIALOG": {
      "TITLE": "Unset {{widget_page_name}} as Homepage",
      "BODY": "Are you sure you would like to unset this widget page as the homepage?",
      "REMOVE_FROM_MENU": "Remove from Menu Items"
    },
    "ADD_WIDGET_PAGE": "Add Widget Page",
    "EDIT_WIDGET_PAGE": "Edit Widget Page",
    "WIDGET_CANT_PLACE_ERROR": "There is not enough space on the grid to add this widget",
    "WIDGET_RESIZE_ERROR": "Widgets do not fit within the new grid dimensions. Adjust widget sizes before resizing the grid",
    "BACK_TO_WIDGET_PAGES": "Widget Pages",
    "WIDGET_PAGE_TITLE": "Widget Page Title",
    "UNTITLED_WIDGET_PAGE": "Untitled Widget Page",
    "UPDATE_WIDGET_PAGE_SUCCESS": "Widget Page updated successfully",
    "ADD_WIDGET_PAGE_SUCCESS": "Widget Page created successfully",
    "CHOOSE_BACKGROUND_IMAGE": "Choose Background Image",
    "CHOOSE_IMAGE": "Choose Image",
    "NOTHING_HERE_YET": "Nothing here yet",
    "DRAG_AND_DROP": "Drag and drop widgets from the left panel to get started.",
    "PAGE_LAYOUT_DESC": "Drag, drop and resize the widgets to setup the page layout",
    "ADD_WIDGETS": "Add Widget",
    "ADD_WIDGETS_DESC": "Click or drag an option onto the widget page",
    "NO_WIDGETS_ADDED": "Please add at least one widget to this page",
    "WIDGETS_NOT_CONFIGURED": "Please make sure all widgets are configured. Hover over the widget to configure it.",
    "TABLET_LAYOUT": "Tablet Layout",
    "TABLET_LAYOUT_DESC": "How the widgets should display on tablet devices",
    "MOBILE_LAYOUT": "Mobile Layout",
    "MOBILE_LAYOUT_DESC": "How the widgets should display on mobile devices",
    "LAYOUT_OPTION_DESKTOP": "Same as Desktop",
    "LAYOUT_OPTION_TWO_COLUMN": "Two Columns",
    "LAYOUT_OPTION_ONE_COLUMN": "One Column",
    "WIDGET_TYPES": {
      "IMG_AND_TEXT": "Image + Text",
      "URL": "URL Link",
      "ITEM": "Item Link",
      "CATEGORY": "Category",
      "INFO": "Info Page",
      "WIDGET_PAGE": "Widget Page",
      "TICKETING": "Ticketing",
      "ITEM_TYPE": "Item Type"
    },
    "ADD_WIDGET_DIALOG": {
      "TEXT_OR_BG_REQUIRED": "At least one of the text, background color or background image is required",
      "ADD_WIDGET": "Add Widget",
      "EDIT_WIDGET": "Edit Widget",
      "BACKGROUND_COLOR": "Background Colour",
      "TEXT_COLOR": "Text Colour",
      "TEXT": "Text",
      "WIDGET_TYPE": "Widget Type",
      "URL_LINK": "Link",
      "INVALID_URL": "Invalid URL",
      "OPEN_IN_NEW_TAB": "Open in new tab",
      "SELECT_ITEM": "Select Item",
      "SELECT_CATEGORY": "Select Category",
      "SELECT_WIDGET_PAGE": "Select Widget Page",
      "SELECT_INFO_PAGE": "Select Info Page",
      "SELECT_ITEM_TYPE": "Select Item Type",
      "SELECT_TICKET": "Select Ticket",
      "APPEARANCE": "Appearance",
      "ALL_TICKETS": "Ticket List",
      "ALL_TICKETS_HELP_TEXT": "Link to list of all tickets",
      "SINGLE_TICKET": "Single Ticket",
      "SINGLE_TICKET_HELP_TEXT": "Link to a specific ticket"
    },
    "DELETE_WIDGET_PAGE_TITLE": "Delete Widget Page",
    "DELETE_WIDGET_PAGE_DESC": "Are you sure you want to delete this widget page?",
    "DELETING_WIDGET_PAGE": "Deleting Widget Page"
  },
  "AI": {
    "GENERATE_WITH_AI": "✨ Generate with AI",
    "EDIT_WITH_AI": "✨ Edit with AI",
    "ASK_TO_EDIT": "Ask to edit or generate",
    "UNDO_EDITS": "Undo",
    "GENERATE_BACKGROUND": "✨ Generate Image with AI",
    "PROMPT_LABEL": "Prompt",
    "PROMPT_HINT": "Enter a prompt to generate an image"
  },
  "EVENT_TICKETS": {
    "SEND_REMINDERS": "Send Reminders",
    "SEND_REMINDERS_SUCCESS": "Reminders Sent Successfully",
    "RESEND_TICKETS": "Resend Tickets",
    "RESEND_TICKETS_SUCCESS": "Tickets Resent Successfully",
    "EXPORT_GUESTS": "Export Guests",
    "CONFIRM": {
      "SEND_REMINDERS_HEADER": "Send Ticket Reminders",
      "SEND_REMINDERS_DESCRIPTION": "On Confirm, a reminder email will be sent to purchasers with unaccepted guest invitations or unassigned tickets.",
      "RESEND_TICKETS_HEADER": "Resend Tickets",
      "RESEND_TICKETS_DESCRIPTION": "On Confirm, tickets will be sent to all guests who have accepted."
    }
  },
  "TEAMS": {
    "HELP_TEXT": "On the event display, teams compete to see who can raise the highest amount",
    "LOOKING_FOR_TABLES": "Looking for tables for managing ticket holders? ",
    "GO_TO_TABLES": "Go to tables",
    "EMPTY_STATE": "No Teams Yet",
    "EMPTY_STATE_SUBTITLE": "Create teams to compete for the highest amount raised",
    "ADD_NEW": "Add New Team",
    "CREATE_TEAM": "Create Team",
    "CREATE_DESCRIPTION": "Add teams to your campaign to track fundraising by each team. Participants can select their team during registration or be added manually.",
    "TEAM_NAME": "Team Name",
    "CREATE_TEAMS_SUCCESS": "Team created successfully",
    "NAME": "Name",
    "ORDER": "Order",
    "CONFIRM_DELETE_TEAM_TITLE": "Delete Team",
    "CONFIRM_DELETE_TEAM_DESC": "Are you sure you wish to delete this team? All participants currently assigned to this team will no longer belong to any team.",
    "DELETE_SUCCESS": "Team Deleted",
    "UPDATE_TEAM_SUCCESS": "Team updated successfully",
    "VIEW_PROFILES": "View Participants",
    "ADD_PROFILE": "Add Participants",
    "PROFILES_COUNT": "Participants Total",
    "PROFILES": {
      "FULL_NAME": "Name",
      "EMAIL": "Email",
      "PHONE": "Phone",
      "CURRENT_TEAM": "Current Team",
      "SEARCH": "Search Participant"
    },
    "EDIT": {
      "ADD_GUESTS": "Add Participants",
      "VIEW_GUESTS": "View Participants",
      "REMOVE_BUTTON_LABEL": "Remove Participants",
      "PROFILE_SELECTED": "{{count}} Participant Selected",
      "PROFILES_SELECTED": "{{count}} Participants Selected",
      "REMOVE_CONFIRM_TITLE": "Confirm Remove",
      "REMOVE_CONFIRM_BODY": "Are you sure you would like to remove {{count}} participant(s) from {{team}}?"
    }
  },
  "PRESENTER": {
    "COLOR_TOKENS": {
      "PRIMARY_COLOR": "Primary Colour",
      "BACKGROUND_COLOR": "Background Colour",
      "ACCENT_COLOR": "Accent Colour",
      "BANNER_BACKGROUND_COLOR": "Banner Background Colour",
      "WARNING_COLOR": "Warning Colour",
      "SUCCESS_COLOR": "Success Colour",
      "CUSTOM_COLOR": "Custom Colour"
    },
    "COLOR_PICKER": {
      "PICK_FROM_SCREEN": "Pick from screen"
    },
    "CUSTOM_COLOR_HEX": "Custom Colour",
    "WIDGET_COPIED_TO_CLIPBOARD": "{{widgetType}} copied to clipboard",
    "WIDGET_TYPE": {
      "COUNTDOWN": "Countdown widget",
      "IMAGE": "Image widget",
      "TEXT": "Text widget",
      "VIDEO": "Video widget",
      "TOTAL_RAISED": "Total raised widget",
      "TEAM_SCORING": "Team scoring widget",
      "NOTIFICATION": "Notification widget",
      "ITEM_TABLE": "Item table widget",
      "RAFFLE_WINNERS": "Raffle winners widget",
      "HONOUR_ROLL": "Honour roll widget",
      "THERMOMETER": "Thermometer widget",
      "RAFFLE_DRAW": "Raffle draw widget",
      "QR_CODE": "QR Code widget"
    },
    "IMAGE_WIDGET_SOURCE_DIALOG": {
      "TITLE": "Select image source",
      "SOURCES": {
        "BANNER": "Campaign banner",
        "LOGO": "Campaign logo",
        "CUSTOM": "Custom"
      },
      "SUBTITLES": {
        "BANNER": "Add the campaign banner from the branding settings",
        "LOGO": "Add the campaign logo from the branding settings"
      },
      "UPLOAD_NEW_IMAGE": "Upload new image",
      "CUSTOM_IMAGE": "Custom Image",
      "UPLOAD_IMAGE_SUBTITLE": "Upload a new image in the next step"
    },
    "IMAGE_WIDGET_PLACEHOLDER": {
      "NO_BANNER_TITLE": "This campaign has no banner image",
      "NO_BANNER_BODY": "You can add one in branding settings",
      "NO_LOGO_TITLE": "This campaign has no logo",
      "NO_LOGO_BODY": "You can add one in branding settings"
    },
    "NO_EMBED_URL": "Add a video URL",
    "NO_ITEMS": "No items yet",
    "USE_TEST_DATA": "Use test data",
    "LAUNCH": "Launch",
    "SAVE_AS_TEMPLATE": "Save as template",
    "PRESENTER_VIEW": "Presenter View",
    "COPY_LINK": "Copy Link",
    "LINK_COPIED": "Link copied",
    "NO_SLIDE_SELECTED": "No slide selected",
    "TEST_THEME": {
      "TITLE": "Test Theme",
      "DESCRIPTION": "The below colours are for test purposes, the actual colours will be taken from the selected auction"
    },
    "TEMPLATE_SAVED": "Template saved",
    "TEMPLATE_SAVE_FAILED": "Failed to save template",
    "CONFIGURE_TEMPLATE_TITLE": "Template Settings",
    "TEMPLATE_NAME": "Template name",
    "TEMPLATE_DESCRIPTION": "Template description",
    "WHO_CAN_VIEW": "Who can view",
    "VISIBILITY_PUBLIC": "All organisations",
    "VISIBILITY_CLIENT_ACCOUNT": "Select organisations",
    "ZOOM_FIT": "Fit",
    "ZOOM_FILL": "Fill",
    "GO_FULLSCREEN": "Go fullscreen",
    "EXIT_FULLSCREEN": "Exit fullscreen",
    "RAFFLE_DRAW_WIDGET": {
      "PRIZE": "Prize"
    },
    "RAFFLE_ITEM": "Raffle item: ",
    "PLEASE_SELECT_RAFFLE_ITEM": "Please select a raffle item",
    "NO": "Raffle item: ",
    "NOTIFICATION_WIDGET": {
      "AREA_TITLE": "Notification Area",
      "HINT": "This widget always stays in front of other content"
    },
    "COMMON_TOOL_OPTIONS": {
      "FONT_WEIGHT_OPTIONS": {
        "NORMAL": "Normal",
        "BOLD": "Bold",
        "THIN": "Thin",
        "LIGHT": "Light",
        "MEDIUM": "Medium",
        "SEMIBOLD": "Semibold",
        "EXTRABOLD": "Extra Bold"
      },
      "TEXT_ALIGN_OPTIONS": {
        "LEFT": "Left",
        "CENTER": "Center",
        "RIGHT": "Right",
        "JUSTIFY": "Justify"
      },
      "BORDER_STYLE_OPTIONS": {
        "SOLID": "Solid",
        "DASHED": "Dashed",
        "DOTTED": "Dotted",
        "DOUBLE": "Double",
        "NONE": "None"
      },
      "BORDER_WIDTH": "Border Width",
      "BORDER_COLOR": "Border Color",
      "BORDER_STYLE": "Border Style"
    },
    "NOTIFICATION_TOOLS": {
      "TITLE": "Notifications",
      "PREVIEW_NOTIFICATION": "Preview notification",
      "TYPE": "Type",
      "STYLING": "Styling",
      "BACKGROUND_COLOR": "Background colour",
      "TEXT_COLOR": "Text colour",
      "SECONDARY_BACKGROUND_COLOR": "Secondary background colour",
      "SECONDARY_TEXT_COLOR": "Secondary text colour",
      "SIZE": "Size",
      "FONT": "Font",
      "WEIGHT": "Weight",
      "ALIGNMENT": "Alignment",
      "NOTIFICATIONS": "Notifications",
      "SHOW_BID_NOTIFICATIONS": "Show bid notifications",
      "SHOW_PURCHASE_NOTIFICATIONS": "Show purchase notifications",
      "SHOW_DONATION_NOTIFICATIONS": "Show donation notifications",
      "SHOW_CUSTOM_NOTIFICATIONS": "Show custom notifications",
      "DISPLAY": "Display",
      "HIDE_NAME": "Hide name",
      "HIDE_PRICE": "Hide price",
      "IMAGE_CONTAINED": "Contain images",
      "NOTIF_TYPES": {
        "POPOUT_A": "Popout A",
        "POPOUT_B": "Popout B",
        "TOAST_A": "Toast A"
      }
    },
    "RAFFLE_WINNERS_WIDGET": {
      "TICKET_NUMBER": "Ticket number",
      "WINNER": "Winner",
      "PLACEHOLDER_TITLE": "Raffle Winners",
      "PLACEHOLDER_SUBTITLE": "No raffle winners yet"
    },
    "RAFFLE_DRAW_TOOLS": {
      "OPACITY": "Opacity",
      "ENABLE_CONFETTI": "Enable Confetti",
      "ENABLE_BULK_RAFFLE_DRAW": "Enable bulk raffle draw",
      "SHOW_PRIZE_NUMBERS": "Show prize numbers",
      "TITLE": "Raffle Draw",
      "PREVIEW_DRAW": "Preview draw",
      "RESET_PREVIEW": "Reset preview",
      "PREVIEW_NOTIFICATION": "Preview notification",
      "SELECT_RAFFLE_ITEM": "Select raffle item",
      "CARD_BACKGROUND_COLOR": "Card Background Color",
      "CARD_BACKGROUND_COLOUR": "Card Background Colour",
      "PRIMARY_TEXT_COLOR": "Primary text colour",
      "TEXT_COLOR": "Text colour",
      "SIZE": "Size",
      "FONT": "Font",
      "WEIGHT": "Weight",
      "ALIGNMENT": "Alignment"
    },
    "VIDEO_TOOLS": {
      "TITLE": "Video",
      "EMBED_URL": "Video URL",
      "EMBED_URL_HINT": "Add a YouTube or Vimeo video URL"
    },
    "RAFFLE_WINNERS_LIST_TOOLS": {
      "TITLE": "Raffle Winners",
      "PREVIEW_DRAW": "Preview draw",
      "USE_TEST_DATA": "Use test data",
      "RAFFLE_ITEM": "Raffle item",
      "PRIMARY_COLOUR": "Primary colour",
      "PRIMARY_TEXT_COLOUR": "Primary text colour",
      "ACCENT_COLOUR": "Accent colour",
      "BACKGROUND_COLOUR": "Background colour",
      "TEXT_COLOUR": "Text colour",
      "ROWS": "Rows",
      "COLUMNS": "Columns",
      "SIZE": "Size",
      "FONT": "Font",
      "WEIGHT": "Weight",
      "ALIGNMENT": "Alignment"
    },
    "RAFFLE_ITEM_DIALOG": {
      "TITLE": "Select raffle item",
      "DESCRIPTION": "This raffle widget is not linked to a raffle item. You can select one now (recommended), or continue without a raffle item.",
      "SELECT_LABEL": "Raffle item",
      "CONFIRM": "Confirm",
      "CONTINUE_WITHOUT": "Continue without raffle item",
      "EMPTY_STATE_MESSAGE": "No raffle items have been added to the campaign yet. You'll need to create and link a raffle item in order to use the raffle draw widgets.",
      "GO_TO_ITEMS_LIST": "Go to items list"
    },
    "HONOUR_ROLL_WIDGET": {
      "PLACEHOLDER_TITLE": "Honour Roll",
      "PLACEHOLDER_SUBTITLE": "No honour roll activities yet"
    },
    "DELETE_SLIDE": {
      "TITLE": "Delete Slide",
      "BODY": "Are you sure you would like to delete this slide? This action is irreversible",
      "CONFIRM": "Delete",
      "CANCEL": "Cancel"
    },
    "RENAME_SLIDE_DIALOG": {
      "TITLE": "Rename Slide",
      "LABEL": "Slide name"
    },
    "DELETE_SLIDE_SUCCESS": "Slide deleted",
    "BACKGROUND_COLOR": "Background Colour",
    "BACKGROUND_IMAGE_COVER": "Image cover",
    "FONT_FAMILY": "Font",
    "FONT_COLOR": "Text Colour",
    "FONT_OVERRIDE_DIALOG": {
      "TITLE": "Override Widget Font Settings",
      "BODY": "This will override the font settings for all widgets on this slide. Are you sure you want to continue?",
      "CONFIRM": "Override",
      "CANCEL": "Cancel"
    },
    "SAVING": "Saving",
    "SAVED": "Saved",
    "ZOOM": "Zoom",
    "ASPECT_RATIO": "Aspect Ratio",
    "FIT": "Fit",
    "ELEMENTS": {
      "TEMPLATES": "Templates",
      "TEMPLATES_DESCRIPTION": "Select a predefined template for your projector",
      "TEXT": "Text",
      "TEXT_DESCRIPTION": "Add text elements",
      "SMART_TEXT": "Campaign Url",
      "SMART_TEXT_DESCRIPTION": "Display the campaign url",
      "VIDEO": "Video",
      "VIDEO_DESCRIPTION": "Add an embedded video",
      "IMAGE": "Image",
      "IMAGE_DESCRIPTION": "Upload a new image or add the campaign banner / logo",
      "ITEM_TABLE": "Item Table",
      "ITEM_TABLE_DESCRIPTION": "Display a table of items",
      "TOTAL_RAISED": "Total Raised",
      "TOTAL_RAISED_DESCRIPTION": "Show the current fundraising total",
      "NOTIFICATION": "Notification",
      "NOTIFICATION_DESCRIPTION": "Display pop-up notifications for new bids and purchases",
      "RAFFLE_DRAW": "Raffle Draw",
      "RAFFLE_DRAW_DESCRIPTION": "Display a spinning raffle draw",
      "RAFFLE_WINNERS": "Raffle Winners",
      "RAFFLE_WINNERS_DESCRIPTION": "Display raffle winners and results",
      "THERMOMETER": "Thermometer",
      "THERMOMETER_DESCRIPTION": "Visual fundraising progress indicator",
      "COUNTDOWN_TIMER": "Countdown Timer",
      "COUNTDOWN_TIMER_DESCRIPTION": "Add countdown timer",
      "HONOUR_ROLL": "Honour Roll",
      "HONOUR_ROLL_DESCRIPTION": "Recognize donors and supporters",
      "TEAM_SCORING": "Team Scoring",
      "TEAM_SCORING_DESCRIPTION": "Display team scores and total raised amounts",
      "QR_CODE": "QR Code",
      "QR_CODE_DESCRIPTION": "Display a QR code for the campaign URL",
      "CUSTOM_CSS": "Custom CSS",
      "CUSTOM_CSS_DESCRIPTION": "Add custom CSS to the projector"
    },
    "THERMOMETER_TOOLS": {
      "TITLE": "Thermometer",
      "FUNDRAISING_TARGET": "Fundraising target",
      "TRACK_PLEDGES_ONLY": "Track pledges only",
      "BASE_TOTAL_RAISED_ENABLED": "Include base total raised",
      "CUSTOM_IMAGE": "Custom image",
      "THERMOMETER_BACKGROUND_COLOR": "Thermometer background color",
      "THERMOMETER_BORDER_COLOR": "Thermometer border color",
      "THERMOMETER_COLOR": "Thermometer color",
      "SIZE": "Size",
      "FONT": "Font",
      "WEIGHT": "Weight",
      "ALIGNMENT": "Alignment",
      "TEXT_COLOR": "Text Color"
    },
    "QR_CODE_TOOLS": {
      "TITLE": "QR Code",
      "URL": "URL",
      "HIDE_URL": "Hide URL",
      "STYLING": "Styling",
      "BACKGROUND_COLOR": "Background colour",
      "TEXT_COLOR": "Text colour",
      "FONT": "Font",
      "FONT_SIZE": "Font size"
    },
    "TEAM_SCORING_TOOLS": {
      "TITLE": "Team Scoring",
      "COLUMNS": "Columns",
      "ROWS": "Rows",
      "PAGE_SHOW_DURATION": "Page Show Duration (seconds)",
      "PRIMARY_COLOR": "Primary Color",
      "ACCENT_COLOR": "Accent Color",
      "BACKGROUND_COLOR": "Background Color",
      "TEXT_COLOR": "Text Color",
      "OPACITY": "Opacity",
      "SIZE": "Size",
      "FONT": "Font",
      "WEIGHT": "Weight",
      "ALIGNMENT": "Alignment",
      "BORDER_WIDTH": "Border Width",
      "BORDER_COLOR": "Border Color",
      "BORDER_STYLE": "Border Style",
      "CARD_TYPE": "Card Type",
      "CARD_TYPE_STANDARD_TABLE": "Standard Table",
      "CARD_TYPE_COMPACT_TABLE": "Compact Table",
      "TRANSITION": "Transition",
      "TRANSITION_FADE_IN": "Fade In",
      "TRANSITION_SCROLL_TOP": "Scroll Top",
      "BORDER_STYLE_SOLID": "Solid",
      "BORDER_STYLE_DASHED": "Dashed",
      "BORDER_STYLE_DOTTED": "Dotted",
      "BORDER_STYLE_NONE": "None",
      "FILTER_TEAMS": {
        "BUTTON": "Filter Teams",
        "TITLE": "Filter Teams",
        "HINT": "Select the teams you want to show in the widget. Unselected teams will be hidden."
      },
      "NO_TEAMS": "No teams yet",
      "TOTAL_RAISED": "Total Raised: {{score}}"
    },
    "ADVANCED_OPTIONS": "Advanced Options",
    "SUBTITLE": "Edit Projector",
    "BACK": "Edit Campaign",
    "TEMPLATES": "Templates",
    "BACKGROUND": "Background",
    "TEXT": "Text",
    "IMAGE": "Image",
    "ITEM_TABLE": "Item Table",
    "TOTAL_RAISED": "Total Raised",
    "NOTIFICATION": "Notification",
    "RAFFLE_DRAW": "Raffle Draw",
    "RAFFLE_WINNERS": "Raffle Winners",
    "THERMOMETER": "Thermometer",
    "COUNTDOWN_TIMER": "Countdown Timer",
    "HONOR_ROLL": "Honor Roll",
    "TEAM_SCORING": "Team Scoring",
    "QR_CODE": "QR Code",
    "CUSTOM_CSS": "Custom CSS",
    "CUSTOM_CSS_ADVANCED": "Custom CSS (Advanced)",
    "ADD_ELEMENTS": "Add Elements",
    "MEDIA": "Media",
    "RAFFLE": "Raffle",
    "LAYERS": "Layers",
    "BLANK_TEMPLATE": "Blank Template",
    "BROWSE_TEMPLATES": "Browse Templates",
    "CUSTOM_STYLES": "Custom Styles",
    "THEME_EDITOR": "Theme Editor",
    "CSS_EDITOR": "CSS Editor",
    "SCREEN_SIZE": "Screen Size",
    "PREVIEW": "Preview",
    "APPLY_TEMPLATE": {
      "STEP_SELECT_TEMPLATE": "Select template",
      "STEP_SELECT_TARGET": "Select slide",
      "CREATE_NEW_SLIDE": "Create new slide",
      "SELECT_EXISTING_SLIDE": "Select existing slide"
    },
    "TEMPLATE": {
      "SELECT_TITLE": "Choose a Template",
      "SELECT_SUBTITLE": "Select a template to get started with the projector",
      "RAFFLE": {
        "NAME": "Raffle",
        "DESCRIPTION": "Perfect for raffle draws and winner announcements"
      },
      "LIVE_AUCTION": {
        "NAME": "Live Auction",
        "DESCRIPTION": "Ideal for live auction presentations and bidding displays"
      },
      "SILENT_AUCTION": {
        "NAME": "Silent Auction",
        "DESCRIPTION": "Great for silent auction item showcases and updates"
      },
      "TOTAL_RAISED": {
        "NAME": "Total Raised",
        "DESCRIPTION": "Display the total amount raised during the event"
      },
      "TOTAL_RAISED_WITH_TARGET": {
        "NAME": "Total Raised with Target",
        "DESCRIPTION": "Show total raised with progress towards a fundraising goal"
      },
      "SILENT_AUCTION_PARTICIPATION": {
        "NAME": "Silent Auction Participation",
        "DESCRIPTION": "Display percentage of guests participating in silent auction"
      },
      "PLEDGE": {
        "NAME": "Pledge",
        "DESCRIPTION": "Perfect for pledge drives and commitment displays"
      },
      "GUEST_PARTICIPATION": {
        "NAME": "Guest Participation",
        "DESCRIPTION": "Show percentage of guests who have made contributions"
      },
      "BLANK": {
        "NAME": "Blank Template",
        "DESCRIPTION": "Start from scratch with a clean canvas"
      }
    },
    "TOOLBAR": {
      "FIT_TO_SCREEN": "Fit to Screen",
      "RESET_ZOOM": "Reset Zoom"
    },
    "SLIDES": {
      "MORE_OPTIONS": "More options",
      "DUPLICATE": "Duplicate",
      "RENAME": "Rename Slide",
      "ADD_SLIDE": "Add slide",
      "ADD_SLIDE_TOOLTIP": "Add new slide"
    },
    "LAYOUT": {
      "TITLE": "Layout",
      "ALIGN_LEFT": "Align Left",
      "ALIGN_HORIZONTAL_CENTER": "Align Horizontal Center",
      "ALIGN_RIGHT": "Align Right",
      "ALIGN_TOP": "Align Top",
      "ALIGN_VERTICAL_CENTER": "Align Vertical Center",
      "ALIGN_BOTTOM": "Align Bottom",
      "X": "X",
      "Y": "Y",
      "UNIT": "Unit",
      "WIDTH": "Width",
      "HEIGHT": "Height"
    },
    "UNDO": "Undo",
    "REDO": "Redo",
    "COPY": "Copy",
    "PASTE": "Paste",
    "DELETE": "Delete",
    "ITEM_TABLE_TOOLS": {
      "TITLE": "Item Table",
      "COLUMNS": "Columns",
      "ROWS": "Rows",
      "SLIDE_INTERVAL": "Slide Interval",
      "SIZE": "Size",
      "FONT": "Font",
      "WEIGHT": "Weight",
      "ALIGNMENT": "Alignment",
      "CARD_TYPE": "Card Type",
      "TRANSITION": "Transition",
      "IMAGE_CONTAINED": "Contain Images",
      "TABLE_PRIMARY_COLOR": "Primary Colour",
      "TABLE_ACCENT_COLOR": "Accent Colour",
      "TABLE_BACKGROUND_COLOR": "Background Colour",
      "TEXT_COLOR": "Text Colour",
      "FILTER_ITEMS": {
        "BUTTON": "Filter items",
        "TITLE": "Filter items",
        "HINT": "Uncheck items to hide them from this widget",
        "CAMPAIGN_VISIBILITY": "Campaign Visibility"
      },
      "EXCLUDED_ITEMS": {
        "COUNT": "{{count}} items excluded",
        "COUNT_SINGULAR": "{{count}} item excluded",
        "TITLE": "Excluded items",
        "EMPTY": "No items excluded"
      },
      "PRESETS": {
        "LIST": "List",
        "GRID": "Grid"
      },
      "CARD_TYPES": {
        "STANDARD_TABLE": "Standard Table",
        "COMPACT_TABLE": "Compact Table",
        "TALL_CARD": "Tall Card"
      },
      "TRANSITIONS": {
        "FADE_IN": "Fade In",
        "SCROLL_UP": "Scroll Up",
        "SCROLL_DOWN": "Scroll Down",
        "SCROLL_LEFT": "Scroll Left",
        "SCROLL_RIGHT": "Scroll Right"
      }
    },
    "ITEM_TABLE_CARD_COMPACT": {
      "STARTING_BID": "Starting bid",
      "TICKET_PRICE": "Ticket price",
      "TICKETS_REMAINING": "Tickets remaining",
      "UNIT_PRICE": "Unit price",
      "REMAINING": "Remaining",
      "RAISED": "Raised",
      "MIN_DONATION": "Min donation"
    },
    "TEXT_TOOLS": {
      "LABEL": "Label",
      "TITLE": "Text",
      "TEXT": "Text",
      "FONT": "Font",
      "SIZE": "Size",
      "WEIGHT": "Weight",
      "STYLE": "Style",
      "DECORATION": "Decoration",
      "ALIGNMENT": "Alignment",
      "LINE_HEIGHT": "Line Height",
      "LETTER_SPACING": "Letter Spacing",
      "COLOR": "Color",
      "FONT_STYLES": {
        "NORMAL": "Normal",
        "ITALIC": "Italic",
        "OBLIQUE": "Oblique"
      },
      "TEXT_DECORATIONS": {
        "NONE": "None",
        "UNDERLINE": "Underline",
        "OVERLINE": "Overline",
        "LINE_THROUGH": "Line Through"
      }
    },
    "TOTAL_RAISED_TOOLS": {
      "TITLE": "Total Raised",
      "LABEL": "Label",
      "INCLUDE_TOTALS": "Include totals",
      "TRACK_BIDS": "Track bids",
      "TRACK_DONATIONS": "Track donations",
      "TRACK_PURCHASES": "Track purchases",
      "TRACK_RAFFLES": "Track raffles",
      "TRACK_TICKET_SALES": "Track ticket sales",
      "BASE_TOTAL_RAISED_ENABLED": "Include base total raised",
      "INCLUDE_BIDS_TOTAL": "Include bids total",
      "INCLUDE_DONATION_TOTAL": "Include donation total",
      "INCLUDE_BUY_IT_NOW_TOTAL": "Include buy it now total",
      "INCLUDE_RAFFLE_TOTAL": "Include raffle total",
      "INCLUDE_TICKET_TOTAL": "Include ticket total",
      "INCLUDE_BASE_TOTAL_RAISED": "Include base total raised",
      "STYLING": "Styling",
      "BACKGROUND_COLOR": "Background Color",
      "TEXT_COLOR": "Text Color",
      "BORDER_WIDTH": "Border width",
      "BORDER_COLOR": "Border color",
      "BORDER_STYLE": "Border style",
      "SIZE": "Size",
      "FONT": "Font",
      "WEIGHT": "Weight",
      "ALIGNMENT": "Alignment",
      "BORDER_STYLES": {
        "SOLID": "Solid",
        "DASHED": "Dashed",
        "DOTTED": "Dotted",
        "DOUBLE": "Double"
      }
    },
    "COUNTDOWN_TOOLS": {
      "CUSTOM_TIME": "Custom",
      "AUCTION_CLOSE": "Auction Close",
      "AUCTION_CLOSE_DISABLED_TOOLTIP": "Schedule the auction close date & time in Auction Controls to use this option",
      "TITLE": "Countdown Timer",
      "END_DATE": "End Date",
      "END_TIME": "End Time",
      "AUCTION_SCHEDULED_CLOSE_MESSAGE": "The auction is scheduled to close at {{closing_time}}",
      "USE_AUCTION_END_TIME": "Use Auction End Time",
      "TIMEOUT_TEXT": "Countdown finished message",
      "PLUS_OVERTIME_LABEL": "Plus overtime label",
      "STYLING": "Styling",
      "BACKGROUND_COLOR": "Background Color",
      "TEXT_COLOR": "Text Color",
      "FONT": "Font",
      "WEIGHT": "Weight",
      "SIZE": "Size",
      "ALIGNMENT": "Alignment",
      "LETTER_SPACING": "Letter Spacing",
      "BORDER_WIDTH": "Border Width",
      "BORDER_COLOR": "Border Color",
      "BORDER_STYLE": "Border Style",
      "BORDER_STYLES": {
        "SOLID": "Solid",
        "DASHED": "Dashed",
        "DOTTED": "Dotted",
        "DOUBLE": "Double"
      }
    },
    "COUNTDOWN_WIDGET": {
      "PLUS_OVERTIME": "+ overtime"
    },
    "HONOUR_ROLL_TOOLS": {
      "TITLE": "Honour Roll",
      "ADVANCED_OPTIONS": "Advanced Options",
      "LATEST_ACTIVITY_QUANTITY": "Latest Activity Quantity",
      "PARTICIPANTS_TRANSITION": "Participants Transition",
      "NUMBER_ACTIVITIES_VISIBLE": "Number Activities Visible",
      "PAGE_SHOW_DURATION": "Page Show Duration",
      "PAGE_SHOW_DURATION_MAX_ERROR": "cannot exceed 60 seconds",
      "SECONDS": "seconds",
      "CARD_COLOR": "Card Color",
      "PRIMARY_COLOR": "Primary Color",
      "BACKGROUND_COLOR": "Background Color",
      "OPACITY": "Opacity",
      "BORDER_WIDTH": "Border Width",
      "BORDER_COLOR": "Border Color",
      "BORDER_STYLE": "Border Style",
      "SIZE": "Size",
      "FONT": "Font",
      "WEIGHT": "Weight",
      "ALIGNMENT": "Alignment",
      "TEXT_COLOR": "Text Color",
      "FONT_SIZE_MAX_ERROR": "cannot exceed 20",
      "SHOW_ITEM_CODE": "Show Item Code",
      "SHOW_ITEM_NAME": "Show Item Name",
      "PARTICIPANTS_TRANSITION_OPTIONS": {
        "SCROLL_RIGHT": "Scroll Right",
        "SCROLL_LEFT": "Scroll Left",
        "SCROLL_UP": "Scroll Up",
        "SCROLL_DOWN": "Scroll Down",
        "FADE": "Fade"
      },
      "BORDER_STYLES": {
        "SOLID": "Solid",
        "DASHED": "Dashed",
        "DOTTED": "Dotted",
        "DOUBLE": "Double"
      }
    }
  },
  "UNKNOWN_ADDRESS": "Unknown address, manually add or edit to proceed",
  "VALID_ADDRESS": "Valid address"
}
